var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var _e;
/**
* @vue/runtime-core v3.4.26
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
import { pauseTracking, resetTracking, isRef, toRaw, shallowReadonly, isShallow, isReactive, ReactiveEffect, getCurrentScope, ref, track, reactive, shallowReactive, trigger, isProxy, proxyRefs, markRaw, EffectScope, computed as computed$1, customRef, isReadonly } from '@vue/reactivity';
export { EffectScope, ReactiveEffect, TrackOpTypes, TriggerOpTypes, customRef, effect, effectScope, getCurrentScope, isProxy, isReactive, isReadonly, isRef, isShallow, markRaw, onScopeDispose, proxyRefs, reactive, readonly, ref, shallowReactive, shallowReadonly, shallowRef, stop, toRaw, toRef, toRefs, toValue, triggerRef, unref } from '@vue/reactivity';
import { isString, isFunction, isPromise, isArray, NOOP, getGlobalThis, extend, EMPTY_OBJ, toHandlerKey, looseToNumber, hyphenate, camelize, isObject, isOn, hasOwn, isModelListener, capitalize, toNumber, hasChanged, remove, isSet, isMap, isPlainObject, isBuiltInDirective, invokeArrayFns, isRegExp, isGloballyAllowed, NO, isReservedProp, EMPTY_ARR, toRawType, makeMap, def, normalizeClass, stringifyStyle, normalizeStyle, isKnownSvgAttr, isBooleanAttr, isKnownHtmlAttr, includeBooleanAttr, isRenderableAttrValue } from '@vue/shared';
export { camelize, capitalize, normalizeClass, normalizeProps, normalizeStyle, toDisplayString, toHandlerKey } from '@vue/shared';
var stack = [];
function pushWarningContext(vnode) {
    stack.push(vnode);
}
function popWarningContext() {
    stack.pop();
}
function warn$1(msg) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    pauseTracking();
    var instance = stack.length ? stack[stack.length - 1].component : null;
    var appWarnHandler = instance && instance.appContext.config.warnHandler;
    var trace = getComponentTrace();
    if (appWarnHandler) {
        callWithErrorHandling(appWarnHandler, instance, 11, [
            msg + args.map(function (a) {
                var _a, _b;
                return (_b = (_a = a.toString) == null ? void 0 : _a.call(a)) != null ? _b : JSON.stringify(a);
            }).join(""),
            instance && instance.proxy,
            trace.map(function (_e) {
                var vnode = _e.vnode;
                return "at <".concat(formatComponentName(instance, vnode.type), ">");
            }).join("\n"),
            trace
        ]);
    }
    else {
        var warnArgs = __spreadArray(["[Vue warn]: ".concat(msg)], __read(args), false);
        if (trace.length && // avoid spamming console during tests
            true) {
            warnArgs.push.apply(warnArgs, __spreadArray(["\n"], __read(formatTrace(trace)), false));
        }
        console.warn.apply(console, __spreadArray([], __read(warnArgs), false));
    }
    resetTracking();
}
function getComponentTrace() {
    var currentVNode = stack[stack.length - 1];
    if (!currentVNode) {
        return [];
    }
    var normalizedStack = [];
    while (currentVNode) {
        var last = normalizedStack[0];
        if (last && last.vnode === currentVNode) {
            last.recurseCount++;
        }
        else {
            normalizedStack.push({
                vnode: currentVNode,
                recurseCount: 0
            });
        }
        var parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
function formatTrace(trace) {
    var logs = [];
    trace.forEach(function (entry, i) {
        logs.push.apply(logs, __spreadArray(__spreadArray([], __read(i === 0 ? [] : ["\n"]), false), __read(formatTraceEntry(entry)), false));
    });
    return logs;
}
function formatTraceEntry(_e) {
    var vnode = _e.vnode, recurseCount = _e.recurseCount;
    var postfix = recurseCount > 0 ? "... (".concat(recurseCount, " recursive calls)") : "";
    var isRoot = vnode.component ? vnode.component.parent == null : false;
    var open = " at <".concat(formatComponentName(vnode.component, vnode.type, isRoot));
    var close = ">" + postfix;
    return vnode.props ? __spreadArray(__spreadArray([open], __read(formatProps(vnode.props)), false), [close], false) : [open + close];
}
function formatProps(props) {
    var res = [];
    var keys = Object.keys(props);
    keys.slice(0, 3).forEach(function (key) {
        res.push.apply(res, __spreadArray([], __read(formatProp(key, props[key])), false));
    });
    if (keys.length > 3) {
        res.push(" ...");
    }
    return res;
}
function formatProp(key, value, raw) {
    if (isString(value)) {
        value = JSON.stringify(value);
        return raw ? value : ["".concat(key, "=").concat(value)];
    }
    else if (typeof value === "number" || typeof value === "boolean" || value == null) {
        return raw ? value : ["".concat(key, "=").concat(value)];
    }
    else if (isRef(value)) {
        value = formatProp(key, toRaw(value.value), true);
        return raw ? value : ["".concat(key, "=Ref<"), value, ">"];
    }
    else if (isFunction(value)) {
        return ["".concat(key, "=fn").concat(value.name ? "<".concat(value.name, ">") : "")];
    }
    else {
        value = toRaw(value);
        return raw ? value : ["".concat(key, "="), value];
    }
}
function assertNumber(val, type) {
    if (!!!(process.env.NODE_ENV !== "production"))
        return;
    if (val === void 0) {
        return;
    }
    else if (typeof val !== "number") {
        warn$1("".concat(type, " is not a valid number - got ").concat(JSON.stringify(val), "."));
    }
    else if (isNaN(val)) {
        warn$1("".concat(type, " is NaN - the duration expression might be incorrect."));
    }
}
var ErrorCodes = {
    "SETUP_FUNCTION": 0,
    "0": "SETUP_FUNCTION",
    "RENDER_FUNCTION": 1,
    "1": "RENDER_FUNCTION",
    "WATCH_GETTER": 2,
    "2": "WATCH_GETTER",
    "WATCH_CALLBACK": 3,
    "3": "WATCH_CALLBACK",
    "WATCH_CLEANUP": 4,
    "4": "WATCH_CLEANUP",
    "NATIVE_EVENT_HANDLER": 5,
    "5": "NATIVE_EVENT_HANDLER",
    "COMPONENT_EVENT_HANDLER": 6,
    "6": "COMPONENT_EVENT_HANDLER",
    "VNODE_HOOK": 7,
    "7": "VNODE_HOOK",
    "DIRECTIVE_HOOK": 8,
    "8": "DIRECTIVE_HOOK",
    "TRANSITION_HOOK": 9,
    "9": "TRANSITION_HOOK",
    "APP_ERROR_HANDLER": 10,
    "10": "APP_ERROR_HANDLER",
    "APP_WARN_HANDLER": 11,
    "11": "APP_WARN_HANDLER",
    "FUNCTION_REF": 12,
    "12": "FUNCTION_REF",
    "ASYNC_COMPONENT_LOADER": 13,
    "13": "ASYNC_COMPONENT_LOADER",
    "SCHEDULER": 14,
    "14": "SCHEDULER"
};
var ErrorTypeStrings$1 = (_e = {},
    _e["sp"] = "serverPrefetch hook",
    _e["bc"] = "beforeCreate hook",
    _e["c"] = "created hook",
    _e["bm"] = "beforeMount hook",
    _e["m"] = "mounted hook",
    _e["bu"] = "beforeUpdate hook",
    _e["u"] = "updated",
    _e["bum"] = "beforeUnmount hook",
    _e["um"] = "unmounted hook",
    _e["a"] = "activated hook",
    _e["da"] = "deactivated hook",
    _e["ec"] = "errorCaptured hook",
    _e["rtc"] = "renderTracked hook",
    _e["rtg"] = "renderTriggered hook",
    _e[0] = "setup function",
    _e[1] = "render function",
    _e[2] = "watcher getter",
    _e[3] = "watcher callback",
    _e[4] = "watcher cleanup function",
    _e[5] = "native event handler",
    _e[6] = "component event handler",
    _e[7] = "vnode hook",
    _e[8] = "directive hook",
    _e[9] = "transition hook",
    _e[10] = "app errorHandler",
    _e[11] = "app warnHandler",
    _e[12] = "ref function",
    _e[13] = "async component loader",
    _e[14] = "scheduler flush. This is likely a Vue internals bug. Please open an issue at https://github.com/vuejs/core .",
    _e);
function callWithErrorHandling(fn, instance, type, args) {
    try {
        return args ? fn.apply(void 0, __spreadArray([], __read(args), false)) : fn();
    }
    catch (err) {
        handleError(err, instance, type);
    }
}
function callWithAsyncErrorHandling(fn, instance, type, args) {
    if (isFunction(fn)) {
        var res = callWithErrorHandling(fn, instance, type, args);
        if (res && isPromise(res)) {
            res.catch(function (err) {
                handleError(err, instance, type);
            });
        }
        return res;
    }
    if (isArray(fn)) {
        var values = [];
        for (var i = 0; i < fn.length; i++) {
            values.push(callWithAsyncErrorHandling(fn[i], instance, type, args));
        }
        return values;
    }
    else if (!!(process.env.NODE_ENV !== "production")) {
        warn$1("Invalid value type passed to callWithAsyncErrorHandling(): ".concat(typeof fn));
    }
}
function handleError(err, instance, type, throwInDev) {
    if (throwInDev === void 0) { throwInDev = true; }
    var contextVNode = instance ? instance.vnode : null;
    if (instance) {
        var cur = instance.parent;
        var exposedInstance = instance.proxy;
        var errorInfo = !!(process.env.NODE_ENV !== "production") ? ErrorTypeStrings$1[type] : "https://vuejs.org/error-reference/#runtime-".concat(type);
        while (cur) {
            var errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) {
                for (var i = 0; i < errorCapturedHooks.length; i++) {
                    if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) {
                        return;
                    }
                }
            }
            cur = cur.parent;
        }
        var appErrorHandler = instance.appContext.config.errorHandler;
        if (appErrorHandler) {
            pauseTracking();
            callWithErrorHandling(appErrorHandler, null, 10, [err, exposedInstance, errorInfo]);
            resetTracking();
            return;
        }
    }
    logError(err, type, contextVNode, throwInDev);
}
function logError(err, type, contextVNode, throwInDev) {
    if (throwInDev === void 0) { throwInDev = true; }
    if (!!(process.env.NODE_ENV !== "production")) {
        var info = ErrorTypeStrings$1[type];
        if (contextVNode) {
            pushWarningContext(contextVNode);
        }
        warn$1("Unhandled error".concat(info ? " during execution of ".concat(info) : ""));
        if (contextVNode) {
            popWarningContext();
        }
        if (throwInDev) {
            throw err;
        }
        else {
            console.error(err);
        }
    }
    else {
        console.error(err);
    }
}
var isFlushing = false;
var isFlushPending = false;
var queue = [];
var flushIndex = 0;
var pendingPostFlushCbs = [];
var activePostFlushCbs = null;
var postFlushIndex = 0;
var resolvedPromise = /* @__PURE__ */ Promise.resolve();
var currentFlushPromise = null;
var RECURSION_LIMIT = 100;
function nextTick(fn) {
    var p = currentFlushPromise || resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
function findInsertionIndex(id) {
    var start = flushIndex + 1;
    var end = queue.length;
    while (start < end) {
        var middle = start + end >>> 1;
        var middleJob = queue[middle];
        var middleJobId = getId(middleJob);
        if (middleJobId < id || middleJobId === id && middleJob.pre) {
            start = middle + 1;
        }
        else {
            end = middle;
        }
    }
    return start;
}
function queueJob(job) {
    if (!queue.length || !queue.includes(job, isFlushing && job.allowRecurse ? flushIndex + 1 : flushIndex)) {
        if (job.id == null) {
            queue.push(job);
        }
        else {
            queue.splice(findInsertionIndex(job.id), 0, job);
        }
        queueFlush();
    }
}
function queueFlush() {
    if (!isFlushing && !isFlushPending) {
        isFlushPending = true;
        currentFlushPromise = resolvedPromise.then(flushJobs);
    }
}
function invalidateJob(job) {
    var i = queue.indexOf(job);
    if (i > flushIndex) {
        queue.splice(i, 1);
    }
}
function queuePostFlushCb(cb) {
    if (!isArray(cb)) {
        if (!activePostFlushCbs || !activePostFlushCbs.includes(cb, cb.allowRecurse ? postFlushIndex + 1 : postFlushIndex)) {
            pendingPostFlushCbs.push(cb);
        }
    }
    else {
        pendingPostFlushCbs.push.apply(pendingPostFlushCbs, __spreadArray([], __read(cb), false));
    }
    queueFlush();
}
function flushPreFlushCbs(instance, seen, i) {
    if (i === void 0) { i = isFlushing ? flushIndex + 1 : 0; }
    if (!!(process.env.NODE_ENV !== "production")) {
        seen = seen || /* @__PURE__ */ new Map();
    }
    for (; i < queue.length; i++) {
        var cb = queue[i];
        if (cb && cb.pre) {
            if (instance && cb.id !== instance.uid) {
                continue;
            }
            if (!!(process.env.NODE_ENV !== "production") && checkRecursiveUpdates(seen, cb)) {
                continue;
            }
            queue.splice(i, 1);
            i--;
            cb();
        }
    }
}
function flushPostFlushCbs(seen) {
    if (pendingPostFlushCbs.length) {
        var deduped = __spreadArray([], __read(new Set(pendingPostFlushCbs)), false).sort(function (a, b) { return getId(a) - getId(b); });
        pendingPostFlushCbs.length = 0;
        if (activePostFlushCbs) {
            activePostFlushCbs.push.apply(activePostFlushCbs, __spreadArray([], __read(deduped), false));
            return;
        }
        activePostFlushCbs = deduped;
        if (!!(process.env.NODE_ENV !== "production")) {
            seen = seen || /* @__PURE__ */ new Map();
        }
        for (postFlushIndex = 0; postFlushIndex < activePostFlushCbs.length; postFlushIndex++) {
            if (!!(process.env.NODE_ENV !== "production") && checkRecursiveUpdates(seen, activePostFlushCbs[postFlushIndex])) {
                continue;
            }
            activePostFlushCbs[postFlushIndex]();
        }
        activePostFlushCbs = null;
        postFlushIndex = 0;
    }
}
var getId = function (job) { return job.id == null ? Infinity : job.id; };
var comparator = function (a, b) {
    var diff = getId(a) - getId(b);
    if (diff === 0) {
        if (a.pre && !b.pre)
            return -1;
        if (b.pre && !a.pre)
            return 1;
    }
    return diff;
};
function flushJobs(seen) {
    isFlushPending = false;
    isFlushing = true;
    if (!!(process.env.NODE_ENV !== "production")) {
        seen = seen || /* @__PURE__ */ new Map();
    }
    queue.sort(comparator);
    var check = !!(process.env.NODE_ENV !== "production") ? function (job) { return checkRecursiveUpdates(seen, job); } : NOOP;
    try {
        for (flushIndex = 0; flushIndex < queue.length; flushIndex++) {
            var job = queue[flushIndex];
            if (job && job.active !== false) {
                if (!!(process.env.NODE_ENV !== "production") && check(job)) {
                    continue;
                }
                callWithErrorHandling(job, null, 14);
            }
        }
    }
    finally {
        flushIndex = 0;
        queue.length = 0;
        flushPostFlushCbs(seen);
        isFlushing = false;
        currentFlushPromise = null;
        if (queue.length || pendingPostFlushCbs.length) {
            flushJobs(seen);
        }
    }
}
function checkRecursiveUpdates(seen, fn) {
    if (!seen.has(fn)) {
        seen.set(fn, 1);
    }
    else {
        var count = seen.get(fn);
        if (count > RECURSION_LIMIT) {
            var instance = fn.ownerInstance;
            var componentName = instance && getComponentName(instance.type);
            handleError("Maximum recursive updates exceeded".concat(componentName ? " in component <".concat(componentName, ">") : "", ". This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function."), null, 10);
            return true;
        }
        else {
            seen.set(fn, count + 1);
        }
    }
}
var isHmrUpdating = false;
var hmrDirtyComponents = /* @__PURE__ */ new Set();
if (!!(process.env.NODE_ENV !== "production")) {
    getGlobalThis().__VUE_HMR_RUNTIME__ = {
        createRecord: tryWrap(createRecord),
        rerender: tryWrap(rerender),
        reload: tryWrap(reload)
    };
}
var map = /* @__PURE__ */ new Map();
function registerHMR(instance) {
    var id = instance.type.__hmrId;
    var record = map.get(id);
    if (!record) {
        createRecord(id, instance.type);
        record = map.get(id);
    }
    record.instances.add(instance);
}
function unregisterHMR(instance) {
    map.get(instance.type.__hmrId).instances.delete(instance);
}
function createRecord(id, initialDef) {
    if (map.has(id)) {
        return false;
    }
    map.set(id, {
        initialDef: normalizeClassComponent(initialDef),
        instances: /* @__PURE__ */ new Set()
    });
    return true;
}
function normalizeClassComponent(component) {
    return isClassComponent(component) ? component.__vccOpts : component;
}
function rerender(id, newRender) {
    var record = map.get(id);
    if (!record) {
        return;
    }
    record.initialDef.render = newRender;
    __spreadArray([], __read(record.instances), false).forEach(function (instance) {
        if (newRender) {
            instance.render = newRender;
            normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        isHmrUpdating = true;
        instance.effect.dirty = true;
        instance.update();
        isHmrUpdating = false;
    });
}
function reload(id, newComp) {
    var e_1, _e;
    var record = map.get(id);
    if (!record)
        return;
    newComp = normalizeClassComponent(newComp);
    updateComponentDef(record.initialDef, newComp);
    var instances = __spreadArray([], __read(record.instances), false);
    try {
        for (var instances_1 = __values(instances), instances_1_1 = instances_1.next(); !instances_1_1.done; instances_1_1 = instances_1.next()) {
            var instance = instances_1_1.value;
            var oldComp = normalizeClassComponent(instance.type);
            if (!hmrDirtyComponents.has(oldComp)) {
                if (oldComp !== record.initialDef) {
                    updateComponentDef(oldComp, newComp);
                }
                hmrDirtyComponents.add(oldComp);
            }
            instance.appContext.propsCache.delete(instance.type);
            instance.appContext.emitsCache.delete(instance.type);
            instance.appContext.optionsCache.delete(instance.type);
            if (instance.ceReload) {
                hmrDirtyComponents.add(oldComp);
                instance.ceReload(newComp.styles);
                hmrDirtyComponents.delete(oldComp);
            }
            else if (instance.parent) {
                instance.parent.effect.dirty = true;
                queueJob(instance.parent.update);
            }
            else if (instance.appContext.reload) {
                instance.appContext.reload();
            }
            else if (typeof window !== "undefined") {
                window.location.reload();
            }
            else {
                console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (instances_1_1 && !instances_1_1.done && (_e = instances_1.return)) _e.call(instances_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    queuePostFlushCb(function () {
        var e_2, _e;
        try {
            for (var instances_2 = __values(instances), instances_2_1 = instances_2.next(); !instances_2_1.done; instances_2_1 = instances_2.next()) {
                var instance = instances_2_1.value;
                hmrDirtyComponents.delete(normalizeClassComponent(instance.type));
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (instances_2_1 && !instances_2_1.done && (_e = instances_2.return)) _e.call(instances_2);
            }
            finally { if (e_2) throw e_2.error; }
        }
    });
}
function updateComponentDef(oldComp, newComp) {
    extend(oldComp, newComp);
    for (var key in oldComp) {
        if (key !== "__file" && !(key in newComp)) {
            delete oldComp[key];
        }
    }
}
function tryWrap(fn) {
    return function (id, arg) {
        try {
            return fn(id, arg);
        }
        catch (e) {
            console.error(e);
            console.warn("[HMR] Something went wrong during Vue component hot-reload. Full reload required.");
        }
    };
}
var devtools$1;
var buffer = [];
var devtoolsNotInstalled = false;
function emit$1(event) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (devtools$1) {
        devtools$1.emit.apply(devtools$1, __spreadArray([event], __read(args), false));
    }
    else if (!devtoolsNotInstalled) {
        buffer.push({ event: event, args: args });
    }
}
function setDevtoolsHook$1(hook, target) {
    var _a, _b;
    devtools$1 = hook;
    if (devtools$1) {
        devtools$1.enabled = true;
        buffer.forEach(function (_e) {
            var event = _e.event, args = _e.args;
            return devtools$1.emit.apply(devtools$1, __spreadArray([event], __read(args), false));
        });
        buffer = [];
    }
    else if (
    // handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== "undefined" && // some envs mock window but not fully
        window.HTMLElement && // also exclude jsdom
        !((_b = (_a = window.navigator) == null ? void 0 : _a.userAgent) == null ? void 0 : _b.includes("jsdom"))) {
        var replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push(function (newHook) {
            setDevtoolsHook$1(newHook, target);
        });
        setTimeout(function () {
            if (!devtools$1) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                devtoolsNotInstalled = true;
                buffer = [];
            }
        }, 3e3);
    }
    else {
        devtoolsNotInstalled = true;
        buffer = [];
    }
}
function devtoolsInitApp(app, version) {
    emit$1("app:init" /* APP_INIT */, app, version, {
        Fragment: Fragment,
        Text: Text,
        Comment: Comment,
        Static: Static
    });
}
function devtoolsUnmountApp(app) {
    emit$1("app:unmount" /* APP_UNMOUNT */, app);
}
var devtoolsComponentAdded = /* @__PURE__ */ createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */);
var devtoolsComponentUpdated = /* @__PURE__ */ createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */);
var _devtoolsComponentRemoved = /* @__PURE__ */ createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */);
var devtoolsComponentRemoved = function (component) {
    if (devtools$1 && typeof devtools$1.cleanupBuffer === "function" && // remove the component if it wasn't buffered
        !devtools$1.cleanupBuffer(component)) {
        _devtoolsComponentRemoved(component);
    }
};
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function createDevtoolsComponentHook(hook) {
    return function (component) {
        emit$1(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
    };
}
var devtoolsPerfStart = /* @__PURE__ */ createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */);
var devtoolsPerfEnd = /* @__PURE__ */ createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */);
function createDevtoolsPerformanceHook(hook) {
    return function (component, type, time) {
        emit$1(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function devtoolsComponentEmit(component, event, params) {
    emit$1("component:emit" /* COMPONENT_EMIT */, component.appContext.app, component, event, params);
}
function emit(instance, event) {
    var rawArgs = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        rawArgs[_i - 2] = arguments[_i];
    }
    if (instance.isUnmounted)
        return;
    var props = instance.vnode.props || EMPTY_OBJ;
    if (!!(process.env.NODE_ENV !== "production")) {
        var emitsOptions = instance.emitsOptions, _e = __read(instance.propsOptions, 1), propsOptions = _e[0];
        if (emitsOptions) {
            if (!(event in emitsOptions) && true) {
                if (!propsOptions || !(toHandlerKey(event) in propsOptions)) {
                    warn$1("Component emitted event \"".concat(event, "\" but it is neither declared in the emits option nor as an \"").concat(toHandlerKey(event), "\" prop."));
                }
            }
            else {
                var validator = emitsOptions[event];
                if (isFunction(validator)) {
                    var isValid = validator.apply(void 0, __spreadArray([], __read(rawArgs), false));
                    if (!isValid) {
                        warn$1("Invalid event arguments: event validation failed for event \"".concat(event, "\"."));
                    }
                }
            }
        }
    }
    var args = rawArgs;
    var isModelListener = event.startsWith("update:");
    var modelArg = isModelListener && event.slice(7);
    if (modelArg && modelArg in props) {
        var modifiersKey = "".concat(modelArg === "modelValue" ? "model" : modelArg, "Modifiers");
        var _f = props[modifiersKey] || EMPTY_OBJ, number = _f.number, trim = _f.trim;
        if (trim) {
            args = rawArgs.map(function (a) { return isString(a) ? a.trim() : a; });
        }
        if (number) {
            args = rawArgs.map(looseToNumber);
        }
    }
    if (!!(process.env.NODE_ENV !== "production") || __VUE_PROD_DEVTOOLS__) {
        devtoolsComponentEmit(instance, event, args);
    }
    if (!!(process.env.NODE_ENV !== "production")) {
        var lowerCaseEvent = event.toLowerCase();
        if (lowerCaseEvent !== event && props[toHandlerKey(lowerCaseEvent)]) {
            warn$1("Event \"".concat(lowerCaseEvent, "\" is emitted in component ").concat(formatComponentName(instance, instance.type), " but the handler is registered for \"").concat(event, "\". Note that HTML attributes are case-insensitive and you cannot use v-on to listen to camelCase events when using in-DOM templates. You should probably use \"").concat(hyphenate(event), "\" instead of \"").concat(event, "\"."));
        }
    }
    var handlerName;
    var handler = props[handlerName = toHandlerKey(event)] || // also try camelCase event handler (#2249)
        props[handlerName = toHandlerKey(camelize(event))];
    if (!handler && isModelListener) {
        handler = props[handlerName = toHandlerKey(hyphenate(event))];
    }
    if (handler) {
        callWithAsyncErrorHandling(handler, instance, 6, args);
    }
    var onceHandler = props[handlerName + "Once"];
    if (onceHandler) {
        if (!instance.emitted) {
            instance.emitted = {};
        }
        else if (instance.emitted[handlerName]) {
            return;
        }
        instance.emitted[handlerName] = true;
        callWithAsyncErrorHandling(onceHandler, instance, 6, args);
    }
}
function normalizeEmitsOptions(comp, appContext, asMixin) {
    if (asMixin === void 0) { asMixin = false; }
    var cache = appContext.emitsCache;
    var cached = cache.get(comp);
    if (cached !== void 0) {
        return cached;
    }
    var raw = comp.emits;
    var normalized = {};
    var hasExtends = false;
    if (__VUE_OPTIONS_API__ && !isFunction(comp)) {
        var extendEmits = function (raw2) {
            var normalizedFromExtend = normalizeEmitsOptions(raw2, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                extend(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) {
            appContext.mixins.forEach(extendEmits);
        }
        if (comp.extends) {
            extendEmits(comp.extends);
        }
        if (comp.mixins) {
            comp.mixins.forEach(extendEmits);
        }
    }
    if (!raw && !hasExtends) {
        if (isObject(comp)) {
            cache.set(comp, null);
        }
        return null;
    }
    if (isArray(raw)) {
        raw.forEach(function (key) { return normalized[key] = null; });
    }
    else {
        extend(normalized, raw);
    }
    if (isObject(comp)) {
        cache.set(comp, normalized);
    }
    return normalized;
}
function isEmitListener(options, key) {
    if (!options || !isOn(key)) {
        return false;
    }
    key = key.slice(2).replace(/Once$/, "");
    return hasOwn(options, key[0].toLowerCase() + key.slice(1)) || hasOwn(options, hyphenate(key)) || hasOwn(options, key);
}
var currentRenderingInstance = null;
var currentScopeId = null;
function setCurrentRenderingInstance(instance) {
    var prev = currentRenderingInstance;
    currentRenderingInstance = instance;
    currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
function pushScopeId(id) {
    currentScopeId = id;
}
function popScopeId() {
    currentScopeId = null;
}
var withScopeId = function (_id) { return withCtx; };
function withCtx(fn, ctx, isNonScopedSlot) {
    if (ctx === void 0) { ctx = currentRenderingInstance; }
    if (!ctx)
        return fn;
    if (fn._n) {
        return fn;
    }
    var renderFnWithContext = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (renderFnWithContext._d) {
            setBlockTracking(-1);
        }
        var prevInstance = setCurrentRenderingInstance(ctx);
        var res;
        try {
            res = fn.apply(void 0, __spreadArray([], __read(args), false));
        }
        finally {
            setCurrentRenderingInstance(prevInstance);
            if (renderFnWithContext._d) {
                setBlockTracking(1);
            }
        }
        if (!!(process.env.NODE_ENV !== "production") || __VUE_PROD_DEVTOOLS__) {
            devtoolsComponentUpdated(ctx);
        }
        return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
var accessedAttrs = false;
function markAttrsAccessed() {
    accessedAttrs = true;
}
function renderComponentRoot(instance) {
    var _e;
    var Component = instance.type, vnode = instance.vnode, proxy = instance.proxy, withProxy = instance.withProxy, _f = __read(instance.propsOptions, 1), propsOptions = _f[0], slots = instance.slots, attrs = instance.attrs, emit = instance.emit, render = instance.render, renderCache = instance.renderCache, props = instance.props, data = instance.data, setupState = instance.setupState, ctx = instance.ctx, inheritAttrs = instance.inheritAttrs;
    var prev = setCurrentRenderingInstance(instance);
    var result;
    var fallthroughAttrs;
    if (!!(process.env.NODE_ENV !== "production")) {
        accessedAttrs = false;
    }
    try {
        if (vnode.shapeFlag & 4) {
            var proxyToUse = withProxy || proxy;
            var thisProxy = !!(process.env.NODE_ENV !== "production") && setupState.__isScriptSetup ? new Proxy(proxyToUse, {
                get: function (target, key, receiver) {
                    warn$1("Property '".concat(String(key), "' was accessed via 'this'. Avoid using 'this' in templates."));
                    return Reflect.get(target, key, receiver);
                }
            }) : proxyToUse;
            result = normalizeVNode(render.call(thisProxy, proxyToUse, renderCache, !!(process.env.NODE_ENV !== "production") ? shallowReadonly(props) : props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        }
        else {
            var render2 = Component;
            if (!!(process.env.NODE_ENV !== "production") && attrs === props) {
                markAttrsAccessed();
            }
            result = normalizeVNode(render2.length > 1 ? render2(!!(process.env.NODE_ENV !== "production") ? shallowReadonly(props) : props, !!(process.env.NODE_ENV !== "production") ? {
                get attrs() {
                    markAttrsAccessed();
                    return shallowReadonly(attrs);
                },
                slots: slots,
                emit: emit
            } : { attrs: attrs, slots: slots, emit: emit }) : render2(!!(process.env.NODE_ENV !== "production") ? shallowReadonly(props) : props, null));
            fallthroughAttrs = Component.props ? attrs : getFunctionalFallthrough(attrs);
        }
    }
    catch (err) {
        blockStack.length = 0;
        handleError(err, instance, 1);
        result = createVNode(Comment);
    }
    var root = result;
    var setRoot = void 0;
    if (!!(process.env.NODE_ENV !== "production") && result.patchFlag > 0 && result.patchFlag & 2048) {
        _e = __read(getChildRoot(result), 2), root = _e[0], setRoot = _e[1];
    }
    if (fallthroughAttrs && inheritAttrs !== false) {
        var keys = Object.keys(fallthroughAttrs);
        var shapeFlag = root.shapeFlag;
        if (keys.length) {
            if (shapeFlag & (1 | 6)) {
                if (propsOptions && keys.some(isModelListener)) {
                    fallthroughAttrs = filterModelListeners(fallthroughAttrs, propsOptions);
                }
                root = cloneVNode(root, fallthroughAttrs, false, true);
            }
            else if (!!(process.env.NODE_ENV !== "production") && !accessedAttrs && root.type !== Comment) {
                var allAttrs = Object.keys(attrs);
                var eventAttrs = [];
                var extraAttrs = [];
                for (var i = 0, l = allAttrs.length; i < l; i++) {
                    var key = allAttrs[i];
                    if (isOn(key)) {
                        if (!isModelListener(key)) {
                            eventAttrs.push(key[2].toLowerCase() + key.slice(3));
                        }
                    }
                    else {
                        extraAttrs.push(key);
                    }
                }
                if (extraAttrs.length) {
                    warn$1("Extraneous non-props attributes (".concat(extraAttrs.join(", "), ") were passed to component but could not be automatically inherited because component renders fragment or text root nodes."));
                }
                if (eventAttrs.length) {
                    warn$1("Extraneous non-emits event listeners (".concat(eventAttrs.join(", "), ") were passed to component but could not be automatically inherited because component renders fragment or text root nodes. If the listener is intended to be a component custom event listener only, declare it using the \"emits\" option."));
                }
            }
        }
    }
    if (vnode.dirs) {
        if (!!(process.env.NODE_ENV !== "production") && !isElementRoot(root)) {
            warn$1("Runtime directive used on component with non-element root node. The directives will not function as intended.");
        }
        root = cloneVNode(root, null, false, true);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) {
        if (!!(process.env.NODE_ENV !== "production") && !isElementRoot(root)) {
            warn$1("Component inside <Transition> renders non-element root node that cannot be animated.");
        }
        root.transition = vnode.transition;
    }
    if (!!(process.env.NODE_ENV !== "production") && setRoot) {
        setRoot(root);
    }
    else {
        result = root;
    }
    setCurrentRenderingInstance(prev);
    return result;
}
var getChildRoot = function (vnode) {
    var rawChildren = vnode.children;
    var dynamicChildren = vnode.dynamicChildren;
    var childRoot = filterSingleRoot(rawChildren, false);
    if (!childRoot) {
        return [vnode, void 0];
    }
    else if (!!(process.env.NODE_ENV !== "production") && childRoot.patchFlag > 0 && childRoot.patchFlag & 2048) {
        return getChildRoot(childRoot);
    }
    var index = rawChildren.indexOf(childRoot);
    var dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    var setRoot = function (updatedRoot) {
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) {
                dynamicChildren[dynamicIndex] = updatedRoot;
            }
            else if (updatedRoot.patchFlag > 0) {
                vnode.dynamicChildren = __spreadArray(__spreadArray([], __read(dynamicChildren), false), [updatedRoot], false);
            }
        }
    };
    return [normalizeVNode(childRoot), setRoot];
};
function filterSingleRoot(children, recurse) {
    if (recurse === void 0) { recurse = true; }
    var singleRoot;
    for (var i = 0; i < children.length; i++) {
        var child = children[i];
        if (isVNode(child)) {
            if (child.type !== Comment || child.children === "v-if") {
                if (singleRoot) {
                    return;
                }
                else {
                    singleRoot = child;
                    if (!!(process.env.NODE_ENV !== "production") && recurse && singleRoot.patchFlag > 0 && singleRoot.patchFlag & 2048) {
                        return filterSingleRoot(singleRoot.children);
                    }
                }
            }
        }
        else {
            return;
        }
    }
    return singleRoot;
}
var getFunctionalFallthrough = function (attrs) {
    var res;
    for (var key in attrs) {
        if (key === "class" || key === "style" || isOn(key)) {
            (res || (res = {}))[key] = attrs[key];
        }
    }
    return res;
};
var filterModelListeners = function (attrs, props) {
    var res = {};
    for (var key in attrs) {
        if (!isModelListener(key) || !(key.slice(9) in props)) {
            res[key] = attrs[key];
        }
    }
    return res;
};
var isElementRoot = function (vnode) {
    return vnode.shapeFlag & (6 | 1) || vnode.type === Comment;
};
function shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    var prevProps = prevVNode.props, prevChildren = prevVNode.children, component = prevVNode.component;
    var nextProps = nextVNode.props, nextChildren = nextVNode.children, patchFlag = nextVNode.patchFlag;
    var emits = component.emitsOptions;
    if (!!(process.env.NODE_ENV !== "production") && (prevChildren || nextChildren) && isHmrUpdating) {
        return true;
    }
    if (nextVNode.dirs || nextVNode.transition) {
        return true;
    }
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024) {
            return true;
        }
        if (patchFlag & 16) {
            if (!prevProps) {
                return !!nextProps;
            }
            return hasPropsChanged(prevProps, nextProps, emits);
        }
        else if (patchFlag & 8) {
            var dynamicProps = nextVNode.dynamicProps;
            for (var i = 0; i < dynamicProps.length; i++) {
                var key = dynamicProps[i];
                if (nextProps[key] !== prevProps[key] && !isEmitListener(emits, key)) {
                    return true;
                }
            }
        }
    }
    else {
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) {
                return true;
            }
        }
        if (prevProps === nextProps) {
            return false;
        }
        if (!prevProps) {
            return !!nextProps;
        }
        if (!nextProps) {
            return true;
        }
        return hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function hasPropsChanged(prevProps, nextProps, emitsOptions) {
    var nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) {
        return true;
    }
    for (var i = 0; i < nextKeys.length; i++) {
        var key = nextKeys[i];
        if (nextProps[key] !== prevProps[key] && !isEmitListener(emitsOptions, key)) {
            return true;
        }
    }
    return false;
}
function updateHOCHostEl(_e, el) {
    var vnode = _e.vnode, parent = _e.parent;
    while (parent) {
        var root = parent.subTree;
        if (root.suspense && root.suspense.activeBranch === vnode) {
            root.el = vnode.el;
        }
        if (root === vnode) {
            (vnode = parent.vnode).el = el;
            parent = parent.parent;
        }
        else {
            break;
        }
    }
}
var COMPONENTS = "components";
var DIRECTIVES = "directives";
function resolveComponent(name, maybeSelfReference) {
    return resolveAsset(COMPONENTS, name, true, maybeSelfReference) || name;
}
var NULL_DYNAMIC_COMPONENT = Symbol.for("v-ndc");
function resolveDynamicComponent(component) {
    if (isString(component)) {
        return resolveAsset(COMPONENTS, component, false) || component;
    }
    else {
        return component || NULL_DYNAMIC_COMPONENT;
    }
}
function resolveDirective(name) {
    return resolveAsset(DIRECTIVES, name);
}
function resolveAsset(type, name, warnMissing, maybeSelfReference) {
    if (warnMissing === void 0) { warnMissing = true; }
    if (maybeSelfReference === void 0) { maybeSelfReference = false; }
    var instance = currentRenderingInstance || currentInstance;
    if (instance) {
        var Component = instance.type;
        if (type === COMPONENTS) {
            var selfName = getComponentName(Component, false);
            if (selfName && (selfName === name || selfName === camelize(name) || selfName === capitalize(camelize(name)))) {
                return Component;
            }
        }
        var res = (
        // local registration
        // check instance[type] first which is resolved for options API
        resolve(instance[type] || Component[type], name) || // global registration
            resolve(instance.appContext[type], name));
        if (!res && maybeSelfReference) {
            return Component;
        }
        if (!!(process.env.NODE_ENV !== "production") && warnMissing && !res) {
            var extra = type === COMPONENTS ? "\nIf this is a native custom element, make sure to exclude it from component resolution via compilerOptions.isCustomElement." : "";
            warn$1("Failed to resolve ".concat(type.slice(0, -1), ": ").concat(name).concat(extra));
        }
        return res;
    }
    else if (!!(process.env.NODE_ENV !== "production")) {
        warn$1("resolve".concat(capitalize(type.slice(0, -1)), " can only be used in render() or setup()."));
    }
}
function resolve(registry, name) {
    return registry && (registry[name] || registry[camelize(name)] || registry[capitalize(camelize(name))]);
}
var isSuspense = function (type) { return type.__isSuspense; };
var suspenseId = 0;
var SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process: function (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
        if (n1 == null) {
            mountSuspense(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals);
        }
        else {
            if (parentSuspense && parentSuspense.deps > 0 && !n1.suspense.isInFallback) {
                n2.suspense = n1.suspense;
                n2.suspense.vnode = n2;
                n2.el = n1.el;
                return;
            }
            patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, rendererInternals);
        }
    },
    hydrate: hydrateSuspense,
    create: createSuspenseBoundary,
    normalize: normalizeSuspenseChildren
};
var Suspense = SuspenseImpl;
function triggerEvent(vnode, name) {
    var eventListener = vnode.props && vnode.props[name];
    if (isFunction(eventListener)) {
        eventListener();
    }
}
function mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
    var patch = rendererInternals.p, createElement = rendererInternals.o.createElement;
    var hiddenContainer = createElement("div");
    var suspense = vnode.suspense = createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals);
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds);
    if (suspense.deps > 0) {
        triggerEvent(vnode, "onPending");
        triggerEvent(vnode, "onFallback");
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, 
        // fallback tree will not have suspense context
        namespace, slotScopeIds);
        setActiveBranch(suspense, vnode.ssFallback);
    }
    else {
        suspense.resolve(false, true);
    }
}
function patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, _e) {
    var patch = _e.p, unmount = _e.um, createElement = _e.o.createElement;
    var suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    var newBranch = n2.ssContent;
    var newFallback = n2.ssFallback;
    var activeBranch = suspense.activeBranch, pendingBranch = suspense.pendingBranch, isInFallback = suspense.isInFallback, isHydrating = suspense.isHydrating;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if (isSameVNodeType(newBranch, pendingBranch)) {
            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
            if (suspense.deps <= 0) {
                suspense.resolve();
            }
            else if (isInFallback) {
                if (!isHydrating) {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, 
                    // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    setActiveBranch(suspense, newFallback);
                }
            }
        }
        else {
            suspense.pendingId = suspenseId++;
            if (isHydrating) {
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            }
            else {
                unmount(pendingBranch, parentComponent, suspense);
            }
            suspense.deps = 0;
            suspense.effects.length = 0;
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) {
                    suspense.resolve();
                }
                else {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, 
                    // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    setActiveBranch(suspense, newFallback);
                }
            }
            else if (activeBranch && isSameVNodeType(newBranch, activeBranch)) {
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
                suspense.resolve(true);
            }
            else {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) {
                    suspense.resolve();
                }
            }
        }
    }
    else {
        if (activeBranch && isSameVNodeType(newBranch, activeBranch)) {
            patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
            setActiveBranch(suspense, newBranch);
        }
        else {
            triggerEvent(n2, "onPending");
            suspense.pendingBranch = newBranch;
            if (newBranch.shapeFlag & 512) {
                suspense.pendingId = newBranch.component.suspenseId;
            }
            else {
                suspense.pendingId = suspenseId++;
            }
            patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
            if (suspense.deps <= 0) {
                suspense.resolve();
            }
            else {
                var timeout = suspense.timeout, pendingId_1 = suspense.pendingId;
                if (timeout > 0) {
                    setTimeout(function () {
                        if (suspense.pendingId === pendingId_1) {
                            suspense.fallback(newFallback);
                        }
                    }, timeout);
                }
                else if (timeout === 0) {
                    suspense.fallback(newFallback);
                }
            }
        }
    }
}
var hasWarned = false;
function createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals, isHydrating) {
    if (isHydrating === void 0) { isHydrating = false; }
    if (!!(process.env.NODE_ENV !== "production") && true && !hasWarned) {
        hasWarned = true;
        console[console.info ? "info" : "log"]("<Suspense> is an experimental feature and its API will likely change.");
    }
    var patch = rendererInternals.p, move = rendererInternals.m, unmount = rendererInternals.um, next = rendererInternals.n, _e = rendererInternals.o, parentNode = _e.parentNode, remove = _e.remove;
    var parentSuspenseId;
    var isSuspensible = isVNodeSuspensible(vnode);
    if (isSuspensible) {
        if (parentSuspense && parentSuspense.pendingBranch) {
            parentSuspenseId = parentSuspense.pendingId;
            parentSuspense.deps++;
        }
    }
    var timeout = vnode.props ? toNumber(vnode.props.timeout) : void 0;
    if (!!(process.env.NODE_ENV !== "production")) {
        assertNumber(timeout, "Suspense timeout");
    }
    var initialAnchor = anchor;
    var suspense = {
        vnode: vnode,
        parent: parentSuspense,
        parentComponent: parentComponent,
        namespace: namespace,
        container: container,
        hiddenContainer: hiddenContainer,
        deps: 0,
        pendingId: suspenseId++,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        pendingBranch: null,
        isInFallback: !isHydrating,
        isHydrating: isHydrating,
        isUnmounted: false,
        effects: [],
        resolve: function (resume, sync) {
            var _e;
            if (resume === void 0) { resume = false; }
            if (sync === void 0) { sync = false; }
            if (!!(process.env.NODE_ENV !== "production")) {
                if (!resume && !suspense.pendingBranch) {
                    throw new Error("suspense.resolve() is called without a pending branch.");
                }
                if (suspense.isUnmounted) {
                    throw new Error("suspense.resolve() is called on an already unmounted suspense boundary.");
                }
            }
            var vnode2 = suspense.vnode, activeBranch = suspense.activeBranch, pendingBranch = suspense.pendingBranch, pendingId = suspense.pendingId, effects = suspense.effects, parentComponent2 = suspense.parentComponent, container2 = suspense.container;
            var delayEnter = false;
            if (suspense.isHydrating) {
                suspense.isHydrating = false;
            }
            else if (!resume) {
                delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                if (delayEnter) {
                    activeBranch.transition.afterLeave = function () {
                        if (pendingId === suspense.pendingId) {
                            move(pendingBranch, container2, anchor === initialAnchor ? next(activeBranch) : anchor, 0);
                            queuePostFlushCb(effects);
                        }
                    };
                }
                if (activeBranch) {
                    if (parentNode(activeBranch.el) !== suspense.hiddenContainer) {
                        anchor = next(activeBranch);
                    }
                    unmount(activeBranch, parentComponent2, suspense, true);
                }
                if (!delayEnter) {
                    move(pendingBranch, container2, anchor, 0);
                }
            }
            setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            var parent = suspense.parent;
            var hasUnresolvedAncestor = false;
            while (parent) {
                if (parent.pendingBranch) {
                    (_e = parent.effects).push.apply(_e, __spreadArray([], __read(effects), false));
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            if (!hasUnresolvedAncestor && !delayEnter) {
                queuePostFlushCb(effects);
            }
            suspense.effects = [];
            if (isSuspensible) {
                if (parentSuspense && parentSuspense.pendingBranch && parentSuspenseId === parentSuspense.pendingId) {
                    parentSuspense.deps--;
                    if (parentSuspense.deps === 0 && !sync) {
                        parentSuspense.resolve();
                    }
                }
            }
            triggerEvent(vnode2, "onResolve");
        },
        fallback: function (fallbackVNode) {
            if (!suspense.pendingBranch) {
                return;
            }
            var vnode2 = suspense.vnode, activeBranch = suspense.activeBranch, parentComponent2 = suspense.parentComponent, container2 = suspense.container, namespace2 = suspense.namespace;
            triggerEvent(vnode2, "onFallback");
            var anchor2 = next(activeBranch);
            var mountFallback = function () {
                if (!suspense.isInFallback) {
                    return;
                }
                patch(null, fallbackVNode, container2, anchor2, parentComponent2, null, 
                // fallback tree will not have suspense context
                namespace2, slotScopeIds, optimized);
                setActiveBranch(suspense, fallbackVNode);
            };
            var delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) {
                activeBranch.transition.afterLeave = mountFallback;
            }
            suspense.isInFallback = true;
            unmount(activeBranch, parentComponent2, null, 
            // no suspense so unmount hooks fire now
            true
            // shouldRemove
            );
            if (!delayEnter) {
                mountFallback();
            }
        },
        move: function (container2, anchor2, type) {
            suspense.activeBranch && move(suspense.activeBranch, container2, anchor2, type);
            suspense.container = container2;
        },
        next: function () {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep: function (instance, setupRenderEffect) {
            var isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) {
                suspense.deps++;
            }
            var hydratedEl = instance.vnode.el;
            instance.asyncDep.catch(function (err) {
                handleError(err, instance, 0);
            }).then(function (asyncSetupResult) {
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) {
                    return;
                }
                instance.asyncResolved = true;
                var vnode2 = instance.vnode;
                if (!!(process.env.NODE_ENV !== "production")) {
                    pushWarningContext(vnode2);
                }
                handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) {
                    vnode2.el = hydratedEl;
                }
                var placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode2, 
                // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), 
                // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, namespace, optimized);
                if (placeholder) {
                    remove(placeholder);
                }
                updateHOCHostEl(instance, vnode2.el);
                if (!!(process.env.NODE_ENV !== "production")) {
                    popWarningContext();
                }
                if (isInPendingSuspense && --suspense.deps === 0) {
                    suspense.resolve();
                }
            });
        },
        unmount: function (parentSuspense2, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) {
                unmount(suspense.activeBranch, parentComponent, parentSuspense2, doRemove);
            }
            if (suspense.pendingBranch) {
                unmount(suspense.pendingBranch, parentComponent, parentSuspense2, doRemove);
            }
        }
    };
    return suspense;
}
function hydrateSuspense(node, vnode, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    var suspense = vnode.suspense = createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, 
    // eslint-disable-next-line no-restricted-globals
    document.createElement("div"), null, namespace, slotScopeIds, optimized, rendererInternals, true);
    var result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) {
        suspense.resolve(false, true);
    }
    return result;
}
function normalizeSuspenseChildren(vnode) {
    var shapeFlag = vnode.shapeFlag, children = vnode.children;
    var isSlotChildren = shapeFlag & 32;
    vnode.ssContent = normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? normalizeSuspenseSlot(children.fallback) : createVNode(Comment);
}
function normalizeSuspenseSlot(s) {
    var block;
    if (isFunction(s)) {
        var trackBlock = isBlockTreeEnabled && s._c;
        if (trackBlock) {
            s._d = false;
            openBlock();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = currentBlock;
            closeBlock();
        }
    }
    if (isArray(s)) {
        var singleChild = filterSingleRoot(s);
        if (!!(process.env.NODE_ENV !== "production") && !singleChild && s.filter(function (child) { return child !== NULL_DYNAMIC_COMPONENT; }).length > 0) {
            warn$1("<Suspense> slots expect a single root node.");
        }
        s = singleChild;
    }
    s = normalizeVNode(s);
    if (block && !s.dynamicChildren) {
        s.dynamicChildren = block.filter(function (c) { return c !== s; });
    }
    return s;
}
function queueEffectWithSuspense(fn, suspense) {
    var _e;
    if (suspense && suspense.pendingBranch) {
        if (isArray(fn)) {
            (_e = suspense.effects).push.apply(_e, __spreadArray([], __read(fn), false));
        }
        else {
            suspense.effects.push(fn);
        }
    }
    else {
        queuePostFlushCb(fn);
    }
}
function setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    var vnode = suspense.vnode, parentComponent = suspense.parentComponent;
    var el = branch.el;
    while (!el && branch.component) {
        branch = branch.component.subTree;
        el = branch.el;
    }
    vnode.el = el;
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        updateHOCHostEl(parentComponent, el);
    }
}
function isVNodeSuspensible(vnode) {
    var suspensible = vnode.props && vnode.props.suspensible;
    return suspensible != null && suspensible !== false;
}
var ssrContextKey = Symbol.for("v-scx");
var useSSRContext = function () {
    {
        var ctx = inject(ssrContextKey);
        if (!ctx) {
            !!(process.env.NODE_ENV !== "production") && warn$1("Server rendering context not provided. Make sure to only call useSSRContext() conditionally in the server build.");
        }
        return ctx;
    }
};
function watchEffect(effect, options) {
    return doWatch(effect, null, options);
}
function watchPostEffect(effect, options) {
    return doWatch(effect, null, !!(process.env.NODE_ENV !== "production") ? extend({}, options, { flush: "post" }) : { flush: "post" });
}
function watchSyncEffect(effect, options) {
    return doWatch(effect, null, !!(process.env.NODE_ENV !== "production") ? extend({}, options, { flush: "sync" }) : { flush: "sync" });
}
var INITIAL_WATCHER_VALUE = {};
function watch(source, cb, options) {
    if (!!(process.env.NODE_ENV !== "production") && !isFunction(cb)) {
        warn$1("`watch(fn, options?)` signature has been moved to a separate API. Use `watchEffect(fn, options?)` instead. `watch` now only supports `watch(source, cb, options?) signature.");
    }
    return doWatch(source, cb, options);
}
function doWatch(source, cb, _e) {
    var _f = _e === void 0 ? EMPTY_OBJ : _e, immediate = _f.immediate, deep = _f.deep, flush = _f.flush, once = _f.once, onTrack = _f.onTrack, onTrigger = _f.onTrigger;
    if (cb && once) {
        var _cb_1 = cb;
        cb = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            _cb_1.apply(void 0, __spreadArray([], __read(args), false));
            unwatch();
        };
    }
    if (!!(process.env.NODE_ENV !== "production") && deep !== void 0 && typeof deep === "number") {
        warn$1("watch() \"deep\" option with number value will be used as watch depth in future versions. Please use a boolean instead to avoid potential breakage.");
    }
    if (!!(process.env.NODE_ENV !== "production") && !cb) {
        if (immediate !== void 0) {
            warn$1("watch() \"immediate\" option is only respected when using the watch(source, callback, options?) signature.");
        }
        if (deep !== void 0) {
            warn$1("watch() \"deep\" option is only respected when using the watch(source, callback, options?) signature.");
        }
        if (once !== void 0) {
            warn$1("watch() \"once\" option is only respected when using the watch(source, callback, options?) signature.");
        }
    }
    var warnInvalidSource = function (s) {
        warn$1("Invalid watch source: ", s, "A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.");
    };
    var instance = currentInstance;
    var reactiveGetter = function (source2) { return deep === true ? source2 : (
    // for deep: false, only traverse root-level properties
    traverse(source2, deep === false ? 1 : void 0)); };
    var getter;
    var forceTrigger = false;
    var isMultiSource = false;
    if (isRef(source)) {
        getter = function () { return source.value; };
        forceTrigger = isShallow(source);
    }
    else if (isReactive(source)) {
        getter = function () { return reactiveGetter(source); };
        forceTrigger = true;
    }
    else if (isArray(source)) {
        isMultiSource = true;
        forceTrigger = source.some(function (s) { return isReactive(s) || isShallow(s); });
        getter = function () { return source.map(function (s) {
            if (isRef(s)) {
                return s.value;
            }
            else if (isReactive(s)) {
                return reactiveGetter(s);
            }
            else if (isFunction(s)) {
                return callWithErrorHandling(s, instance, 2);
            }
            else {
                !!(process.env.NODE_ENV !== "production") && warnInvalidSource(s);
            }
        }); };
    }
    else if (isFunction(source)) {
        if (cb) {
            getter = function () { return callWithErrorHandling(source, instance, 2); };
        }
        else {
            getter = function () {
                if (cleanup) {
                    cleanup();
                }
                return callWithAsyncErrorHandling(source, instance, 3, [onCleanup]);
            };
        }
    }
    else {
        getter = NOOP;
        !!(process.env.NODE_ENV !== "production") && warnInvalidSource(source);
    }
    if (cb && deep) {
        var baseGetter_1 = getter;
        getter = function () { return traverse(baseGetter_1()); };
    }
    var cleanup;
    var onCleanup = function (fn) {
        cleanup = effect.onStop = function () {
            callWithErrorHandling(fn, instance, 4);
            cleanup = effect.onStop = void 0;
        };
    };
    var ssrCleanup;
    if (isInSSRComponentSetup) {
        onCleanup = NOOP;
        if (!cb) {
            getter();
        }
        else if (immediate) {
            callWithAsyncErrorHandling(cb, instance, 3, [
                getter(),
                isMultiSource ? [] : void 0,
                onCleanup
            ]);
        }
        if (flush === "sync") {
            var ctx = useSSRContext();
            ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
        }
        else {
            return NOOP;
        }
    }
    var oldValue = isMultiSource ? new Array(source.length).fill(INITIAL_WATCHER_VALUE) : INITIAL_WATCHER_VALUE;
    var job = function () {
        if (!effect.active || !effect.dirty) {
            return;
        }
        if (cb) {
            var newValue = effect.run();
            if (deep || forceTrigger || (isMultiSource ? newValue.some(function (v, i) { return hasChanged(v, oldValue[i]); }) : hasChanged(newValue, oldValue)) || false) {
                if (cleanup) {
                    cleanup();
                }
                callWithAsyncErrorHandling(cb, instance, 3, [
                    newValue,
                    // pass undefined as the old value when it's changed for the first time
                    oldValue === INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === INITIAL_WATCHER_VALUE ? [] : oldValue,
                    onCleanup
                ]);
                oldValue = newValue;
            }
        }
        else {
            effect.run();
        }
    };
    job.allowRecurse = !!cb;
    var scheduler;
    if (flush === "sync") {
        scheduler = job;
    }
    else if (flush === "post") {
        scheduler = function () { return queuePostRenderEffect(job, instance && instance.suspense); };
    }
    else {
        job.pre = true;
        if (instance)
            job.id = instance.uid;
        scheduler = function () { return queueJob(job); };
    }
    var effect = new ReactiveEffect(getter, NOOP, scheduler);
    var scope = getCurrentScope();
    var unwatch = function () {
        effect.stop();
        if (scope) {
            remove(scope.effects, effect);
        }
    };
    if (!!(process.env.NODE_ENV !== "production")) {
        effect.onTrack = onTrack;
        effect.onTrigger = onTrigger;
    }
    if (cb) {
        if (immediate) {
            job();
        }
        else {
            oldValue = effect.run();
        }
    }
    else if (flush === "post") {
        queuePostRenderEffect(effect.run.bind(effect), instance && instance.suspense);
    }
    else {
        effect.run();
    }
    if (ssrCleanup)
        ssrCleanup.push(unwatch);
    return unwatch;
}
function instanceWatch(source, value, options) {
    var publicThis = this.proxy;
    var getter = isString(source) ? source.includes(".") ? createPathGetter(publicThis, source) : function () { return publicThis[source]; } : source.bind(publicThis, publicThis);
    var cb;
    if (isFunction(value)) {
        cb = value;
    }
    else {
        cb = value.handler;
        options = value;
    }
    var reset = setCurrentInstance(this);
    var res = doWatch(getter, cb.bind(publicThis), options);
    reset();
    return res;
}
function createPathGetter(ctx, path) {
    var segments = path.split(".");
    return function () {
        var cur = ctx;
        for (var i = 0; i < segments.length && cur; i++) {
            cur = cur[segments[i]];
        }
        return cur;
    };
}
function traverse(value, depth, seen) {
    if (depth === void 0) { depth = Infinity; }
    if (depth <= 0 || !isObject(value) || value["__v_skip"]) {
        return value;
    }
    seen = seen || /* @__PURE__ */ new Set();
    if (seen.has(value)) {
        return value;
    }
    seen.add(value);
    depth--;
    if (isRef(value)) {
        traverse(value.value, depth, seen);
    }
    else if (isArray(value)) {
        for (var i = 0; i < value.length; i++) {
            traverse(value[i], depth, seen);
        }
    }
    else if (isSet(value) || isMap(value)) {
        value.forEach(function (v) {
            traverse(v, depth, seen);
        });
    }
    else if (isPlainObject(value)) {
        for (var key in value) {
            traverse(value[key], depth, seen);
        }
    }
    return value;
}
function validateDirectiveName(name) {
    if (isBuiltInDirective(name)) {
        warn$1("Do not use built-in directive ids as custom directive id: " + name);
    }
}
function withDirectives(vnode, directives) {
    if (currentRenderingInstance === null) {
        !!(process.env.NODE_ENV !== "production") && warn$1("withDirectives can only be used inside render functions.");
        return vnode;
    }
    var instance = getExposeProxy(currentRenderingInstance) || currentRenderingInstance.proxy;
    var bindings = vnode.dirs || (vnode.dirs = []);
    for (var i = 0; i < directives.length; i++) {
        var _e = __read(directives[i], 4), dir = _e[0], value = _e[1], arg = _e[2], _f = _e[3], modifiers = _f === void 0 ? EMPTY_OBJ : _f;
        if (dir) {
            if (isFunction(dir)) {
                dir = {
                    mounted: dir,
                    updated: dir
                };
            }
            if (dir.deep) {
                traverse(value);
            }
            bindings.push({
                dir: dir,
                instance: instance,
                value: value,
                oldValue: void 0,
                arg: arg,
                modifiers: modifiers
            });
        }
    }
    return vnode;
}
function invokeDirectiveHook(vnode, prevVNode, instance, name) {
    var bindings = vnode.dirs;
    var oldBindings = prevVNode && prevVNode.dirs;
    for (var i = 0; i < bindings.length; i++) {
        var binding = bindings[i];
        if (oldBindings) {
            binding.oldValue = oldBindings[i].value;
        }
        var hook = binding.dir[name];
        if (hook) {
            pauseTracking();
            callWithAsyncErrorHandling(hook, instance, 8, [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            resetTracking();
        }
    }
}
var leaveCbKey = Symbol("_leaveCb");
var enterCbKey = Symbol("_enterCb");
function useTransitionState() {
    var state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: /* @__PURE__ */ new Map()
    };
    onMounted(function () {
        state.isMounted = true;
    });
    onBeforeUnmount(function () {
        state.isUnmounting = true;
    });
    return state;
}
var TransitionHookValidator = [Function, Array];
var BaseTransitionPropsValidators = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    // enter
    onBeforeEnter: TransitionHookValidator,
    onEnter: TransitionHookValidator,
    onAfterEnter: TransitionHookValidator,
    onEnterCancelled: TransitionHookValidator,
    // leave
    onBeforeLeave: TransitionHookValidator,
    onLeave: TransitionHookValidator,
    onAfterLeave: TransitionHookValidator,
    onLeaveCancelled: TransitionHookValidator,
    // appear
    onBeforeAppear: TransitionHookValidator,
    onAppear: TransitionHookValidator,
    onAfterAppear: TransitionHookValidator,
    onAppearCancelled: TransitionHookValidator
};
var BaseTransitionImpl = {
    name: "BaseTransition",
    props: BaseTransitionPropsValidators,
    setup: function (props, _e) {
        var slots = _e.slots;
        var instance = getCurrentInstance();
        var state = useTransitionState();
        return function () {
            var e_3, _e;
            var children = slots.default && getTransitionRawChildren(slots.default(), true);
            if (!children || !children.length) {
                return;
            }
            var child = children[0];
            if (children.length > 1) {
                var hasFound = false;
                try {
                    for (var children_1 = __values(children), children_1_1 = children_1.next(); !children_1_1.done; children_1_1 = children_1.next()) {
                        var c = children_1_1.value;
                        if (c.type !== Comment) {
                            if (!!(process.env.NODE_ENV !== "production") && hasFound) {
                                warn$1("<transition> can only be used on a single element or component. Use <transition-group> for lists.");
                                break;
                            }
                            child = c;
                            hasFound = true;
                            if (!!!(process.env.NODE_ENV !== "production"))
                                break;
                        }
                    }
                }
                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                finally {
                    try {
                        if (children_1_1 && !children_1_1.done && (_e = children_1.return)) _e.call(children_1);
                    }
                    finally { if (e_3) throw e_3.error; }
                }
            }
            var rawProps = toRaw(props);
            var mode = rawProps.mode;
            if (!!(process.env.NODE_ENV !== "production") && mode && mode !== "in-out" && mode !== "out-in" && mode !== "default") {
                warn$1("invalid <transition> mode: ".concat(mode));
            }
            if (state.isLeaving) {
                return emptyPlaceholder(child);
            }
            var innerChild = getKeepAliveChild(child);
            if (!innerChild) {
                return emptyPlaceholder(child);
            }
            var enterHooks = resolveTransitionHooks(innerChild, rawProps, state, instance);
            setTransitionHooks(innerChild, enterHooks);
            var oldChild = instance.subTree;
            var oldInnerChild = oldChild && getKeepAliveChild(oldChild);
            if (oldInnerChild && oldInnerChild.type !== Comment && !isSameVNodeType(innerChild, oldInnerChild)) {
                var leavingHooks = resolveTransitionHooks(oldInnerChild, rawProps, state, instance);
                setTransitionHooks(oldInnerChild, leavingHooks);
                if (mode === "out-in" && innerChild.type !== Comment) {
                    state.isLeaving = true;
                    leavingHooks.afterLeave = function () {
                        state.isLeaving = false;
                        if (instance.update.active !== false) {
                            instance.effect.dirty = true;
                            instance.update();
                        }
                    };
                    return emptyPlaceholder(child);
                }
                else if (mode === "in-out" && innerChild.type !== Comment) {
                    leavingHooks.delayLeave = function (el, earlyRemove, delayedLeave) {
                        var leavingVNodesCache = getLeavingNodesForType(state, oldInnerChild);
                        leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                        el[leaveCbKey] = function () {
                            earlyRemove();
                            el[leaveCbKey] = void 0;
                            delete enterHooks.delayedLeave;
                        };
                        enterHooks.delayedLeave = delayedLeave;
                    };
                }
            }
            return child;
        };
    }
};
var BaseTransition = BaseTransitionImpl;
function getLeavingNodesForType(state, vnode) {
    var leavingVNodes = state.leavingVNodes;
    var leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = /* @__PURE__ */ Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
function resolveTransitionHooks(vnode, props, state, instance) {
    var appear = props.appear, mode = props.mode, _e = props.persisted, persisted = _e === void 0 ? false : _e, onBeforeEnter = props.onBeforeEnter, onEnter = props.onEnter, onAfterEnter = props.onAfterEnter, onEnterCancelled = props.onEnterCancelled, onBeforeLeave = props.onBeforeLeave, onLeave = props.onLeave, onAfterLeave = props.onAfterLeave, onLeaveCancelled = props.onLeaveCancelled, onBeforeAppear = props.onBeforeAppear, onAppear = props.onAppear, onAfterAppear = props.onAfterAppear, onAppearCancelled = props.onAppearCancelled;
    var key = String(vnode.key);
    var leavingVNodesCache = getLeavingNodesForType(state, vnode);
    var callHook = function (hook, args) {
        hook && callWithAsyncErrorHandling(hook, instance, 9, args);
    };
    var callAsyncHook = function (hook, args) {
        var done = args[1];
        callHook(hook, args);
        if (isArray(hook)) {
            if (hook.every(function (hook2) { return hook2.length <= 1; }))
                done();
        }
        else if (hook.length <= 1) {
            done();
        }
    };
    var hooks = {
        mode: mode,
        persisted: persisted,
        beforeEnter: function (el) {
            var hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) {
                    hook = onBeforeAppear || onBeforeEnter;
                }
                else {
                    return;
                }
            }
            if (el[leaveCbKey]) {
                el[leaveCbKey](true
                /* cancelled */
                );
            }
            var leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && isSameVNodeType(vnode, leavingVNode) && leavingVNode.el[leaveCbKey]) {
                leavingVNode.el[leaveCbKey]();
            }
            callHook(hook, [el]);
        },
        enter: function (el) {
            var hook = onEnter;
            var afterHook = onAfterEnter;
            var cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                }
                else {
                    return;
                }
            }
            var called = false;
            var done = el[enterCbKey] = function (cancelled) {
                if (called)
                    return;
                called = true;
                if (cancelled) {
                    callHook(cancelHook, [el]);
                }
                else {
                    callHook(afterHook, [el]);
                }
                if (hooks.delayedLeave) {
                    hooks.delayedLeave();
                }
                el[enterCbKey] = void 0;
            };
            if (hook) {
                callAsyncHook(hook, [el, done]);
            }
            else {
                done();
            }
        },
        leave: function (el, remove) {
            var key2 = String(vnode.key);
            if (el[enterCbKey]) {
                el[enterCbKey](true
                /* cancelled */
                );
            }
            if (state.isUnmounting) {
                return remove();
            }
            callHook(onBeforeLeave, [el]);
            var called = false;
            var done = el[leaveCbKey] = function (cancelled) {
                if (called)
                    return;
                called = true;
                remove();
                if (cancelled) {
                    callHook(onLeaveCancelled, [el]);
                }
                else {
                    callHook(onAfterLeave, [el]);
                }
                el[leaveCbKey] = void 0;
                if (leavingVNodesCache[key2] === vnode) {
                    delete leavingVNodesCache[key2];
                }
            };
            leavingVNodesCache[key2] = vnode;
            if (onLeave) {
                callAsyncHook(onLeave, [el, done]);
            }
            else {
                done();
            }
        },
        clone: function (vnode2) {
            return resolveTransitionHooks(vnode2, props, state, instance);
        }
    };
    return hooks;
}
function emptyPlaceholder(vnode) {
    if (isKeepAlive(vnode)) {
        vnode = cloneVNode(vnode);
        vnode.children = null;
        return vnode;
    }
}
function getKeepAliveChild(vnode) {
    if (!isKeepAlive(vnode)) {
        return vnode;
    }
    if (!!(process.env.NODE_ENV !== "production") && vnode.component) {
        return vnode.component.subTree;
    }
    var shapeFlag = vnode.shapeFlag, children = vnode.children;
    if (children) {
        if (shapeFlag & 16) {
            return children[0];
        }
        if (shapeFlag & 32 && isFunction(children.default)) {
            return children.default();
        }
    }
}
function setTransitionHooks(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) {
        setTransitionHooks(vnode.component.subTree, hooks);
    }
    else if (vnode.shapeFlag & 128) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    }
    else {
        vnode.transition = hooks;
    }
}
function getTransitionRawChildren(children, keepComment, parentKey) {
    if (keepComment === void 0) { keepComment = false; }
    var ret = [];
    var keyedFragmentCount = 0;
    for (var i = 0; i < children.length; i++) {
        var child = children[i];
        var key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        if (child.type === Fragment) {
            if (child.patchFlag & 128)
                keyedFragmentCount++;
            ret = ret.concat(getTransitionRawChildren(child.children, keepComment, key));
        }
        else if (keepComment || child.type !== Comment) {
            ret.push(key != null ? cloneVNode(child, { key: key }) : child);
        }
    }
    if (keyedFragmentCount > 1) {
        for (var i = 0; i < ret.length; i++) {
            ret[i].patchFlag = -2;
        }
    }
    return ret;
}
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function defineComponent(options, extraOptions) {
    return isFunction(options) ? (
    // #8326: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ (function () { return extend({ name: options.name }, extraOptions, { setup: options }); })()) : options;
}
var isAsyncWrapper = function (i) { return !!i.type.__asyncLoader; };
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function defineAsyncComponent(source) {
    if (isFunction(source)) {
        source = { loader: source };
    }
    var loader = source.loader, loadingComponent = source.loadingComponent, errorComponent = source.errorComponent, _e = source.delay, delay = _e === void 0 ? 200 : _e, timeout = source.timeout, 
    // undefined = never times out
    _f = source.suspensible, 
    // undefined = never times out
    suspensible = _f === void 0 ? true : _f, userOnError = source.onError;
    var pendingRequest = null;
    var resolvedComp;
    var retries = 0;
    var retry = function () {
        retries++;
        pendingRequest = null;
        return load();
    };
    var load = function () {
        var thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch(function (err) {
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) {
                return new Promise(function (resolve, reject) {
                    var userRetry = function () { return resolve(retry()); };
                    var userFail = function () { return reject(err); };
                    userOnError(err, userRetry, userFail, retries + 1);
                });
            }
            else {
                throw err;
            }
        }).then(function (comp) {
            if (thisRequest !== pendingRequest && pendingRequest) {
                return pendingRequest;
            }
            if (!!(process.env.NODE_ENV !== "production") && !comp) {
                warn$1("Async component loader resolved to undefined. If you are using retry(), make sure to return its return value.");
            }
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) {
                comp = comp.default;
            }
            if (!!(process.env.NODE_ENV !== "production") && comp && !isObject(comp) && !isFunction(comp)) {
                throw new Error("Invalid async component load result: ".concat(comp));
            }
            resolvedComp = comp;
            return comp;
        }));
    };
    return defineComponent({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        get __asyncResolved() {
            return resolvedComp;
        },
        setup: function () {
            var instance = currentInstance;
            if (resolvedComp) {
                return function () { return createInnerComp(resolvedComp, instance); };
            }
            var onError = function (err) {
                pendingRequest = null;
                handleError(err, instance, 13, !errorComponent);
            };
            if (suspensible && instance.suspense || isInSSRComponentSetup) {
                return load().then(function (comp) {
                    return function () { return createInnerComp(comp, instance); };
                }).catch(function (err) {
                    onError(err);
                    return function () { return errorComponent ? createVNode(errorComponent, {
                        error: err
                    }) : null; };
                });
            }
            var loaded = ref(false);
            var error = ref();
            var delayed = ref(!!delay);
            if (delay) {
                setTimeout(function () {
                    delayed.value = false;
                }, delay);
            }
            if (timeout != null) {
                setTimeout(function () {
                    if (!loaded.value && !error.value) {
                        var err = new Error("Async component timed out after ".concat(timeout, "ms."));
                        onError(err);
                        error.value = err;
                    }
                }, timeout);
            }
            load().then(function () {
                loaded.value = true;
                if (instance.parent && isKeepAlive(instance.parent.vnode)) {
                    instance.parent.effect.dirty = true;
                    queueJob(instance.parent.update);
                }
            }).catch(function (err) {
                onError(err);
                error.value = err;
            });
            return function () {
                if (loaded.value && resolvedComp) {
                    return createInnerComp(resolvedComp, instance);
                }
                else if (error.value && errorComponent) {
                    return createVNode(errorComponent, {
                        error: error.value
                    });
                }
                else if (loadingComponent && !delayed.value) {
                    return createVNode(loadingComponent);
                }
            };
        }
    });
}
function createInnerComp(comp, parent) {
    var _e = parent.vnode, ref2 = _e.ref, props = _e.props, children = _e.children, ce = _e.ce;
    var vnode = createVNode(comp, props, children);
    vnode.ref = ref2;
    vnode.ce = ce;
    delete parent.vnode.ce;
    return vnode;
}
var isKeepAlive = function (vnode) { return vnode.type.__isKeepAlive; };
var KeepAliveImpl = {
    name: "KeepAlive",
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [String, RegExp, Array],
        exclude: [String, RegExp, Array],
        max: [String, Number]
    },
    setup: function (props, _e) {
        var slots = _e.slots;
        var instance = getCurrentInstance();
        var sharedContext = instance.ctx;
        if (!sharedContext.renderer) {
            return function () {
                var children = slots.default && slots.default();
                return children && children.length === 1 ? children[0] : children;
            };
        }
        var cache = /* @__PURE__ */ new Map();
        var keys = /* @__PURE__ */ new Set();
        var current = null;
        if (!!(process.env.NODE_ENV !== "production") || __VUE_PROD_DEVTOOLS__) {
            instance.__v_cache = cache;
        }
        var parentSuspense = instance.suspense;
        var _f = sharedContext.renderer, patch = _f.p, move = _f.m, _unmount = _f.um, createElement = _f.o.createElement;
        var storageContainer = createElement("div");
        sharedContext.activate = function (vnode, container, anchor, namespace, optimized) {
            var instance2 = vnode.component;
            move(vnode, container, anchor, 0, parentSuspense);
            patch(instance2.vnode, vnode, container, anchor, instance2, parentSuspense, namespace, vnode.slotScopeIds, optimized);
            queuePostRenderEffect(function () {
                instance2.isDeactivated = false;
                if (instance2.a) {
                    invokeArrayFns(instance2.a);
                }
                var vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) {
                    invokeVNodeHook(vnodeHook, instance2.parent, vnode);
                }
            }, parentSuspense);
            if (!!(process.env.NODE_ENV !== "production") || __VUE_PROD_DEVTOOLS__) {
                devtoolsComponentAdded(instance2);
            }
        };
        sharedContext.deactivate = function (vnode) {
            var instance2 = vnode.component;
            move(vnode, storageContainer, null, 1, parentSuspense);
            queuePostRenderEffect(function () {
                if (instance2.da) {
                    invokeArrayFns(instance2.da);
                }
                var vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) {
                    invokeVNodeHook(vnodeHook, instance2.parent, vnode);
                }
                instance2.isDeactivated = true;
            }, parentSuspense);
            if (!!(process.env.NODE_ENV !== "production") || __VUE_PROD_DEVTOOLS__) {
                devtoolsComponentAdded(instance2);
            }
        };
        function unmount(vnode) {
            resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach(function (vnode, key) {
                var name = getComponentName(vnode.type);
                if (name && (!filter || !filter(name))) {
                    pruneCacheEntry(key);
                }
            });
        }
        function pruneCacheEntry(key) {
            var cached = cache.get(key);
            if (!current || !isSameVNodeType(cached, current)) {
                unmount(cached);
            }
            else if (current) {
                resetShapeFlag(current);
            }
            cache.delete(key);
            keys.delete(key);
        }
        watch(function () { return [props.include, props.exclude]; }, function (_e) {
            var _f = __read(_e, 2), include = _f[0], exclude = _f[1];
            include && pruneCache(function (name) { return matches(include, name); });
            exclude && pruneCache(function (name) { return !matches(exclude, name); });
        }, 
        // prune post-render after `current` has been updated
        { flush: "post", deep: true });
        var pendingCacheKey = null;
        var cacheSubtree = function () {
            if (pendingCacheKey != null) {
                cache.set(pendingCacheKey, getInnerChild(instance.subTree));
            }
        };
        onMounted(cacheSubtree);
        onUpdated(cacheSubtree);
        onBeforeUnmount(function () {
            cache.forEach(function (cached) {
                var subTree = instance.subTree, suspense = instance.suspense;
                var vnode = getInnerChild(subTree);
                if (cached.type === vnode.type && cached.key === vnode.key) {
                    resetShapeFlag(vnode);
                    var da = vnode.component.da;
                    da && queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return function () {
            pendingCacheKey = null;
            if (!slots.default) {
                return null;
            }
            var children = slots.default();
            var rawVNode = children[0];
            if (children.length > 1) {
                if (!!(process.env.NODE_ENV !== "production")) {
                    warn$1("KeepAlive should contain exactly one component child.");
                }
                current = null;
                return children;
            }
            else if (!isVNode(rawVNode) || !(rawVNode.shapeFlag & 4) && !(rawVNode.shapeFlag & 128)) {
                current = null;
                return rawVNode;
            }
            var vnode = getInnerChild(rawVNode);
            var comp = vnode.type;
            var name = getComponentName(isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            var include = props.include, exclude = props.exclude, max = props.max;
            if (include && (!name || !matches(include, name)) || exclude && name && matches(exclude, name)) {
                current = vnode;
                return rawVNode;
            }
            var key = vnode.key == null ? comp : vnode.key;
            var cachedVNode = cache.get(key);
            if (vnode.el) {
                vnode = cloneVNode(vnode);
                if (rawVNode.shapeFlag & 128) {
                    rawVNode.ssContent = vnode;
                }
            }
            pendingCacheKey = key;
            if (cachedVNode) {
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) {
                    setTransitionHooks(vnode, vnode.transition);
                }
                vnode.shapeFlag |= 512;
                keys.delete(key);
                keys.add(key);
            }
            else {
                keys.add(key);
                if (max && keys.size > parseInt(max, 10)) {
                    pruneCacheEntry(keys.values().next().value);
                }
            }
            vnode.shapeFlag |= 256;
            current = vnode;
            return isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
var KeepAlive = KeepAliveImpl;
function matches(pattern, name) {
    if (isArray(pattern)) {
        return pattern.some(function (p) { return matches(p, name); });
    }
    else if (isString(pattern)) {
        return pattern.split(",").includes(name);
    }
    else if (isRegExp(pattern)) {
        return pattern.test(name);
    }
    return false;
}
function onActivated(hook, target) {
    registerKeepAliveHook(hook, "a", target);
}
function onDeactivated(hook, target) {
    registerKeepAliveHook(hook, "da", target);
}
function registerKeepAliveHook(hook, type, target) {
    if (target === void 0) { target = currentInstance; }
    var wrappedHook = hook.__wdc || (hook.__wdc = function () {
        var current = target;
        while (current) {
            if (current.isDeactivated) {
                return;
            }
            current = current.parent;
        }
        return hook();
    });
    injectHook(type, wrappedHook, target);
    if (target) {
        var current = target.parent;
        while (current && current.parent) {
            if (isKeepAlive(current.parent.vnode)) {
                injectToKeepAliveRoot(wrappedHook, type, target, current);
            }
            current = current.parent;
        }
    }
}
function injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    var injected = injectHook(type, hook, keepAliveRoot, true
    /* prepend */
    );
    onUnmounted(function () {
        remove(keepAliveRoot[type], injected);
    }, target);
}
function resetShapeFlag(vnode) {
    vnode.shapeFlag &= ~256;
    vnode.shapeFlag &= ~512;
}
function getInnerChild(vnode) {
    return vnode.shapeFlag & 128 ? vnode.ssContent : vnode;
}
function injectHook(type, hook, target, prepend) {
    if (target === void 0) { target = currentInstance; }
    if (prepend === void 0) { prepend = false; }
    if (target) {
        var hooks = target[type] || (target[type] = []);
        var wrappedHook = hook.__weh || (hook.__weh = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (target.isUnmounted) {
                return;
            }
            pauseTracking();
            var reset = setCurrentInstance(target);
            var res = callWithAsyncErrorHandling(hook, target, type, args);
            reset();
            resetTracking();
            return res;
        });
        if (prepend) {
            hooks.unshift(wrappedHook);
        }
        else {
            hooks.push(wrappedHook);
        }
        return wrappedHook;
    }
    else if (!!(process.env.NODE_ENV !== "production")) {
        var apiName = toHandlerKey(ErrorTypeStrings$1[type].replace(/ hook$/, ""));
        warn$1("".concat(apiName, " is called when there is no active component instance to be associated with. Lifecycle injection APIs can only be used during execution of setup().") + (" If you are using async setup(), make sure to register lifecycle hooks before the first await statement."));
    }
}
var createHook = function (lifecycle) { return function (hook, target) {
    if (target === void 0) { target = currentInstance; }
    return (
    // post-create lifecycle registrations are noops during SSR (except for serverPrefetch)
    (!isInSSRComponentSetup || lifecycle === "sp") && injectHook(lifecycle, function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return hook.apply(void 0, __spreadArray([], __read(args), false));
    }, target));
}; };
var onBeforeMount = createHook("bm");
var onMounted = createHook("m");
var onBeforeUpdate = createHook("bu");
var onUpdated = createHook("u");
var onBeforeUnmount = createHook("bum");
var onUnmounted = createHook("um");
var onServerPrefetch = createHook("sp");
var onRenderTriggered = createHook("rtg");
var onRenderTracked = createHook("rtc");
function onErrorCaptured(hook, target) {
    if (target === void 0) { target = currentInstance; }
    injectHook("ec", hook, target);
}
function renderList(source, renderItem, cache, index) {
    var ret;
    var cached = cache && cache[index];
    if (isArray(source) || isString(source)) {
        ret = new Array(source.length);
        for (var i = 0, l = source.length; i < l; i++) {
            ret[i] = renderItem(source[i], i, void 0, cached && cached[i]);
        }
    }
    else if (typeof source === "number") {
        if (!!(process.env.NODE_ENV !== "production") && !Number.isInteger(source)) {
            warn$1("The v-for range expect an integer value but got ".concat(source, "."));
        }
        ret = new Array(source);
        for (var i = 0; i < source; i++) {
            ret[i] = renderItem(i + 1, i, void 0, cached && cached[i]);
        }
    }
    else if (isObject(source)) {
        if (source[Symbol.iterator]) {
            ret = Array.from(source, function (item, i) { return renderItem(item, i, void 0, cached && cached[i]); });
        }
        else {
            var keys = Object.keys(source);
            ret = new Array(keys.length);
            for (var i = 0, l = keys.length; i < l; i++) {
                var key = keys[i];
                ret[i] = renderItem(source[key], key, i, cached && cached[i]);
            }
        }
    }
    else {
        ret = [];
    }
    if (cache) {
        cache[index] = ret;
    }
    return ret;
}
function createSlots(slots, dynamicSlots) {
    var _loop_1 = function (i) {
        var slot = dynamicSlots[i];
        if (isArray(slot)) {
            for (var j = 0; j < slot.length; j++) {
                slots[slot[j].name] = slot[j].fn;
            }
        }
        else if (slot) {
            slots[slot.name] = slot.key ? function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var res = slot.fn.apply(slot, __spreadArray([], __read(args), false));
                if (res)
                    res.key = slot.key;
                return res;
            } : slot.fn;
        }
    };
    for (var i = 0; i < dynamicSlots.length; i++) {
        _loop_1(i);
    }
    return slots;
}
function renderSlot(slots, name, props, fallback, noSlotted) {
    if (props === void 0) { props = {}; }
    if (currentRenderingInstance.isCE || currentRenderingInstance.parent && isAsyncWrapper(currentRenderingInstance.parent) && currentRenderingInstance.parent.isCE) {
        if (name !== "default")
            props.name = name;
        return createVNode("slot", props, fallback && fallback());
    }
    var slot = slots[name];
    if (!!(process.env.NODE_ENV !== "production") && slot && slot.length > 1) {
        warn$1("SSR-optimized slot function detected in a non-SSR-optimized render function. You need to mark this component with $dynamic-slots in the parent template.");
        slot = function () { return []; };
    }
    if (slot && slot._c) {
        slot._d = false;
    }
    openBlock();
    var validSlotContent = slot && ensureValidVNode(slot(props));
    var rendered = createBlock(Fragment, {
        key: props.key || // slot content array of a dynamic conditional slot may have a branch
            // key attached in the `createSlots` helper, respect that
            validSlotContent && validSlotContent.key || "_".concat(name)
    }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
    if (!noSlotted && rendered.scopeId) {
        rendered.slotScopeIds = [rendered.scopeId + "-s"];
    }
    if (slot && slot._c) {
        slot._d = true;
    }
    return rendered;
}
function ensureValidVNode(vnodes) {
    return vnodes.some(function (child) {
        if (!isVNode(child))
            return true;
        if (child.type === Comment)
            return false;
        if (child.type === Fragment && !ensureValidVNode(child.children))
            return false;
        return true;
    }) ? vnodes : null;
}
function toHandlers(obj, preserveCaseIfNecessary) {
    var ret = {};
    if (!!(process.env.NODE_ENV !== "production") && !isObject(obj)) {
        warn$1("v-on with no argument expects an object value.");
        return ret;
    }
    for (var key in obj) {
        ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? "on:".concat(key) : toHandlerKey(key)] = obj[key];
    }
    return ret;
}
var getPublicInstance = function (i) {
    if (!i)
        return null;
    if (isStatefulComponent(i))
        return getExposeProxy(i) || i.proxy;
    return getPublicInstance(i.parent);
};
var publicPropertiesMap = (
// Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/* @__PURE__ */ extend(/* @__PURE__ */ Object.create(null), {
    $: function (i) { return i; },
    $el: function (i) { return i.vnode.el; },
    $data: function (i) { return i.data; },
    $props: function (i) { return !!(process.env.NODE_ENV !== "production") ? shallowReadonly(i.props) : i.props; },
    $attrs: function (i) { return !!(process.env.NODE_ENV !== "production") ? shallowReadonly(i.attrs) : i.attrs; },
    $slots: function (i) { return !!(process.env.NODE_ENV !== "production") ? shallowReadonly(i.slots) : i.slots; },
    $refs: function (i) { return !!(process.env.NODE_ENV !== "production") ? shallowReadonly(i.refs) : i.refs; },
    $parent: function (i) { return getPublicInstance(i.parent); },
    $root: function (i) { return getPublicInstance(i.root); },
    $emit: function (i) { return i.emit; },
    $options: function (i) { return __VUE_OPTIONS_API__ ? resolveMergedOptions(i) : i.type; },
    $forceUpdate: function (i) { return i.f || (i.f = function () {
        i.effect.dirty = true;
        queueJob(i.update);
    }); },
    $nextTick: function (i) { return i.n || (i.n = nextTick.bind(i.proxy)); },
    $watch: function (i) { return __VUE_OPTIONS_API__ ? instanceWatch.bind(i) : NOOP; }
}));
var isReservedPrefix = function (key) { return key === "_" || key === "$"; };
var hasSetupBinding = function (state, key) { return state !== EMPTY_OBJ && !state.__isScriptSetup && hasOwn(state, key); };
var PublicInstanceProxyHandlers = {
    get: function (_e, key) {
        var instance = _e._;
        if (key === "__v_skip") {
            return true;
        }
        var ctx = instance.ctx, setupState = instance.setupState, data = instance.data, props = instance.props, accessCache = instance.accessCache, type = instance.type, appContext = instance.appContext;
        if (!!(process.env.NODE_ENV !== "production") && key === "__isVue") {
            return true;
        }
        var normalizedProps;
        if (key[0] !== "$") {
            var n = accessCache[key];
            if (n !== void 0) {
                switch (n) {
                    case 1 /* SETUP */:
                        return setupState[key];
                    case 2 /* DATA */:
                        return data[key];
                    case 4 /* CONTEXT */:
                        return ctx[key];
                    case 3 /* PROPS */:
                        return props[key];
                }
            }
            else if (hasSetupBinding(setupState, key)) {
                accessCache[key] = 1 /* SETUP */;
                return setupState[key];
            }
            else if (data !== EMPTY_OBJ && hasOwn(data, key)) {
                accessCache[key] = 2 /* DATA */;
                return data[key];
            }
            else if (
            // only cache other properties when instance has declared (thus stable)
            // props
            (normalizedProps = instance.propsOptions[0]) && hasOwn(normalizedProps, key)) {
                accessCache[key] = 3 /* PROPS */;
                return props[key];
            }
            else if (ctx !== EMPTY_OBJ && hasOwn(ctx, key)) {
                accessCache[key] = 4 /* CONTEXT */;
                return ctx[key];
            }
            else if (!__VUE_OPTIONS_API__ || shouldCacheAccess) {
                accessCache[key] = 0 /* OTHER */;
            }
        }
        var publicGetter = publicPropertiesMap[key];
        var cssModule, globalProperties;
        if (publicGetter) {
            if (key === "$attrs") {
                track(instance.attrs, "get", "");
                !!(process.env.NODE_ENV !== "production") && markAttrsAccessed();
            }
            else if (!!(process.env.NODE_ENV !== "production") && key === "$slots") {
                track(instance, "get", key);
            }
            return publicGetter(instance);
        }
        else if (
        // css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) {
            return cssModule;
        }
        else if (ctx !== EMPTY_OBJ && hasOwn(ctx, key)) {
            accessCache[key] = 4 /* CONTEXT */;
            return ctx[key];
        }
        else if (
        // global properties
        globalProperties = appContext.config.globalProperties, hasOwn(globalProperties, key)) {
            {
                return globalProperties[key];
            }
        }
        else if (!!(process.env.NODE_ENV !== "production") && currentRenderingInstance && (!isString(key) || // #1091 avoid internal isRef/isVNode checks on component instance leading
            // to infinite warning loop
            key.indexOf("__v") !== 0)) {
            if (data !== EMPTY_OBJ && isReservedPrefix(key[0]) && hasOwn(data, key)) {
                warn$1("Property ".concat(JSON.stringify(key), " must be accessed via $data because it starts with a reserved character (\"$\" or \"_\") and is not proxied on the render context."));
            }
            else if (instance === currentRenderingInstance) {
                warn$1("Property ".concat(JSON.stringify(key), " was accessed during render but is not defined on instance."));
            }
        }
    },
    set: function (_e, key, value) {
        var instance = _e._;
        var data = instance.data, setupState = instance.setupState, ctx = instance.ctx;
        if (hasSetupBinding(setupState, key)) {
            setupState[key] = value;
            return true;
        }
        else if (!!(process.env.NODE_ENV !== "production") && setupState.__isScriptSetup && hasOwn(setupState, key)) {
            warn$1("Cannot mutate <script setup> binding \"".concat(key, "\" from Options API."));
            return false;
        }
        else if (data !== EMPTY_OBJ && hasOwn(data, key)) {
            data[key] = value;
            return true;
        }
        else if (hasOwn(instance.props, key)) {
            !!(process.env.NODE_ENV !== "production") && warn$1("Attempting to mutate prop \"".concat(key, "\". Props are readonly."));
            return false;
        }
        if (key[0] === "$" && key.slice(1) in instance) {
            !!(process.env.NODE_ENV !== "production") && warn$1("Attempting to mutate public property \"".concat(key, "\". Properties starting with $ are reserved and readonly."));
            return false;
        }
        else {
            if (!!(process.env.NODE_ENV !== "production") && key in instance.appContext.config.globalProperties) {
                Object.defineProperty(ctx, key, {
                    enumerable: true,
                    configurable: true,
                    value: value
                });
            }
            else {
                ctx[key] = value;
            }
        }
        return true;
    },
    has: function (_e, key) {
        var _f = _e._, data = _f.data, setupState = _f.setupState, accessCache = _f.accessCache, ctx = _f.ctx, appContext = _f.appContext, propsOptions = _f.propsOptions;
        var normalizedProps;
        return !!accessCache[key] || data !== EMPTY_OBJ && hasOwn(data, key) || hasSetupBinding(setupState, key) || (normalizedProps = propsOptions[0]) && hasOwn(normalizedProps, key) || hasOwn(ctx, key) || hasOwn(publicPropertiesMap, key) || hasOwn(appContext.config.globalProperties, key);
    },
    defineProperty: function (target, key, descriptor) {
        if (descriptor.get != null) {
            target._.accessCache[key] = 0;
        }
        else if (hasOwn(descriptor, "value")) {
            this.set(target, key, descriptor.value, null);
        }
        return Reflect.defineProperty(target, key, descriptor);
    }
};
if (!!(process.env.NODE_ENV !== "production") && true) {
    PublicInstanceProxyHandlers.ownKeys = function (target) {
        warn$1("Avoid app logic that relies on enumerating keys on a component instance. The keys will be empty in production mode to avoid performance overhead.");
        return Reflect.ownKeys(target);
    };
}
var RuntimeCompiledPublicInstanceProxyHandlers = /* @__PURE__ */ extend({}, PublicInstanceProxyHandlers, {
    get: function (target, key) {
        if (key === Symbol.unscopables) {
            return;
        }
        return PublicInstanceProxyHandlers.get(target, key, target);
    },
    has: function (_, key) {
        var has = key[0] !== "_" && !isGloballyAllowed(key);
        if (!!(process.env.NODE_ENV !== "production") && !has && PublicInstanceProxyHandlers.has(_, key)) {
            warn$1("Property ".concat(JSON.stringify(key), " should not start with _ which is a reserved prefix for Vue internals."));
        }
        return has;
    }
});
function createDevRenderContext(instance) {
    var target = {};
    Object.defineProperty(target, "_", {
        configurable: true,
        enumerable: false,
        get: function () { return instance; }
    });
    Object.keys(publicPropertiesMap).forEach(function (key) {
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: function () { return publicPropertiesMap[key](instance); },
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: NOOP
        });
    });
    return target;
}
function exposePropsOnRenderContext(instance) {
    var ctx = instance.ctx, _e = __read(instance.propsOptions, 1), propsOptions = _e[0];
    if (propsOptions) {
        Object.keys(propsOptions).forEach(function (key) {
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: function () { return instance.props[key]; },
                set: NOOP
            });
        });
    }
}
function exposeSetupStateOnRenderContext(instance) {
    var ctx = instance.ctx, setupState = instance.setupState;
    Object.keys(toRaw(setupState)).forEach(function (key) {
        if (!setupState.__isScriptSetup) {
            if (isReservedPrefix(key[0])) {
                warn$1("setup() return property ".concat(JSON.stringify(key), " should not start with \"$\" or \"_\" which are reserved prefixes for Vue internals."));
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: function () { return setupState[key]; },
                set: NOOP
            });
        }
    });
}
var warnRuntimeUsage = function (method) { return warn$1("".concat(method, "() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect.")); };
function defineProps() {
    if (!!(process.env.NODE_ENV !== "production")) {
        warnRuntimeUsage("defineProps");
    }
    return null;
}
function defineEmits() {
    if (!!(process.env.NODE_ENV !== "production")) {
        warnRuntimeUsage("defineEmits");
    }
    return null;
}
function defineExpose(exposed) {
    if (!!(process.env.NODE_ENV !== "production")) {
        warnRuntimeUsage("defineExpose");
    }
}
function defineOptions(options) {
    if (!!(process.env.NODE_ENV !== "production")) {
        warnRuntimeUsage("defineOptions");
    }
}
function defineSlots() {
    if (!!(process.env.NODE_ENV !== "production")) {
        warnRuntimeUsage("defineSlots");
    }
    return null;
}
function defineModel() {
    if (!!(process.env.NODE_ENV !== "production")) {
        warnRuntimeUsage("defineModel");
    }
}
function withDefaults(props, defaults) {
    if (!!(process.env.NODE_ENV !== "production")) {
        warnRuntimeUsage("withDefaults");
    }
    return null;
}
function useSlots() {
    return getContext().slots;
}
function useAttrs() {
    return getContext().attrs;
}
function getContext() {
    var i = getCurrentInstance();
    if (!!(process.env.NODE_ENV !== "production") && !i) {
        warn$1("useContext() called without active instance.");
    }
    return i.setupContext || (i.setupContext = createSetupContext(i));
}
function normalizePropsOrEmits(props) {
    return isArray(props) ? props.reduce(function (normalized, p) { return (normalized[p] = null, normalized); }, {}) : props;
}
function mergeDefaults(raw, defaults) {
    var props = normalizePropsOrEmits(raw);
    for (var key in defaults) {
        if (key.startsWith("__skip"))
            continue;
        var opt = props[key];
        if (opt) {
            if (isArray(opt) || isFunction(opt)) {
                opt = props[key] = { type: opt, default: defaults[key] };
            }
            else {
                opt.default = defaults[key];
            }
        }
        else if (opt === null) {
            opt = props[key] = { default: defaults[key] };
        }
        else if (!!(process.env.NODE_ENV !== "production")) {
            warn$1("props default key \"".concat(key, "\" has no corresponding declaration."));
        }
        if (opt && defaults["__skip_".concat(key)]) {
            opt.skipFactory = true;
        }
    }
    return props;
}
function mergeModels(a, b) {
    if (!a || !b)
        return a || b;
    if (isArray(a) && isArray(b))
        return a.concat(b);
    return extend({}, normalizePropsOrEmits(a), normalizePropsOrEmits(b));
}
function createPropsRestProxy(props, excludedKeys) {
    var ret = {};
    var _loop_2 = function (key) {
        if (!excludedKeys.includes(key)) {
            Object.defineProperty(ret, key, {
                enumerable: true,
                get: function () { return props[key]; }
            });
        }
    };
    for (var key in props) {
        _loop_2(key);
    }
    return ret;
}
function withAsyncContext(getAwaitable) {
    var ctx = getCurrentInstance();
    if (!!(process.env.NODE_ENV !== "production") && !ctx) {
        warn$1("withAsyncContext called without active current instance. This is likely a bug.");
    }
    var awaitable = getAwaitable();
    unsetCurrentInstance();
    if (isPromise(awaitable)) {
        awaitable = awaitable.catch(function (e) {
            setCurrentInstance(ctx);
            throw e;
        });
    }
    return [awaitable, function () { return setCurrentInstance(ctx); }];
}
function createDuplicateChecker() {
    var cache = /* @__PURE__ */ Object.create(null);
    return function (type, key) {
        if (cache[key]) {
            warn$1("".concat(type, " property \"").concat(key, "\" is already defined in ").concat(cache[key], "."));
        }
        else {
            cache[key] = type;
        }
    };
}
var shouldCacheAccess = true;
function applyOptions(instance) {
    var options = resolveMergedOptions(instance);
    var publicThis = instance.proxy;
    var ctx = instance.ctx;
    shouldCacheAccess = false;
    if (options.beforeCreate) {
        callHook(options.beforeCreate, instance, "bc");
    }
    var 
    // state
    dataOptions = options.data, computedOptions = options.computed, methods = options.methods, watchOptions = options.watch, provideOptions = options.provide, injectOptions = options.inject, 
    // lifecycle
    created = options.created, beforeMount = options.beforeMount, mounted = options.mounted, beforeUpdate = options.beforeUpdate, updated = options.updated, activated = options.activated, deactivated = options.deactivated, beforeDestroy = options.beforeDestroy, beforeUnmount = options.beforeUnmount, destroyed = options.destroyed, unmounted = options.unmounted, render = options.render, renderTracked = options.renderTracked, renderTriggered = options.renderTriggered, errorCaptured = options.errorCaptured, serverPrefetch = options.serverPrefetch, 
    // public API
    expose = options.expose, inheritAttrs = options.inheritAttrs, 
    // assets
    components = options.components, directives = options.directives, filters = options.filters;
    var checkDuplicateProperties = !!(process.env.NODE_ENV !== "production") ? createDuplicateChecker() : null;
    if (!!(process.env.NODE_ENV !== "production")) {
        var _e = __read(instance.propsOptions, 1), propsOptions = _e[0];
        if (propsOptions) {
            for (var key in propsOptions) {
                checkDuplicateProperties("Props" /* PROPS */, key);
            }
        }
    }
    if (injectOptions) {
        resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    }
    if (methods) {
        for (var key in methods) {
            var methodHandler = methods[key];
            if (isFunction(methodHandler)) {
                if (!!(process.env.NODE_ENV !== "production")) {
                    Object.defineProperty(ctx, key, {
                        value: methodHandler.bind(publicThis),
                        configurable: true,
                        enumerable: true,
                        writable: true
                    });
                }
                else {
                    ctx[key] = methodHandler.bind(publicThis);
                }
                if (!!(process.env.NODE_ENV !== "production")) {
                    checkDuplicateProperties("Methods" /* METHODS */, key);
                }
            }
            else if (!!(process.env.NODE_ENV !== "production")) {
                warn$1("Method \"".concat(key, "\" has type \"").concat(typeof methodHandler, "\" in the component definition. Did you reference the function correctly?"));
            }
        }
    }
    if (dataOptions) {
        if (!!(process.env.NODE_ENV !== "production") && !isFunction(dataOptions)) {
            warn$1("The data option must be a function. Plain object usage is no longer supported.");
        }
        var data_1 = dataOptions.call(publicThis, publicThis);
        if (!!(process.env.NODE_ENV !== "production") && isPromise(data_1)) {
            warn$1("data() returned a Promise - note data() cannot be async; If you intend to perform data fetching before component renders, use async setup() + <Suspense>.");
        }
        if (!isObject(data_1)) {
            !!(process.env.NODE_ENV !== "production") && warn$1("data() should return an object.");
        }
        else {
            instance.data = reactive(data_1);
            if (!!(process.env.NODE_ENV !== "production")) {
                var _loop_3 = function (key) {
                    checkDuplicateProperties("Data" /* DATA */, key);
                    if (!isReservedPrefix(key[0])) {
                        Object.defineProperty(ctx, key, {
                            configurable: true,
                            enumerable: true,
                            get: function () { return data_1[key]; },
                            set: NOOP
                        });
                    }
                };
                for (var key in data_1) {
                    _loop_3(key);
                }
            }
        }
    }
    shouldCacheAccess = true;
    if (computedOptions) {
        var _loop_4 = function (key) {
            var opt = computedOptions[key];
            var get = isFunction(opt) ? opt.bind(publicThis, publicThis) : isFunction(opt.get) ? opt.get.bind(publicThis, publicThis) : NOOP;
            if (!!(process.env.NODE_ENV !== "production") && get === NOOP) {
                warn$1("Computed property \"".concat(key, "\" has no getter."));
            }
            var set = !isFunction(opt) && isFunction(opt.set) ? opt.set.bind(publicThis) : !!(process.env.NODE_ENV !== "production") ? function () {
                warn$1("Write operation failed: computed property \"".concat(key, "\" is readonly."));
            } : NOOP;
            var c = computed({
                get: get,
                set: set
            });
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: function () { return c.value; },
                set: function (v) { return c.value = v; }
            });
            if (!!(process.env.NODE_ENV !== "production")) {
                checkDuplicateProperties("Computed" /* COMPUTED */, key);
            }
        };
        for (var key in computedOptions) {
            _loop_4(key);
        }
    }
    if (watchOptions) {
        for (var key in watchOptions) {
            createWatcher(watchOptions[key], ctx, publicThis, key);
        }
    }
    if (provideOptions) {
        var provides_1 = isFunction(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides_1).forEach(function (key) {
            provide(key, provides_1[key]);
        });
    }
    if (created) {
        callHook(created, instance, "c");
    }
    function registerLifecycleHook(register, hook) {
        if (isArray(hook)) {
            hook.forEach(function (_hook) { return register(_hook.bind(publicThis)); });
        }
        else if (hook) {
            register(hook.bind(publicThis));
        }
    }
    registerLifecycleHook(onBeforeMount, beforeMount);
    registerLifecycleHook(onMounted, mounted);
    registerLifecycleHook(onBeforeUpdate, beforeUpdate);
    registerLifecycleHook(onUpdated, updated);
    registerLifecycleHook(onActivated, activated);
    registerLifecycleHook(onDeactivated, deactivated);
    registerLifecycleHook(onErrorCaptured, errorCaptured);
    registerLifecycleHook(onRenderTracked, renderTracked);
    registerLifecycleHook(onRenderTriggered, renderTriggered);
    registerLifecycleHook(onBeforeUnmount, beforeUnmount);
    registerLifecycleHook(onUnmounted, unmounted);
    registerLifecycleHook(onServerPrefetch, serverPrefetch);
    if (isArray(expose)) {
        if (expose.length) {
            var exposed_1 = instance.exposed || (instance.exposed = {});
            expose.forEach(function (key) {
                Object.defineProperty(exposed_1, key, {
                    get: function () { return publicThis[key]; },
                    set: function (val) { return publicThis[key] = val; }
                });
            });
        }
        else if (!instance.exposed) {
            instance.exposed = {};
        }
    }
    if (render && instance.render === NOOP) {
        instance.render = render;
    }
    if (inheritAttrs != null) {
        instance.inheritAttrs = inheritAttrs;
    }
    if (components)
        instance.components = components;
    if (directives)
        instance.directives = directives;
}
function resolveInjections(injectOptions, ctx, checkDuplicateProperties) {
    if (checkDuplicateProperties === void 0) { checkDuplicateProperties = NOOP; }
    if (isArray(injectOptions)) {
        injectOptions = normalizeInject(injectOptions);
    }
    var _loop_5 = function (key) {
        var opt = injectOptions[key];
        var injected;
        if (isObject(opt)) {
            if ("default" in opt) {
                injected = inject(opt.from || key, opt.default, true);
            }
            else {
                injected = inject(opt.from || key);
            }
        }
        else {
            injected = inject(opt);
        }
        if (isRef(injected)) {
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: function () { return injected.value; },
                set: function (v) { return injected.value = v; }
            });
        }
        else {
            ctx[key] = injected;
        }
        if (!!(process.env.NODE_ENV !== "production")) {
            checkDuplicateProperties("Inject" /* INJECT */, key);
        }
    };
    for (var key in injectOptions) {
        _loop_5(key);
    }
}
function callHook(hook, instance, type) {
    callWithAsyncErrorHandling(isArray(hook) ? hook.map(function (h) { return h.bind(instance.proxy); }) : hook.bind(instance.proxy), instance, type);
}
function createWatcher(raw, ctx, publicThis, key) {
    var getter = key.includes(".") ? createPathGetter(publicThis, key) : function () { return publicThis[key]; };
    if (isString(raw)) {
        var handler = ctx[raw];
        if (isFunction(handler)) {
            watch(getter, handler);
        }
        else if (!!(process.env.NODE_ENV !== "production")) {
            warn$1("Invalid watch handler specified by key \"".concat(raw, "\""), handler);
        }
    }
    else if (isFunction(raw)) {
        watch(getter, raw.bind(publicThis));
    }
    else if (isObject(raw)) {
        if (isArray(raw)) {
            raw.forEach(function (r) { return createWatcher(r, ctx, publicThis, key); });
        }
        else {
            var handler = isFunction(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if (isFunction(handler)) {
                watch(getter, handler, raw);
            }
            else if (!!(process.env.NODE_ENV !== "production")) {
                warn$1("Invalid watch handler specified by key \"".concat(raw.handler, "\""), handler);
            }
        }
    }
    else if (!!(process.env.NODE_ENV !== "production")) {
        warn$1("Invalid watch option: \"".concat(key, "\""), raw);
    }
}
function resolveMergedOptions(instance) {
    var base = instance.type;
    var mixins = base.mixins, extendsOptions = base.extends;
    var _e = instance.appContext, globalMixins = _e.mixins, cache = _e.optionsCache, optionMergeStrategies = _e.config.optionMergeStrategies;
    var cached = cache.get(base);
    var resolved;
    if (cached) {
        resolved = cached;
    }
    else if (!globalMixins.length && !mixins && !extendsOptions) {
        {
            resolved = base;
        }
    }
    else {
        resolved = {};
        if (globalMixins.length) {
            globalMixins.forEach(function (m) { return mergeOptions(resolved, m, optionMergeStrategies, true); });
        }
        mergeOptions(resolved, base, optionMergeStrategies);
    }
    if (isObject(base)) {
        cache.set(base, resolved);
    }
    return resolved;
}
function mergeOptions(to, from, strats, asMixin) {
    if (asMixin === void 0) { asMixin = false; }
    var mixins = from.mixins, extendsOptions = from.extends;
    if (extendsOptions) {
        mergeOptions(to, extendsOptions, strats, true);
    }
    if (mixins) {
        mixins.forEach(function (m) { return mergeOptions(to, m, strats, true); });
    }
    for (var key in from) {
        if (asMixin && key === "expose") {
            !!(process.env.NODE_ENV !== "production") && warn$1("\"expose\" option is ignored when declared in mixins or extends. It should only be declared in the base component itself.");
        }
        else {
            var strat = internalOptionMergeStrats[key] || strats && strats[key];
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
var internalOptionMergeStrats = {
    data: mergeDataFn,
    props: mergeEmitsOrPropsOptions,
    emits: mergeEmitsOrPropsOptions,
    // objects
    methods: mergeObjectOptions,
    computed: mergeObjectOptions,
    // lifecycle
    beforeCreate: mergeAsArray,
    created: mergeAsArray,
    beforeMount: mergeAsArray,
    mounted: mergeAsArray,
    beforeUpdate: mergeAsArray,
    updated: mergeAsArray,
    beforeDestroy: mergeAsArray,
    beforeUnmount: mergeAsArray,
    destroyed: mergeAsArray,
    unmounted: mergeAsArray,
    activated: mergeAsArray,
    deactivated: mergeAsArray,
    errorCaptured: mergeAsArray,
    serverPrefetch: mergeAsArray,
    // assets
    components: mergeObjectOptions,
    directives: mergeObjectOptions,
    // watch
    watch: mergeWatchOptions,
    // provide / inject
    provide: mergeDataFn,
    inject: mergeInject
};
function mergeDataFn(to, from) {
    if (!from) {
        return to;
    }
    if (!to) {
        return from;
    }
    return function mergedDataFn() {
        return (extend)(isFunction(to) ? to.call(this, this) : to, isFunction(from) ? from.call(this, this) : from);
    };
}
function mergeInject(to, from) {
    return mergeObjectOptions(normalizeInject(to), normalizeInject(from));
}
function normalizeInject(raw) {
    if (isArray(raw)) {
        var res = {};
        for (var i = 0; i < raw.length; i++) {
            res[raw[i]] = raw[i];
        }
        return res;
    }
    return raw;
}
function mergeAsArray(to, from) {
    return to ? __spreadArray([], __read(new Set([].concat(to, from))), false) : from;
}
function mergeObjectOptions(to, from) {
    return to ? extend(/* @__PURE__ */ Object.create(null), to, from) : from;
}
function mergeEmitsOrPropsOptions(to, from) {
    if (to) {
        if (isArray(to) && isArray(from)) {
            return __spreadArray([], __read(/* @__PURE__ */ new Set(__spreadArray(__spreadArray([], __read(to), false), __read(from), false))), false);
        }
        return extend(
        /* @__PURE__ */ Object.create(null), normalizePropsOrEmits(to), normalizePropsOrEmits(from != null ? from : {}));
    }
    else {
        return from;
    }
}
function mergeWatchOptions(to, from) {
    if (!to)
        return from;
    if (!from)
        return to;
    var merged = extend(/* @__PURE__ */ Object.create(null), to);
    for (var key in from) {
        merged[key] = mergeAsArray(to[key], from[key]);
    }
    return merged;
}
function createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: NO,
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: /* @__PURE__ */ Object.create(null),
        optionsCache: /* @__PURE__ */ new WeakMap(),
        propsCache: /* @__PURE__ */ new WeakMap(),
        emitsCache: /* @__PURE__ */ new WeakMap()
    };
}
var uid$1 = 0;
function createAppAPI(render, hydrate) {
    return function createApp(rootComponent, rootProps) {
        if (rootProps === void 0) { rootProps = null; }
        if (!isFunction(rootComponent)) {
            rootComponent = extend({}, rootComponent);
        }
        if (rootProps != null && !isObject(rootProps)) {
            !!(process.env.NODE_ENV !== "production") && warn$1("root props passed to app.mount() must be an object.");
            rootProps = null;
        }
        var context = createAppContext();
        var installedPlugins = /* @__PURE__ */ new WeakSet();
        var isMounted = false;
        var app = context.app = {
            _uid: uid$1++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version: version,
            get config() {
                return context.config;
            },
            set config(v) {
                if (!!(process.env.NODE_ENV !== "production")) {
                    warn$1("app.config cannot be replaced. Modify individual options instead.");
                }
            },
            use: function (plugin) {
                var options = [];
                for (var _i = 1; _i < arguments.length; _i++) {
                    options[_i - 1] = arguments[_i];
                }
                if (installedPlugins.has(plugin)) {
                    !!(process.env.NODE_ENV !== "production") && warn$1("Plugin has already been applied to target app.");
                }
                else if (plugin && isFunction(plugin.install)) {
                    installedPlugins.add(plugin);
                    plugin.install.apply(plugin, __spreadArray([app], __read(options), false));
                }
                else if (isFunction(plugin)) {
                    installedPlugins.add(plugin);
                    plugin.apply(void 0, __spreadArray([app], __read(options), false));
                }
                else if (!!(process.env.NODE_ENV !== "production")) {
                    warn$1("A plugin must either be a function or an object with an \"install\" function.");
                }
                return app;
            },
            mixin: function (mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) {
                        context.mixins.push(mixin);
                    }
                    else if (!!(process.env.NODE_ENV !== "production")) {
                        warn$1("Mixin has already been applied to target app" + (mixin.name ? ": ".concat(mixin.name) : ""));
                    }
                }
                else if (!!(process.env.NODE_ENV !== "production")) {
                    warn$1("Mixins are only available in builds supporting Options API");
                }
                return app;
            },
            component: function (name, component) {
                if (!!(process.env.NODE_ENV !== "production")) {
                    validateComponentName(name, context.config);
                }
                if (!component) {
                    return context.components[name];
                }
                if (!!(process.env.NODE_ENV !== "production") && context.components[name]) {
                    warn$1("Component \"".concat(name, "\" has already been registered in target app."));
                }
                context.components[name] = component;
                return app;
            },
            directive: function (name, directive) {
                if (!!(process.env.NODE_ENV !== "production")) {
                    validateDirectiveName(name);
                }
                if (!directive) {
                    return context.directives[name];
                }
                if (!!(process.env.NODE_ENV !== "production") && context.directives[name]) {
                    warn$1("Directive \"".concat(name, "\" has already been registered in target app."));
                }
                context.directives[name] = directive;
                return app;
            },
            mount: function (rootContainer, isHydrate, namespace) {
                if (!isMounted) {
                    if (!!(process.env.NODE_ENV !== "production") && rootContainer.__vue_app__) {
                        warn$1("There is already an app instance mounted on the host container.\n If you want to mount another app on the same host container, you need to unmount the previous app by calling `app.unmount()` first.");
                    }
                    var vnode_1 = createVNode(rootComponent, rootProps);
                    vnode_1.appContext = context;
                    if (namespace === true) {
                        namespace = "svg";
                    }
                    else if (namespace === false) {
                        namespace = void 0;
                    }
                    if (!!(process.env.NODE_ENV !== "production")) {
                        context.reload = function () {
                            render(cloneVNode(vnode_1), rootContainer, namespace);
                        };
                    }
                    if (isHydrate && hydrate) {
                        hydrate(vnode_1, rootContainer);
                    }
                    else {
                        render(vnode_1, rootContainer, namespace);
                    }
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (!!(process.env.NODE_ENV !== "production") || __VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode_1.component;
                        devtoolsInitApp(app, version);
                    }
                    return getExposeProxy(vnode_1.component) || vnode_1.component.proxy;
                }
                else if (!!(process.env.NODE_ENV !== "production")) {
                    warn$1("App has already been mounted.\nIf you want to remount the same app, move your app creation logic into a factory function and create fresh app instances for each mount - e.g. `const createMyApp = () => createApp(App)`");
                }
            },
            unmount: function () {
                if (isMounted) {
                    render(null, app._container);
                    if (!!(process.env.NODE_ENV !== "production") || __VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
                else if (!!(process.env.NODE_ENV !== "production")) {
                    warn$1("Cannot unmount an app that is not mounted.");
                }
            },
            provide: function (key, value) {
                if (!!(process.env.NODE_ENV !== "production") && key in context.provides) {
                    warn$1("App already provides property with key \"".concat(String(key), "\". It will be overwritten with the new value."));
                }
                context.provides[key] = value;
                return app;
            },
            runWithContext: function (fn) {
                var lastApp = currentApp;
                currentApp = app;
                try {
                    return fn();
                }
                finally {
                    currentApp = lastApp;
                }
            }
        };
        return app;
    };
}
var currentApp = null;
function provide(key, value) {
    if (!currentInstance) {
        if (!!(process.env.NODE_ENV !== "production")) {
            warn$1("provide() can only be used inside setup().");
        }
    }
    else {
        var provides = currentInstance.provides;
        var parentProvides = currentInstance.parent && currentInstance.parent.provides;
        if (parentProvides === provides) {
            provides = currentInstance.provides = Object.create(parentProvides);
        }
        provides[key] = value;
    }
}
function inject(key, defaultValue, treatDefaultAsFactory) {
    if (treatDefaultAsFactory === void 0) { treatDefaultAsFactory = false; }
    var instance = currentInstance || currentRenderingInstance;
    if (instance || currentApp) {
        var provides = instance ? instance.parent == null ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : currentApp._context.provides;
        if (provides && key in provides) {
            return provides[key];
        }
        else if (arguments.length > 1) {
            return treatDefaultAsFactory && isFunction(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
        }
        else if (!!(process.env.NODE_ENV !== "production")) {
            warn$1("injection \"".concat(String(key), "\" not found."));
        }
    }
    else if (!!(process.env.NODE_ENV !== "production")) {
        warn$1("inject() can only be used inside setup() or functional components.");
    }
}
function hasInjectionContext() {
    return !!(currentInstance || currentRenderingInstance || currentApp);
}
var internalObjectProto = {};
var createInternalObject = function () { return Object.create(internalObjectProto); };
var isInternalObject = function (obj) { return Object.getPrototypeOf(obj) === internalObjectProto; };
function initProps(instance, rawProps, isStateful, isSSR) {
    if (isSSR === void 0) { isSSR = false; }
    var props = {};
    var attrs = createInternalObject();
    instance.propsDefaults = /* @__PURE__ */ Object.create(null);
    setFullProps(instance, rawProps, props, attrs);
    for (var key in instance.propsOptions[0]) {
        if (!(key in props)) {
            props[key] = void 0;
        }
    }
    if (!!(process.env.NODE_ENV !== "production")) {
        validateProps(rawProps || {}, props, instance);
    }
    if (isStateful) {
        instance.props = isSSR ? props : shallowReactive(props);
    }
    else {
        if (!instance.type.props) {
            instance.props = attrs;
        }
        else {
            instance.props = props;
        }
    }
    instance.attrs = attrs;
}
function isInHmrContext(instance) {
    while (instance) {
        if (instance.type.__hmrId)
            return true;
        instance = instance.parent;
    }
}
function updateProps(instance, rawProps, rawPrevProps, optimized) {
    var props = instance.props, attrs = instance.attrs, patchFlag = instance.vnode.patchFlag;
    var rawCurrentProps = toRaw(props);
    var _e = __read(instance.propsOptions, 1), options = _e[0];
    var hasAttrsChanged = false;
    if (
    // always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    !(!!(process.env.NODE_ENV !== "production") && isInHmrContext(instance)) && (optimized || patchFlag > 0) && !(patchFlag & 16)) {
        if (patchFlag & 8) {
            var propsToUpdate = instance.vnode.dynamicProps;
            for (var i = 0; i < propsToUpdate.length; i++) {
                var key = propsToUpdate[i];
                if (isEmitListener(instance.emitsOptions, key)) {
                    continue;
                }
                var value = rawProps[key];
                if (options) {
                    if (hasOwn(attrs, key)) {
                        if (value !== attrs[key]) {
                            attrs[key] = value;
                            hasAttrsChanged = true;
                        }
                    }
                    else {
                        var camelizedKey = camelize(key);
                        props[camelizedKey] = resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance, false);
                    }
                }
                else {
                    if (value !== attrs[key]) {
                        attrs[key] = value;
                        hasAttrsChanged = true;
                    }
                }
            }
        }
    }
    else {
        if (setFullProps(instance, rawProps, props, attrs)) {
            hasAttrsChanged = true;
        }
        var kebabKey = void 0;
        for (var key in rawCurrentProps) {
            if (!rawProps || // for camelCase
                !hasOwn(rawProps, key) && // it's possible the original props was passed in as kebab-case
                    // and converted to camelCase (#955)
                    ((kebabKey = hyphenate(key)) === key || !hasOwn(rawProps, kebabKey))) {
                if (options) {
                    if (rawPrevProps && // for camelCase
                        (rawPrevProps[key] !== void 0 || // for kebab-case
                            rawPrevProps[kebabKey] !== void 0)) {
                        props[key] = resolvePropValue(options, rawCurrentProps, key, void 0, instance, true);
                    }
                }
                else {
                    delete props[key];
                }
            }
        }
        if (attrs !== rawCurrentProps) {
            for (var key in attrs) {
                if (!rawProps || !hasOwn(rawProps, key) && true) {
                    delete attrs[key];
                    hasAttrsChanged = true;
                }
            }
        }
    }
    if (hasAttrsChanged) {
        trigger(instance.attrs, "set", "");
    }
    if (!!(process.env.NODE_ENV !== "production")) {
        validateProps(rawProps || {}, props, instance);
    }
}
function setFullProps(instance, rawProps, props, attrs) {
    var _e = __read(instance.propsOptions, 2), options = _e[0], needCastKeys = _e[1];
    var hasAttrsChanged = false;
    var rawCastValues;
    if (rawProps) {
        for (var key in rawProps) {
            if (isReservedProp(key)) {
                continue;
            }
            var value = rawProps[key];
            var camelKey = void 0;
            if (options && hasOwn(options, camelKey = camelize(key))) {
                if (!needCastKeys || !needCastKeys.includes(camelKey)) {
                    props[camelKey] = value;
                }
                else {
                    (rawCastValues || (rawCastValues = {}))[camelKey] = value;
                }
            }
            else if (!isEmitListener(instance.emitsOptions, key)) {
                if (!(key in attrs) || value !== attrs[key]) {
                    attrs[key] = value;
                    hasAttrsChanged = true;
                }
            }
        }
    }
    if (needCastKeys) {
        var rawCurrentProps = toRaw(props);
        var castValues = rawCastValues || EMPTY_OBJ;
        for (var i = 0; i < needCastKeys.length; i++) {
            var key = needCastKeys[i];
            props[key] = resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !hasOwn(castValues, key));
        }
    }
    return hasAttrsChanged;
}
function resolvePropValue(options, props, key, value, instance, isAbsent) {
    var opt = options[key];
    if (opt != null) {
        var hasDefault = hasOwn(opt, "default");
        if (hasDefault && value === void 0) {
            var defaultValue = opt.default;
            if (opt.type !== Function && !opt.skipFactory && isFunction(defaultValue)) {
                var propsDefaults = instance.propsDefaults;
                if (key in propsDefaults) {
                    value = propsDefaults[key];
                }
                else {
                    var reset = setCurrentInstance(instance);
                    value = propsDefaults[key] = defaultValue.call(null, props);
                    reset();
                }
            }
            else {
                value = defaultValue;
            }
        }
        if (opt[0 /* shouldCast */]) {
            if (isAbsent && !hasDefault) {
                value = false;
            }
            else if (opt[1 /* shouldCastTrue */] && (value === "" || value === hyphenate(key))) {
                value = true;
            }
        }
    }
    return value;
}
function normalizePropsOptions(comp, appContext, asMixin) {
    if (asMixin === void 0) { asMixin = false; }
    var cache = appContext.propsCache;
    var cached = cache.get(comp);
    if (cached) {
        return cached;
    }
    var raw = comp.props;
    var normalized = {};
    var needCastKeys = [];
    var hasExtends = false;
    if (__VUE_OPTIONS_API__ && !isFunction(comp)) {
        var extendProps = function (raw2) {
            hasExtends = true;
            var _e = __read(normalizePropsOptions(raw2, appContext, true), 2), props = _e[0], keys = _e[1];
            extend(normalized, props);
            if (keys)
                needCastKeys.push.apply(needCastKeys, __spreadArray([], __read(keys), false));
        };
        if (!asMixin && appContext.mixins.length) {
            appContext.mixins.forEach(extendProps);
        }
        if (comp.extends) {
            extendProps(comp.extends);
        }
        if (comp.mixins) {
            comp.mixins.forEach(extendProps);
        }
    }
    if (!raw && !hasExtends) {
        if (isObject(comp)) {
            cache.set(comp, EMPTY_ARR);
        }
        return EMPTY_ARR;
    }
    if (isArray(raw)) {
        for (var i = 0; i < raw.length; i++) {
            if (!!(process.env.NODE_ENV !== "production") && !isString(raw[i])) {
                warn$1("props must be strings when using array syntax.", raw[i]);
            }
            var normalizedKey = camelize(raw[i]);
            if (validatePropName(normalizedKey)) {
                normalized[normalizedKey] = EMPTY_OBJ;
            }
        }
    }
    else if (raw) {
        if (!!(process.env.NODE_ENV !== "production") && !isObject(raw)) {
            warn$1("invalid props options", raw);
        }
        for (var key in raw) {
            var normalizedKey = camelize(key);
            if (validatePropName(normalizedKey)) {
                var opt = raw[key];
                var prop = normalized[normalizedKey] = isArray(opt) || isFunction(opt) ? { type: opt } : extend({}, opt);
                if (prop) {
                    var booleanIndex = getTypeIndex(Boolean, prop.type);
                    var stringIndex = getTypeIndex(String, prop.type);
                    prop[0 /* shouldCast */] = booleanIndex > -1;
                    prop[1 /* shouldCastTrue */] = stringIndex < 0 || booleanIndex < stringIndex;
                    if (booleanIndex > -1 || hasOwn(prop, "default")) {
                        needCastKeys.push(normalizedKey);
                    }
                }
            }
        }
    }
    var res = [normalized, needCastKeys];
    if (isObject(comp)) {
        cache.set(comp, res);
    }
    return res;
}
function validatePropName(key) {
    if (key[0] !== "$" && !isReservedProp(key)) {
        return true;
    }
    else if (!!(process.env.NODE_ENV !== "production")) {
        warn$1("Invalid prop name: \"".concat(key, "\" is a reserved property."));
    }
    return false;
}
function getType(ctor) {
    if (ctor === null) {
        return "null";
    }
    if (typeof ctor === "function") {
        return ctor.name || "";
    }
    else if (typeof ctor === "object") {
        var name = ctor.constructor && ctor.constructor.name;
        return name || "";
    }
    return "";
}
function isSameType(a, b) {
    return getType(a) === getType(b);
}
function getTypeIndex(type, expectedTypes) {
    if (isArray(expectedTypes)) {
        return expectedTypes.findIndex(function (t) { return isSameType(t, type); });
    }
    else if (isFunction(expectedTypes)) {
        return isSameType(expectedTypes, type) ? 0 : -1;
    }
    return -1;
}
function validateProps(rawProps, props, instance) {
    var resolvedValues = toRaw(props);
    var options = instance.propsOptions[0];
    for (var key in options) {
        var opt = options[key];
        if (opt == null)
            continue;
        validateProp(key, resolvedValues[key], opt, !!(process.env.NODE_ENV !== "production") ? shallowReadonly(resolvedValues) : resolvedValues, !hasOwn(rawProps, key) && !hasOwn(rawProps, hyphenate(key)));
    }
}
function validateProp(name, value, prop, props, isAbsent) {
    var type = prop.type, required = prop.required, validator = prop.validator, skipCheck = prop.skipCheck;
    if (required && isAbsent) {
        warn$1('Missing required prop: "' + name + '"');
        return;
    }
    if (value == null && !required) {
        return;
    }
    if (type != null && type !== true && !skipCheck) {
        var isValid = false;
        var types = isArray(type) ? type : [type];
        var expectedTypes = [];
        for (var i = 0; i < types.length && !isValid; i++) {
            var _e = assertType(value, types[i]), valid = _e.valid, expectedType = _e.expectedType;
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            warn$1(getInvalidTypeMessage(name, value, expectedTypes));
            return;
        }
    }
    if (validator && !validator(value, props)) {
        warn$1('Invalid prop: custom validator check failed for prop "' + name + '".');
    }
}
var isSimpleType = /* @__PURE__ */ makeMap("String,Number,Boolean,Function,Symbol,BigInt");
function assertType(value, type) {
    var valid;
    var expectedType = getType(type);
    if (isSimpleType(expectedType)) {
        var t = typeof value;
        valid = t === expectedType.toLowerCase();
        if (!valid && t === "object") {
            valid = value instanceof type;
        }
    }
    else if (expectedType === "Object") {
        valid = isObject(value);
    }
    else if (expectedType === "Array") {
        valid = isArray(value);
    }
    else if (expectedType === "null") {
        valid = value === null;
    }
    else {
        valid = value instanceof type;
    }
    return {
        valid: valid,
        expectedType: expectedType
    };
}
function getInvalidTypeMessage(name, value, expectedTypes) {
    if (expectedTypes.length === 0) {
        return "Prop type [] for prop \"".concat(name, "\" won't match anything. Did you mean to use type Array instead?");
    }
    var message = "Invalid prop: type check failed for prop \"".concat(name, "\". Expected ").concat(expectedTypes.map(capitalize).join(" | "));
    var expectedType = expectedTypes[0];
    var receivedType = toRawType(value);
    var expectedValue = styleValue(value, expectedType);
    var receivedValue = styleValue(value, receivedType);
    if (expectedTypes.length === 1 && isExplicable(expectedType) && !isBoolean(expectedType, receivedType)) {
        message += " with value ".concat(expectedValue);
    }
    message += ", got ".concat(receivedType, " ");
    if (isExplicable(receivedType)) {
        message += "with value ".concat(receivedValue, ".");
    }
    return message;
}
function styleValue(value, type) {
    if (type === "String") {
        return "\"".concat(value, "\"");
    }
    else if (type === "Number") {
        return "".concat(Number(value));
    }
    else {
        return "".concat(value);
    }
}
function isExplicable(type) {
    var explicitTypes = ["string", "number", "boolean"];
    return explicitTypes.some(function (elem) { return type.toLowerCase() === elem; });
}
function isBoolean() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return args.some(function (elem) { return elem.toLowerCase() === "boolean"; });
}
var isInternalKey = function (key) { return key[0] === "_" || key === "$stable"; };
var normalizeSlotValue = function (value) { return isArray(value) ? value.map(normalizeVNode) : [normalizeVNode(value)]; };
var normalizeSlot = function (key, rawSlot, ctx) {
    if (rawSlot._n) {
        return rawSlot;
    }
    var normalized = withCtx(function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!!(process.env.NODE_ENV !== "production") && currentInstance && (!ctx || ctx.root === currentInstance.root)) {
            warn$1("Slot \"".concat(key, "\" invoked outside of the render function: this will not track dependencies used in the slot. Invoke the slot function inside the render function instead."));
        }
        return normalizeSlotValue(rawSlot.apply(void 0, __spreadArray([], __read(args), false)));
    }, ctx);
    normalized._c = false;
    return normalized;
};
var normalizeObjectSlots = function (rawSlots, slots, instance) {
    var ctx = rawSlots._ctx;
    var _loop_6 = function (key) {
        if (isInternalKey(key))
            return "continue";
        var value = rawSlots[key];
        if (isFunction(value)) {
            slots[key] = normalizeSlot(key, value, ctx);
        }
        else if (value != null) {
            if (!!(process.env.NODE_ENV !== "production") && true) {
                warn$1("Non-function value encountered for slot \"".concat(key, "\". Prefer function slots for better performance."));
            }
            var normalized_1 = normalizeSlotValue(value);
            slots[key] = function () { return normalized_1; };
        }
    };
    for (var key in rawSlots) {
        _loop_6(key);
    }
};
var normalizeVNodeSlots = function (instance, children) {
    if (!!(process.env.NODE_ENV !== "production") && !isKeepAlive(instance.vnode) && true) {
        warn$1("Non-function value encountered for default slot. Prefer function slots for better performance.");
    }
    var normalized = normalizeSlotValue(children);
    instance.slots.default = function () { return normalized; };
};
var initSlots = function (instance, children) {
    var slots = instance.slots = createInternalObject();
    if (instance.vnode.shapeFlag & 32) {
        var type = children._;
        if (type) {
            extend(slots, children);
            def(slots, "_", type, true);
        }
        else {
            normalizeObjectSlots(children, slots);
        }
    }
    else if (children) {
        normalizeVNodeSlots(instance, children);
    }
};
var updateSlots = function (instance, children, optimized) {
    var vnode = instance.vnode, slots = instance.slots;
    var needDeletionCheck = true;
    var deletionComparisonTarget = EMPTY_OBJ;
    if (vnode.shapeFlag & 32) {
        var type = children._;
        if (type) {
            if (!!(process.env.NODE_ENV !== "production") && isHmrUpdating) {
                extend(slots, children);
                trigger(instance, "set", "$slots");
            }
            else if (optimized && type === 1) {
                needDeletionCheck = false;
            }
            else {
                extend(slots, children);
                if (!optimized && type === 1) {
                    delete slots._;
                }
            }
        }
        else {
            needDeletionCheck = !children.$stable;
            normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    }
    else if (children) {
        normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = { default: 1 };
    }
    if (needDeletionCheck) {
        for (var key in slots) {
            if (!isInternalKey(key) && deletionComparisonTarget[key] == null) {
                delete slots[key];
            }
        }
    }
};
function setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount) {
    if (isUnmount === void 0) { isUnmount = false; }
    if (isArray(rawRef)) {
        rawRef.forEach(function (r, i) { return setRef(r, oldRawRef && (isArray(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount); });
        return;
    }
    if (isAsyncWrapper(vnode) && !isUnmount) {
        return;
    }
    var refValue = vnode.shapeFlag & 4 ? getExposeProxy(vnode.component) || vnode.component.proxy : vnode.el;
    var value = isUnmount ? null : refValue;
    var owner = rawRef.i, ref = rawRef.r;
    if (!!(process.env.NODE_ENV !== "production") && !owner) {
        warn$1("Missing ref owner context. ref cannot be used on hoisted vnodes. A vnode with ref must be created inside the render function.");
        return;
    }
    var oldRef = oldRawRef && oldRawRef.r;
    var refs = owner.refs === EMPTY_OBJ ? owner.refs = {} : owner.refs;
    var setupState = owner.setupState;
    if (oldRef != null && oldRef !== ref) {
        if (isString(oldRef)) {
            refs[oldRef] = null;
            if (hasOwn(setupState, oldRef)) {
                setupState[oldRef] = null;
            }
        }
        else if (isRef(oldRef)) {
            oldRef.value = null;
        }
    }
    if (isFunction(ref)) {
        callWithErrorHandling(ref, owner, 12, [value, refs]);
    }
    else {
        var _isString_1 = isString(ref);
        var _isRef_1 = isRef(ref);
        if (_isString_1 || _isRef_1) {
            var doSet = function () {
                if (rawRef.f) {
                    var existing = _isString_1 ? hasOwn(setupState, ref) ? setupState[ref] : refs[ref] : ref.value;
                    if (isUnmount) {
                        isArray(existing) && remove(existing, refValue);
                    }
                    else {
                        if (!isArray(existing)) {
                            if (_isString_1) {
                                refs[ref] = [refValue];
                                if (hasOwn(setupState, ref)) {
                                    setupState[ref] = refs[ref];
                                }
                            }
                            else {
                                ref.value = [refValue];
                                if (rawRef.k)
                                    refs[rawRef.k] = ref.value;
                            }
                        }
                        else if (!existing.includes(refValue)) {
                            existing.push(refValue);
                        }
                    }
                }
                else if (_isString_1) {
                    refs[ref] = value;
                    if (hasOwn(setupState, ref)) {
                        setupState[ref] = value;
                    }
                }
                else if (_isRef_1) {
                    ref.value = value;
                    if (rawRef.k)
                        refs[rawRef.k] = value;
                }
                else if (!!(process.env.NODE_ENV !== "production")) {
                    warn$1("Invalid template ref type:", ref, "(".concat(typeof ref, ")"));
                }
            };
            if (value) {
                doSet.id = -1;
                queuePostRenderEffect(doSet, parentSuspense);
            }
            else {
                doSet();
            }
        }
        else if (!!(process.env.NODE_ENV !== "production")) {
            warn$1("Invalid template ref type:", ref, "(".concat(typeof ref, ")"));
        }
    }
}
var hasMismatch = false;
var isSVGContainer = function (container) { return container.namespaceURI.includes("svg") && container.tagName !== "foreignObject"; };
var isMathMLContainer = function (container) { return container.namespaceURI.includes("MathML"); };
var getContainerType = function (container) {
    if (isSVGContainer(container))
        return "svg";
    if (isMathMLContainer(container))
        return "mathml";
    return void 0;
};
var isComment = function (node) { return node.nodeType === 8; } /* COMMENT */;
function createHydrationFunctions(rendererInternals) {
    var mountComponent = rendererInternals.mt, patch = rendererInternals.p, _e = rendererInternals.o, patchProp = _e.patchProp, createText = _e.createText, nextSibling = _e.nextSibling, parentNode = _e.parentNode, remove = _e.remove, insert = _e.insert, createComment = _e.createComment;
    var hydrate = function (vnode, container) {
        if (!container.hasChildNodes()) {
            (!!(process.env.NODE_ENV !== "production") || __VUE_PROD_HYDRATION_MISMATCH_DETAILS__) && warn$1("Attempting to hydrate existing markup but container is empty. Performing full mount instead.");
            patch(null, vnode, container);
            flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        hasMismatch = false;
        hydrateNode(container.firstChild, vnode, null, null, null);
        flushPostFlushCbs();
        container._vnode = vnode;
        if (hasMismatch && true) {
            console.error("Hydration completed but contains mismatches.");
        }
    };
    var hydrateNode = function (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized) {
        if (optimized === void 0) { optimized = false; }
        optimized = optimized || !!vnode.dynamicChildren;
        var isFragmentStart = isComment(node) && node.data === "[";
        var onMismatch = function () { return handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart); };
        var type = vnode.type, ref = vnode.ref, shapeFlag = vnode.shapeFlag, patchFlag = vnode.patchFlag;
        var domType = node.nodeType;
        vnode.el = node;
        if (!!(process.env.NODE_ENV !== "production") || __VUE_PROD_DEVTOOLS__) {
            if (!("__vnode" in node)) {
                Object.defineProperty(node, "__vnode", {
                    value: vnode,
                    enumerable: false
                });
            }
            if (!("__vueParentComponent" in node)) {
                Object.defineProperty(node, "__vueParentComponent", {
                    value: parentComponent,
                    enumerable: false
                });
            }
        }
        if (patchFlag === -2) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        var nextNode = null;
        switch (type) {
            case Text:
                if (domType !== 3 /* TEXT */) {
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    }
                    else {
                        nextNode = onMismatch();
                    }
                }
                else {
                    if (node.data !== vnode.children) {
                        hasMismatch = true;
                        (!!(process.env.NODE_ENV !== "production") || __VUE_PROD_HYDRATION_MISMATCH_DETAILS__) && warn$1("Hydration text mismatch in", node.parentNode, "\n  - rendered on server: ".concat(JSON.stringify(node.data), "\n  - expected on client: ").concat(JSON.stringify(vnode.children)));
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case Comment:
                if (isTemplateNode(node)) {
                    nextNode = nextSibling(node);
                    replaceNode(vnode.el = node.content.firstChild, node, parentComponent);
                }
                else if (domType !== 8 /* COMMENT */ || isFragmentStart) {
                    nextNode = onMismatch();
                }
                else {
                    nextNode = nextSibling(node);
                }
                break;
            case Static:
                if (isFragmentStart) {
                    node = nextSibling(node);
                    domType = node.nodeType;
                }
                if (domType === 1 /* ELEMENT */ || domType === 3 /* TEXT */) {
                    nextNode = node;
                    var needToAdoptContent = !vnode.children.length;
                    for (var i = 0; i < vnode.staticCount; i++) {
                        if (needToAdoptContent)
                            vnode.children += nextNode.nodeType === 1 /* ELEMENT */ ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) {
                            vnode.anchor = nextNode;
                        }
                        nextNode = nextSibling(nextNode);
                    }
                    return isFragmentStart ? nextSibling(nextNode) : nextNode;
                }
                else {
                    onMismatch();
                }
                break;
            case Fragment:
                if (!isFragmentStart) {
                    nextNode = onMismatch();
                }
                else {
                    nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                }
                break;
            default:
                if (shapeFlag & 1) {
                    if ((domType !== 1 /* ELEMENT */ || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) && !isTemplateNode(node)) {
                        nextNode = onMismatch();
                    }
                    else {
                        nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                    }
                }
                else if (shapeFlag & 6) {
                    vnode.slotScopeIds = slotScopeIds;
                    var container = parentNode(node);
                    if (isFragmentStart) {
                        nextNode = locateClosingAnchor(node);
                    }
                    else if (isComment(node) && node.data === "teleport start") {
                        nextNode = locateClosingAnchor(node, node.data, "teleport end");
                    }
                    else {
                        nextNode = nextSibling(node);
                    }
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, getContainerType(container), optimized);
                    if (isAsyncWrapper(vnode)) {
                        var subTree = void 0;
                        if (isFragmentStart) {
                            subTree = createVNode(Fragment);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        }
                        else {
                            subTree = node.nodeType === 3 ? createTextVNode("") : createVNode("div");
                        }
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                }
                else if (shapeFlag & 64) {
                    if (domType !== 8 /* COMMENT */) {
                        nextNode = onMismatch();
                    }
                    else {
                        nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                    }
                }
                else if (shapeFlag & 128) {
                    nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, getContainerType(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
                }
                else if (!!(process.env.NODE_ENV !== "production") || __VUE_PROD_HYDRATION_MISMATCH_DETAILS__) {
                    warn$1("Invalid HostVNode type:", type, "(".concat(typeof type, ")"));
                }
        }
        if (ref != null) {
            setRef(ref, null, parentSuspense, vnode);
        }
        return nextNode;
    };
    var hydrateElement = function (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized) {
        optimized = optimized || !!vnode.dynamicChildren;
        var type = vnode.type, props = vnode.props, patchFlag = vnode.patchFlag, shapeFlag = vnode.shapeFlag, dirs = vnode.dirs, transition = vnode.transition;
        var forcePatch = type === "input" || type === "option";
        if (!!(process.env.NODE_ENV !== "production") || forcePatch || patchFlag !== -1) {
            if (dirs) {
                invokeDirectiveHook(vnode, null, parentComponent, "created");
            }
            var needCallTransitionHooks_1 = false;
            if (isTemplateNode(el)) {
                needCallTransitionHooks_1 = needTransition(parentSuspense, transition) && parentComponent && parentComponent.vnode.props && parentComponent.vnode.props.appear;
                var content = el.content.firstChild;
                if (needCallTransitionHooks_1) {
                    transition.beforeEnter(content);
                }
                replaceNode(content, el, parentComponent);
                vnode.el = el = content;
            }
            if (shapeFlag & 16 && // skip if element has innerHTML / textContent
                !(props && (props.innerHTML || props.textContent))) {
                var next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                var hasWarned_1 = false;
                while (next) {
                    hasMismatch = true;
                    if ((!!(process.env.NODE_ENV !== "production") || __VUE_PROD_HYDRATION_MISMATCH_DETAILS__) && !hasWarned_1) {
                        warn$1("Hydration children mismatch on", el, "\nServer rendered element contains more child nodes than client vdom.");
                        hasWarned_1 = true;
                    }
                    var cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            }
            else if (shapeFlag & 8) {
                if (el.textContent !== vnode.children) {
                    hasMismatch = true;
                    (!!(process.env.NODE_ENV !== "production") || __VUE_PROD_HYDRATION_MISMATCH_DETAILS__) && warn$1("Hydration text content mismatch on", el, "\n  - rendered on server: ".concat(el.textContent, "\n  - expected on client: ").concat(vnode.children));
                    el.textContent = vnode.children;
                }
            }
            if (props) {
                if (!!(process.env.NODE_ENV !== "production") || __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ || forcePatch || !optimized || patchFlag & (16 | 32)) {
                    for (var key in props) {
                        if ((!!(process.env.NODE_ENV !== "production") || __VUE_PROD_HYDRATION_MISMATCH_DETAILS__) && propHasMismatch(el, key, props[key], vnode, parentComponent)) {
                            hasMismatch = true;
                        }
                        if (forcePatch && (key.endsWith("value") || key === "indeterminate") || isOn(key) && !isReservedProp(key) || // force hydrate v-bind with .prop modifiers
                            key[0] === ".") {
                            patchProp(el, key, null, props[key], void 0, void 0, parentComponent);
                        }
                    }
                }
                else if (props.onClick) {
                    patchProp(el, "onClick", null, props.onClick, void 0, void 0, parentComponent);
                }
            }
            var vnodeHooks_1;
            if (vnodeHooks_1 = props && props.onVnodeBeforeMount) {
                invokeVNodeHook(vnodeHooks_1, parentComponent, vnode);
            }
            if (dirs) {
                invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            }
            if ((vnodeHooks_1 = props && props.onVnodeMounted) || dirs || needCallTransitionHooks_1) {
                queueEffectWithSuspense(function () {
                    vnodeHooks_1 && invokeVNodeHook(vnodeHooks_1, parentComponent, vnode);
                    needCallTransitionHooks_1 && transition.enter(el);
                    dirs && invokeDirectiveHook(vnode, null, parentComponent, "mounted");
                }, parentSuspense);
            }
        }
        return el.nextSibling;
    };
    var hydrateChildren = function (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized) {
        optimized = optimized || !!parentVNode.dynamicChildren;
        var children = parentVNode.children;
        var l = children.length;
        var hasWarned = false;
        for (var i = 0; i < l; i++) {
            var vnode = optimized ? children[i] : children[i] = normalizeVNode(children[i]);
            if (node) {
                node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
            else if (vnode.type === Text && !vnode.children) {
                continue;
            }
            else {
                hasMismatch = true;
                if ((!!(process.env.NODE_ENV !== "production") || __VUE_PROD_HYDRATION_MISMATCH_DETAILS__) && !hasWarned) {
                    warn$1("Hydration children mismatch on", container, "\nServer rendered element contains fewer child nodes than client vdom.");
                    hasWarned = true;
                }
                patch(null, vnode, container, null, parentComponent, parentSuspense, getContainerType(container), slotScopeIds);
            }
        }
        return node;
    };
    var hydrateFragment = function (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized) {
        var fragmentSlotScopeIds = vnode.slotScopeIds;
        if (fragmentSlotScopeIds) {
            slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        }
        var container = parentNode(node);
        var next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && isComment(next) && next.data === "]") {
            return nextSibling(vnode.anchor = next);
        }
        else {
            hasMismatch = true;
            insert(vnode.anchor = createComment("]"), container, next);
            return next;
        }
    };
    var handleMismatch = function (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment) {
        hasMismatch = true;
        (!!(process.env.NODE_ENV !== "production") || __VUE_PROD_HYDRATION_MISMATCH_DETAILS__) && warn$1("Hydration node mismatch:\n- rendered on server:", node, node.nodeType === 3 /* TEXT */ ? "(text)" : isComment(node) && node.data === "[" ? "(start of fragment)" : "", "\n- expected on client:", vnode.type);
        vnode.el = null;
        if (isFragment) {
            var end = locateClosingAnchor(node);
            while (true) {
                var next2 = nextSibling(node);
                if (next2 && next2 !== end) {
                    remove(next2);
                }
                else {
                    break;
                }
            }
        }
        var next = nextSibling(node);
        var container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, getContainerType(container), slotScopeIds);
        return next;
    };
    var locateClosingAnchor = function (node, open, close) {
        if (open === void 0) { open = "["; }
        if (close === void 0) { close = "]"; }
        var match = 0;
        while (node) {
            node = nextSibling(node);
            if (node && isComment(node)) {
                if (node.data === open)
                    match++;
                if (node.data === close) {
                    if (match === 0) {
                        return nextSibling(node);
                    }
                    else {
                        match--;
                    }
                }
            }
        }
        return node;
    };
    var replaceNode = function (newNode, oldNode, parentComponent) {
        var parentNode2 = oldNode.parentNode;
        if (parentNode2) {
            parentNode2.replaceChild(newNode, oldNode);
        }
        var parent = parentComponent;
        while (parent) {
            if (parent.vnode.el === oldNode) {
                parent.vnode.el = parent.subTree.el = newNode;
            }
            parent = parent.parent;
        }
    };
    var isTemplateNode = function (node) {
        return node.nodeType === 1 /* ELEMENT */ && node.tagName.toLowerCase() === "template";
    };
    return [hydrate, hydrateNode];
}
function propHasMismatch(el, key, clientValue, vnode, instance) {
    var e_4, _e;
    var _a;
    var mismatchType;
    var mismatchKey;
    var actual;
    var expected;
    if (key === "class") {
        actual = el.getAttribute("class");
        expected = normalizeClass(clientValue);
        if (!isSetEqual(toClassSet(actual || ""), toClassSet(expected))) {
            mismatchType = mismatchKey = "class";
        }
    }
    else if (key === "style") {
        actual = el.getAttribute("style");
        expected = isString(clientValue) ? clientValue : stringifyStyle(normalizeStyle(clientValue));
        var actualMap = toStyleMap(actual);
        var expectedMap = toStyleMap(expected);
        if (vnode.dirs) {
            try {
                for (var _f = __values(vnode.dirs), _g = _f.next(); !_g.done; _g = _f.next()) {
                    var _h = _g.value, dir = _h.dir, value = _h.value;
                    if (dir.name === "show" && !value) {
                        expectedMap.set("display", "none");
                    }
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (_g && !_g.done && (_e = _f.return)) _e.call(_f);
                }
                finally { if (e_4) throw e_4.error; }
            }
        }
        var root = instance == null ? void 0 : instance.subTree;
        if (vnode === root || (root == null ? void 0 : root.type) === Fragment && root.children.includes(vnode)) {
            var cssVars = (_a = instance == null ? void 0 : instance.getCssVars) == null ? void 0 : _a.call(instance);
            for (var key2 in cssVars) {
                expectedMap.set("--".concat(key2), String(cssVars[key2]));
            }
        }
        if (!isMapEqual(actualMap, expectedMap)) {
            mismatchType = mismatchKey = "style";
        }
    }
    else if (el instanceof SVGElement && isKnownSvgAttr(key) || el instanceof HTMLElement && (isBooleanAttr(key) || isKnownHtmlAttr(key))) {
        if (isBooleanAttr(key)) {
            actual = el.hasAttribute(key);
            expected = includeBooleanAttr(clientValue);
        }
        else if (clientValue == null) {
            actual = el.hasAttribute(key);
            expected = false;
        }
        else {
            if (el.hasAttribute(key)) {
                actual = el.getAttribute(key);
            }
            else if (key === "value" && el.tagName === "TEXTAREA") {
                actual = el.value;
            }
            else {
                actual = false;
            }
            expected = isRenderableAttrValue(clientValue) ? String(clientValue) : false;
        }
        if (actual !== expected) {
            mismatchType = "attribute";
            mismatchKey = key;
        }
    }
    if (mismatchType) {
        var format = function (v) { return v === false ? "(not rendered)" : "".concat(mismatchKey, "=\"").concat(v, "\""); };
        var preSegment = "Hydration ".concat(mismatchType, " mismatch on");
        var postSegment = "\n  - rendered on server: ".concat(format(actual), "\n  - expected on client: ").concat(format(expected), "\n  Note: this mismatch is check-only. The DOM will not be rectified in production due to performance overhead.\n  You should fix the source of the mismatch.");
        {
            warn$1(preSegment, el, postSegment);
        }
        return true;
    }
    return false;
}
function toClassSet(str) {
    return new Set(str.trim().split(/\s+/));
}
function isSetEqual(a, b) {
    var e_5, _e;
    if (a.size !== b.size) {
        return false;
    }
    try {
        for (var a_1 = __values(a), a_1_1 = a_1.next(); !a_1_1.done; a_1_1 = a_1.next()) {
            var s = a_1_1.value;
            if (!b.has(s)) {
                return false;
            }
        }
    }
    catch (e_5_1) { e_5 = { error: e_5_1 }; }
    finally {
        try {
            if (a_1_1 && !a_1_1.done && (_e = a_1.return)) _e.call(a_1);
        }
        finally { if (e_5) throw e_5.error; }
    }
    return true;
}
function toStyleMap(str) {
    var e_6, _e;
    var styleMap = /* @__PURE__ */ new Map();
    try {
        for (var _f = __values(str.split(";")), _g = _f.next(); !_g.done; _g = _f.next()) {
            var item = _g.value;
            var _h = __read(item.split(":"), 2), key = _h[0], value = _h[1];
            key = key == null ? void 0 : key.trim();
            value = value == null ? void 0 : value.trim();
            if (key && value) {
                styleMap.set(key, value);
            }
        }
    }
    catch (e_6_1) { e_6 = { error: e_6_1 }; }
    finally {
        try {
            if (_g && !_g.done && (_e = _f.return)) _e.call(_f);
        }
        finally { if (e_6) throw e_6.error; }
    }
    return styleMap;
}
function isMapEqual(a, b) {
    var e_7, _e;
    if (a.size !== b.size) {
        return false;
    }
    try {
        for (var a_2 = __values(a), a_2_1 = a_2.next(); !a_2_1.done; a_2_1 = a_2.next()) {
            var _f = __read(a_2_1.value, 2), key = _f[0], value = _f[1];
            if (value !== b.get(key)) {
                return false;
            }
        }
    }
    catch (e_7_1) { e_7 = { error: e_7_1 }; }
    finally {
        try {
            if (a_2_1 && !a_2_1.done && (_e = a_2.return)) _e.call(a_2);
        }
        finally { if (e_7) throw e_7.error; }
    }
    return true;
}
var supported;
var perf;
function startMeasure(instance, type) {
    if (instance.appContext.config.performance && isSupported()) {
        perf.mark("vue-".concat(type, "-").concat(instance.uid));
    }
    if (!!(process.env.NODE_ENV !== "production") || __VUE_PROD_DEVTOOLS__) {
        devtoolsPerfStart(instance, type, isSupported() ? perf.now() : Date.now());
    }
}
function endMeasure(instance, type) {
    if (instance.appContext.config.performance && isSupported()) {
        var startTag = "vue-".concat(type, "-").concat(instance.uid);
        var endTag = startTag + ":end";
        perf.mark(endTag);
        perf.measure("<".concat(formatComponentName(instance, instance.type), "> ").concat(type), startTag, endTag);
        perf.clearMarks(startTag);
        perf.clearMarks(endTag);
    }
    if (!!(process.env.NODE_ENV !== "production") || __VUE_PROD_DEVTOOLS__) {
        devtoolsPerfEnd(instance, type, isSupported() ? perf.now() : Date.now());
    }
}
function isSupported() {
    if (supported !== void 0) {
        return supported;
    }
    if (typeof window !== "undefined" && window.performance) {
        supported = true;
        perf = window.performance;
    }
    else {
        supported = false;
    }
    return supported;
}
function initFeatureFlags() {
    var needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") {
        !!(process.env.NODE_ENV !== "production") && needWarn.push("__VUE_OPTIONS_API__");
        getGlobalThis().__VUE_OPTIONS_API__ = true;
    }
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") {
        !!(process.env.NODE_ENV !== "production") && needWarn.push("__VUE_PROD_DEVTOOLS__");
        getGlobalThis().__VUE_PROD_DEVTOOLS__ = false;
    }
    if (typeof __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ !== "boolean") {
        !!(process.env.NODE_ENV !== "production") && needWarn.push("__VUE_PROD_HYDRATION_MISMATCH_DETAILS__");
        getGlobalThis().__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
    }
    if (!!(process.env.NODE_ENV !== "production") && needWarn.length) {
        var multi = needWarn.length > 1;
        console.warn("Feature flag".concat(multi ? "s" : "", " ").concat(needWarn.join(", "), " ").concat(multi ? "are" : "is", " not explicitly defined. You are running the esm-bundler build of Vue, which expects these compile-time feature flags to be globally injected via the bundler config in order to get better tree-shaking in the production bundle.\n\nFor more details, see https://link.vuejs.org/feature-flags."));
    }
}
var queuePostRenderEffect = queueEffectWithSuspense;
function createRenderer(options) {
    return baseCreateRenderer(options);
}
function createHydrationRenderer(options) {
    return baseCreateRenderer(options, createHydrationFunctions);
}
function baseCreateRenderer(options, createHydrationFns) {
    var _e;
    {
        initFeatureFlags();
    }
    var target = getGlobalThis();
    target.__VUE__ = true;
    if (!!(process.env.NODE_ENV !== "production") || __VUE_PROD_DEVTOOLS__) {
        setDevtoolsHook$1(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    }
    var hostInsert = options.insert, hostRemove = options.remove, hostPatchProp = options.patchProp, hostCreateElement = options.createElement, hostCreateText = options.createText, hostCreateComment = options.createComment, hostSetText = options.setText, hostSetElementText = options.setElementText, hostParentNode = options.parentNode, hostNextSibling = options.nextSibling, _f = options.setScopeId, hostSetScopeId = _f === void 0 ? NOOP : _f, hostInsertStaticContent = options.insertStaticContent;
    var patch = function (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) {
        if (anchor === void 0) { anchor = null; }
        if (parentComponent === void 0) { parentComponent = null; }
        if (parentSuspense === void 0) { parentSuspense = null; }
        if (namespace === void 0) { namespace = void 0; }
        if (slotScopeIds === void 0) { slotScopeIds = null; }
        if (optimized === void 0) { optimized = !!(process.env.NODE_ENV !== "production") && isHmrUpdating ? false : !!n2.dynamicChildren; }
        if (n1 === n2) {
            return;
        }
        if (n1 && !isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        var type = n2.type, ref = n2.ref, shapeFlag = n2.shapeFlag;
        switch (type) {
            case Text:
                processText(n1, n2, container, anchor);
                break;
            case Comment:
                processCommentNode(n1, n2, container, anchor);
                break;
            case Static:
                if (n1 == null) {
                    mountStaticNode(n2, container, anchor, namespace);
                }
                else if (!!(process.env.NODE_ENV !== "production")) {
                    patchStaticNode(n1, n2, container, namespace);
                }
                break;
            case Fragment:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) {
                    processElement(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                }
                else if (shapeFlag & 6) {
                    processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                }
                else if (shapeFlag & 64) {
                    type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                }
                else if (shapeFlag & 128) {
                    type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                }
                else if (!!(process.env.NODE_ENV !== "production")) {
                    warn$1("Invalid VNode type:", type, "(".concat(typeof type, ")"));
                }
        }
        if (ref != null && parentComponent) {
            setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
        }
    };
    var processText = function (n1, n2, container, anchor) {
        if (n1 == null) {
            hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        }
        else {
            var el = n2.el = n1.el;
            if (n2.children !== n1.children) {
                hostSetText(el, n2.children);
            }
        }
    };
    var processCommentNode = function (n1, n2, container, anchor) {
        if (n1 == null) {
            hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        }
        else {
            n2.el = n1.el;
        }
    };
    var mountStaticNode = function (n2, container, anchor, namespace) {
        var _e;
        _e = __read(hostInsertStaticContent(n2.children, container, anchor, namespace, n2.el, n2.anchor), 2), n2.el = _e[0], n2.anchor = _e[1];
    };
    var patchStaticNode = function (n1, n2, container, namespace) {
        var _e;
        if (n2.children !== n1.children) {
            var anchor = hostNextSibling(n1.anchor);
            removeStaticNode(n1);
            _e = __read(hostInsertStaticContent(n2.children, container, anchor, namespace), 2), n2.el = _e[0], n2.anchor = _e[1];
        }
        else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    var moveStaticNode = function (_e, container, nextSibling) {
        var el = _e.el, anchor = _e.anchor;
        var next;
        while (el && el !== anchor) {
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    var removeStaticNode = function (_e) {
        var el = _e.el, anchor = _e.anchor;
        var next;
        while (el && el !== anchor) {
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    var processElement = function (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) {
        if (n2.type === "svg") {
            namespace = "svg";
        }
        else if (n2.type === "math") {
            namespace = "mathml";
        }
        if (n1 == null) {
            mountElement(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
        else {
            patchElement(n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    var mountElement = function (vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) {
        var el;
        var vnodeHook;
        var props = vnode.props, shapeFlag = vnode.shapeFlag, transition = vnode.transition, dirs = vnode.dirs;
        el = vnode.el = hostCreateElement(vnode.type, namespace, props && props.is, props);
        if (shapeFlag & 8) {
            hostSetElementText(el, vnode.children);
        }
        else if (shapeFlag & 16) {
            mountChildren(vnode.children, el, null, parentComponent, parentSuspense, resolveChildrenNamespace(vnode, namespace), slotScopeIds, optimized);
        }
        if (dirs) {
            invokeDirectiveHook(vnode, null, parentComponent, "created");
        }
        setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        if (props) {
            for (var key in props) {
                if (key !== "value" && !isReservedProp(key)) {
                    hostPatchProp(el, key, null, props[key], namespace, vnode.children, parentComponent, parentSuspense, unmountChildren);
                }
            }
            if ("value" in props) {
                hostPatchProp(el, "value", null, props.value, namespace);
            }
            if (vnodeHook = props.onVnodeBeforeMount) {
                invokeVNodeHook(vnodeHook, parentComponent, vnode);
            }
        }
        if (!!(process.env.NODE_ENV !== "production") || __VUE_PROD_DEVTOOLS__) {
            Object.defineProperty(el, "__vnode", {
                value: vnode,
                enumerable: false
            });
            Object.defineProperty(el, "__vueParentComponent", {
                value: parentComponent,
                enumerable: false
            });
        }
        if (dirs) {
            invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        }
        var needCallTransitionHooks = needTransition(parentSuspense, transition);
        if (needCallTransitionHooks) {
            transition.beforeEnter(el);
        }
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) {
            queuePostRenderEffect(function () {
                vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
        }
    };
    var setScopeId = function (el, vnode, scopeId, slotScopeIds, parentComponent) {
        if (scopeId) {
            hostSetScopeId(el, scopeId);
        }
        if (slotScopeIds) {
            for (var i = 0; i < slotScopeIds.length; i++) {
                hostSetScopeId(el, slotScopeIds[i]);
            }
        }
        if (parentComponent) {
            var subTree = parentComponent.subTree;
            if (!!(process.env.NODE_ENV !== "production") && subTree.patchFlag > 0 && subTree.patchFlag & 2048) {
                subTree = filterSingleRoot(subTree.children) || subTree;
            }
            if (vnode === subTree) {
                var parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    var mountChildren = function (children, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, start) {
        if (start === void 0) { start = 0; }
        for (var i = start; i < children.length; i++) {
            var child = children[i] = optimized ? cloneIfMounted(children[i]) : normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    var patchElement = function (n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) {
        var el = n2.el = n1.el;
        var patchFlag = n2.patchFlag, dynamicChildren = n2.dynamicChildren, dirs = n2.dirs;
        patchFlag |= n1.patchFlag & 16;
        var oldProps = n1.props || EMPTY_OBJ;
        var newProps = n2.props || EMPTY_OBJ;
        var vnodeHook;
        parentComponent && toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) {
            invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        }
        if (dirs) {
            invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        }
        parentComponent && toggleRecurse(parentComponent, true);
        if (!!(process.env.NODE_ENV !== "production") && isHmrUpdating) {
            patchFlag = 0;
            optimized = false;
            dynamicChildren = null;
        }
        if (dynamicChildren) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, resolveChildrenNamespace(n2, namespace), slotScopeIds);
            if (!!(process.env.NODE_ENV !== "production")) {
                traverseStaticChildren(n1, n2);
            }
        }
        else if (!optimized) {
            patchChildren(n1, n2, el, null, parentComponent, parentSuspense, resolveChildrenNamespace(n2, namespace), slotScopeIds, false);
        }
        if (patchFlag > 0) {
            if (patchFlag & 16) {
                patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, namespace);
            }
            else {
                if (patchFlag & 2) {
                    if (oldProps.class !== newProps.class) {
                        hostPatchProp(el, "class", null, newProps.class, namespace);
                    }
                }
                if (patchFlag & 4) {
                    hostPatchProp(el, "style", oldProps.style, newProps.style, namespace);
                }
                if (patchFlag & 8) {
                    var propsToUpdate = n2.dynamicProps;
                    for (var i = 0; i < propsToUpdate.length; i++) {
                        var key = propsToUpdate[i];
                        var prev = oldProps[key];
                        var next = newProps[key];
                        if (next !== prev || key === "value") {
                            hostPatchProp(el, key, prev, next, namespace, n1.children, parentComponent, parentSuspense, unmountChildren);
                        }
                    }
                }
            }
            if (patchFlag & 1) {
                if (n1.children !== n2.children) {
                    hostSetElementText(el, n2.children);
                }
            }
        }
        else if (!optimized && dynamicChildren == null) {
            patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, namespace);
        }
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) {
            queuePostRenderEffect(function () {
                vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
                dirs && invokeDirectiveHook(n2, n1, parentComponent, "updated");
            }, parentSuspense);
        }
    };
    var patchBlockChildren = function (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, namespace, slotScopeIds) {
        for (var i = 0; i < newChildren.length; i++) {
            var oldVNode = oldChildren[i];
            var newVNode = newChildren[i];
            var container = (
            // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
                // of the Fragment itself so it can move its children.
                (oldVNode.type === Fragment || // - In the case of different nodes, there is going to be a replacement
                    // which also requires the correct parent container
                    !isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
                    oldVNode.shapeFlag & (6 | 64)) ? hostParentNode(oldVNode.el) : (
            // In other cases, the parent container is not actually used so we
            // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer));
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, true);
        }
    };
    var patchProps = function (el, vnode, oldProps, newProps, parentComponent, parentSuspense, namespace) {
        if (oldProps !== newProps) {
            if (oldProps !== EMPTY_OBJ) {
                for (var key in oldProps) {
                    if (!isReservedProp(key) && !(key in newProps)) {
                        hostPatchProp(el, key, oldProps[key], null, namespace, vnode.children, parentComponent, parentSuspense, unmountChildren);
                    }
                }
            }
            for (var key in newProps) {
                if (isReservedProp(key))
                    continue;
                var next = newProps[key];
                var prev = oldProps[key];
                if (next !== prev && key !== "value") {
                    hostPatchProp(el, key, prev, next, namespace, vnode.children, parentComponent, parentSuspense, unmountChildren);
                }
            }
            if ("value" in newProps) {
                hostPatchProp(el, "value", oldProps.value, newProps.value, namespace);
            }
        }
    };
    var processFragment = function (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) {
        var fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        var fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        var patchFlag = n2.patchFlag, dynamicChildren = n2.dynamicChildren, fragmentSlotScopeIds = n2.slotScopeIds;
        if (!!(process.env.NODE_ENV !== "production") && // #5523 dev root fragment may inherit directives
            (isHmrUpdating || patchFlag & 2048)) {
            patchFlag = 0;
            optimized = false;
            dynamicChildren = null;
        }
        if (fragmentSlotScopeIds) {
            slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        }
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            mountChildren(
            // #10007
            // such fragment like `<></>` will be compiled into
            // a fragment which doesn't have a children.
            // In this case fallback to an empty array
            n2.children || [], container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
        else {
            if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
                // of renderSlot() with no valid children
                n1.dynamicChildren) {
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, namespace, slotScopeIds);
                if (!!(process.env.NODE_ENV !== "production")) {
                    traverseStaticChildren(n1, n2);
                }
                else if (
                // #2080 if the stable fragment has a key, it's a <template v-for> that may
                //  get moved around. Make sure all root level vnodes inherit el.
                // #2134 or if it's a component root, it may also get moved around
                // as the component is being moved.
                n2.key != null || parentComponent && n2 === parentComponent.subTree) {
                    traverseStaticChildren(n1, n2, true
                    /* shallow */
                    );
                }
            }
            else {
                patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            }
        }
    };
    var processComponent = function (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) {
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512) {
                parentComponent.ctx.activate(n2, container, anchor, namespace, optimized);
            }
            else {
                mountComponent(n2, container, anchor, parentComponent, parentSuspense, namespace, optimized);
            }
        }
        else {
            updateComponent(n1, n2, optimized);
        }
    };
    var mountComponent = function (initialVNode, container, anchor, parentComponent, parentSuspense, namespace, optimized) {
        var instance = (initialVNode.component = createComponentInstance(initialVNode, parentComponent, parentSuspense));
        if (!!(process.env.NODE_ENV !== "production") && instance.type.__hmrId) {
            registerHMR(instance);
        }
        if (!!(process.env.NODE_ENV !== "production")) {
            pushWarningContext(initialVNode);
            startMeasure(instance, "mount");
        }
        if (isKeepAlive(initialVNode)) {
            instance.ctx.renderer = internals;
        }
        {
            if (!!(process.env.NODE_ENV !== "production")) {
                startMeasure(instance, "init");
            }
            setupComponent(instance);
            if (!!(process.env.NODE_ENV !== "production")) {
                endMeasure(instance, "init");
            }
        }
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect);
            if (!initialVNode.el) {
                var placeholder = instance.subTree = createVNode(Comment);
                processCommentNode(null, placeholder, container, anchor);
            }
        }
        else {
            setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, namespace, optimized);
        }
        if (!!(process.env.NODE_ENV !== "production")) {
            popWarningContext();
            endMeasure(instance, "mount");
        }
    };
    var updateComponent = function (n1, n2, optimized) {
        var instance = n2.component = n1.component;
        if (shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                if (!!(process.env.NODE_ENV !== "production")) {
                    pushWarningContext(n2);
                }
                updateComponentPreRender(instance, n2, optimized);
                if (!!(process.env.NODE_ENV !== "production")) {
                    popWarningContext();
                }
                return;
            }
            else {
                instance.next = n2;
                invalidateJob(instance.update);
                instance.effect.dirty = true;
                instance.update();
            }
        }
        else {
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    var setupRenderEffect = function (instance, initialVNode, container, anchor, parentSuspense, namespace, optimized) {
        var componentUpdateFn = function () {
            if (!instance.isMounted) {
                var vnodeHook_1;
                var el_1 = initialVNode.el, props = initialVNode.props;
                var bm = instance.bm, m = instance.m, parent_1 = instance.parent;
                var isAsyncWrapperVNode = isAsyncWrapper(initialVNode);
                toggleRecurse(instance, false);
                if (bm) {
                    invokeArrayFns(bm);
                }
                if (!isAsyncWrapperVNode && (vnodeHook_1 = props && props.onVnodeBeforeMount)) {
                    invokeVNodeHook(vnodeHook_1, parent_1, initialVNode);
                }
                toggleRecurse(instance, true);
                if (el_1 && hydrateNode) {
                    var hydrateSubTree_1 = function () {
                        if (!!(process.env.NODE_ENV !== "production")) {
                            startMeasure(instance, "render");
                        }
                        instance.subTree = renderComponentRoot(instance);
                        if (!!(process.env.NODE_ENV !== "production")) {
                            endMeasure(instance, "render");
                        }
                        if (!!(process.env.NODE_ENV !== "production")) {
                            startMeasure(instance, "hydrate");
                        }
                        hydrateNode(el_1, instance.subTree, instance, parentSuspense, null);
                        if (!!(process.env.NODE_ENV !== "production")) {
                            endMeasure(instance, "hydrate");
                        }
                    };
                    if (isAsyncWrapperVNode) {
                        initialVNode.type.__asyncLoader().then(
                        // note: we are moving the render call into an async callback,
                        // which means it won't track dependencies - but it's ok because
                        // a server-rendered async wrapper is already in resolved state
                        // and it will never need to change.
                        function () { return !instance.isUnmounted && hydrateSubTree_1(); });
                    }
                    else {
                        hydrateSubTree_1();
                    }
                }
                else {
                    if (!!(process.env.NODE_ENV !== "production")) {
                        startMeasure(instance, "render");
                    }
                    var subTree = instance.subTree = renderComponentRoot(instance);
                    if (!!(process.env.NODE_ENV !== "production")) {
                        endMeasure(instance, "render");
                    }
                    if (!!(process.env.NODE_ENV !== "production")) {
                        startMeasure(instance, "patch");
                    }
                    patch(null, subTree, container, anchor, instance, parentSuspense, namespace);
                    if (!!(process.env.NODE_ENV !== "production")) {
                        endMeasure(instance, "patch");
                    }
                    initialVNode.el = subTree.el;
                }
                if (m) {
                    queuePostRenderEffect(m, parentSuspense);
                }
                if (!isAsyncWrapperVNode && (vnodeHook_1 = props && props.onVnodeMounted)) {
                    var scopedInitialVNode_1 = initialVNode;
                    queuePostRenderEffect(function () { return invokeVNodeHook(vnodeHook_1, parent_1, scopedInitialVNode_1); }, parentSuspense);
                }
                if (initialVNode.shapeFlag & 256 || parent_1 && isAsyncWrapper(parent_1.vnode) && parent_1.vnode.shapeFlag & 256) {
                    instance.a && queuePostRenderEffect(instance.a, parentSuspense);
                }
                instance.isMounted = true;
                if (!!(process.env.NODE_ENV !== "production") || __VUE_PROD_DEVTOOLS__) {
                    devtoolsComponentAdded(instance);
                }
                initialVNode = container = anchor = null;
            }
            else {
                var next_1 = instance.next, bu = instance.bu, u = instance.u, parent_2 = instance.parent, vnode_2 = instance.vnode;
                {
                    var nonHydratedAsyncRoot = locateNonHydratedAsyncRoot(instance);
                    if (nonHydratedAsyncRoot) {
                        if (next_1) {
                            next_1.el = vnode_2.el;
                            updateComponentPreRender(instance, next_1, optimized);
                        }
                        nonHydratedAsyncRoot.asyncDep.then(function () {
                            if (!instance.isUnmounted) {
                                componentUpdateFn();
                            }
                        });
                        return;
                    }
                }
                var originNext = next_1;
                var vnodeHook_2;
                if (!!(process.env.NODE_ENV !== "production")) {
                    pushWarningContext(next_1 || instance.vnode);
                }
                toggleRecurse(instance, false);
                if (next_1) {
                    next_1.el = vnode_2.el;
                    updateComponentPreRender(instance, next_1, optimized);
                }
                else {
                    next_1 = vnode_2;
                }
                if (bu) {
                    invokeArrayFns(bu);
                }
                if (vnodeHook_2 = next_1.props && next_1.props.onVnodeBeforeUpdate) {
                    invokeVNodeHook(vnodeHook_2, parent_2, next_1, vnode_2);
                }
                toggleRecurse(instance, true);
                if (!!(process.env.NODE_ENV !== "production")) {
                    startMeasure(instance, "render");
                }
                var nextTree = renderComponentRoot(instance);
                if (!!(process.env.NODE_ENV !== "production")) {
                    endMeasure(instance, "render");
                }
                var prevTree = instance.subTree;
                instance.subTree = nextTree;
                if (!!(process.env.NODE_ENV !== "production")) {
                    startMeasure(instance, "patch");
                }
                patch(prevTree, nextTree, 
                // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), 
                // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, namespace);
                if (!!(process.env.NODE_ENV !== "production")) {
                    endMeasure(instance, "patch");
                }
                next_1.el = nextTree.el;
                if (originNext === null) {
                    updateHOCHostEl(instance, nextTree.el);
                }
                if (u) {
                    queuePostRenderEffect(u, parentSuspense);
                }
                if (vnodeHook_2 = next_1.props && next_1.props.onVnodeUpdated) {
                    queuePostRenderEffect(function () { return invokeVNodeHook(vnodeHook_2, parent_2, next_1, vnode_2); }, parentSuspense);
                }
                if (!!(process.env.NODE_ENV !== "production") || __VUE_PROD_DEVTOOLS__) {
                    devtoolsComponentUpdated(instance);
                }
                if (!!(process.env.NODE_ENV !== "production")) {
                    popWarningContext();
                }
            }
        };
        var effect = instance.effect = new ReactiveEffect(componentUpdateFn, NOOP, function () { return queueJob(update); }, instance.scope
        // track it in component's effect scope
        );
        var update = instance.update = function () {
            if (effect.dirty) {
                effect.run();
            }
        };
        update.id = instance.uid;
        toggleRecurse(instance, true);
        if (!!(process.env.NODE_ENV !== "production")) {
            effect.onTrack = instance.rtc ? function (e) { return invokeArrayFns(instance.rtc, e); } : void 0;
            effect.onTrigger = instance.rtg ? function (e) { return invokeArrayFns(instance.rtg, e); } : void 0;
            update.ownerInstance = instance;
        }
        update();
    };
    var updateComponentPreRender = function (instance, nextVNode, optimized) {
        nextVNode.component = instance;
        var prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        updateProps(instance, nextVNode.props, prevProps, optimized);
        updateSlots(instance, nextVNode.children, optimized);
        pauseTracking();
        flushPreFlushCbs(instance);
        resetTracking();
    };
    var patchChildren = function (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) {
        if (optimized === void 0) { optimized = false; }
        var c1 = n1 && n1.children;
        var prevShapeFlag = n1 ? n1.shapeFlag : 0;
        var c2 = n2.children;
        var patchFlag = n2.patchFlag, shapeFlag = n2.shapeFlag;
        if (patchFlag > 0) {
            if (patchFlag & 128) {
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            }
            else if (patchFlag & 256) {
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            }
        }
        if (shapeFlag & 8) {
            if (prevShapeFlag & 16) {
                unmountChildren(c1, parentComponent, parentSuspense);
            }
            if (c2 !== c1) {
                hostSetElementText(container, c2);
            }
        }
        else {
            if (prevShapeFlag & 16) {
                if (shapeFlag & 16) {
                    patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                }
                else {
                    unmountChildren(c1, parentComponent, parentSuspense, true);
                }
            }
            else {
                if (prevShapeFlag & 8) {
                    hostSetElementText(container, "");
                }
                if (shapeFlag & 16) {
                    mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                }
            }
        }
    };
    var patchUnkeyedChildren = function (c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) {
        c1 = c1 || EMPTY_ARR;
        c2 = c2 || EMPTY_ARR;
        var oldLength = c1.length;
        var newLength = c2.length;
        var commonLength = Math.min(oldLength, newLength);
        var i;
        for (i = 0; i < commonLength; i++) {
            var nextChild = c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
        if (oldLength > newLength) {
            unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        }
        else {
            mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, commonLength);
        }
    };
    var patchKeyedChildren = function (c1, c2, container, parentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) {
        var i = 0;
        var l2 = c2.length;
        var e1 = c1.length - 1;
        var e2 = l2 - 1;
        while (i <= e1 && i <= e2) {
            var n1 = c1[i];
            var n2 = c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]);
            if (isSameVNodeType(n1, n2)) {
                patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            }
            else {
                break;
            }
            i++;
        }
        while (i <= e1 && i <= e2) {
            var n1 = c1[e1];
            var n2 = c2[e2] = optimized ? cloneIfMounted(c2[e2]) : normalizeVNode(c2[e2]);
            if (isSameVNodeType(n1, n2)) {
                patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            }
            else {
                break;
            }
            e1--;
            e2--;
        }
        if (i > e1) {
            if (i <= e2) {
                var nextPos = e2 + 1;
                var anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while (i <= e2) {
                    patch(null, c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    i++;
                }
            }
        }
        else if (i > e2) {
            while (i <= e1) {
                unmount(c1[i], parentComponent, parentSuspense, true);
                i++;
            }
        }
        else {
            var s1 = i;
            var s2 = i;
            var keyToNewIndexMap = /* @__PURE__ */ new Map();
            for (i = s2; i <= e2; i++) {
                var nextChild = c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]);
                if (nextChild.key != null) {
                    if (!!(process.env.NODE_ENV !== "production") && keyToNewIndexMap.has(nextChild.key)) {
                        warn$1("Duplicate keys found during update:", JSON.stringify(nextChild.key), "Make sure keys are unique.");
                    }
                    keyToNewIndexMap.set(nextChild.key, i);
                }
            }
            var j = void 0;
            var patched = 0;
            var toBePatched = e2 - s2 + 1;
            var moved = false;
            var maxNewIndexSoFar = 0;
            var newIndexToOldIndexMap = new Array(toBePatched);
            for (i = 0; i < toBePatched; i++)
                newIndexToOldIndexMap[i] = 0;
            for (i = s1; i <= e1; i++) {
                var prevChild = c1[i];
                if (patched >= toBePatched) {
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                var newIndex = void 0;
                if (prevChild.key != null) {
                    newIndex = keyToNewIndexMap.get(prevChild.key);
                }
                else {
                    for (j = s2; j <= e2; j++) {
                        if (newIndexToOldIndexMap[j - s2] === 0 && isSameVNodeType(prevChild, c2[j])) {
                            newIndex = j;
                            break;
                        }
                    }
                }
                if (newIndex === void 0) {
                    unmount(prevChild, parentComponent, parentSuspense, true);
                }
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) {
                        maxNewIndexSoFar = newIndex;
                    }
                    else {
                        moved = true;
                    }
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    patched++;
                }
            }
            var increasingNewIndexSequence = moved ? getSequence(newIndexToOldIndexMap) : EMPTY_ARR;
            j = increasingNewIndexSequence.length - 1;
            for (i = toBePatched - 1; i >= 0; i--) {
                var nextIndex = s2 + i;
                var nextChild = c2[nextIndex];
                var anchor = nextIndex + 1 < l2 ? c2[nextIndex + 1].el : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) {
                    patch(null, nextChild, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                }
                else if (moved) {
                    if (j < 0 || i !== increasingNewIndexSequence[j]) {
                        move(nextChild, container, anchor, 2);
                    }
                    else {
                        j--;
                    }
                }
            }
        }
    };
    var move = function (vnode, container, anchor, moveType, parentSuspense) {
        if (parentSuspense === void 0) { parentSuspense = null; }
        var el = vnode.el, type = vnode.type, transition = vnode.transition, children = vnode.children, shapeFlag = vnode.shapeFlag;
        if (shapeFlag & 6) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === Fragment) {
            hostInsert(el, container, anchor);
            for (var i = 0; i < children.length; i++) {
                move(children[i], container, anchor, moveType);
            }
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === Static) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        var needTransition2 = moveType !== 2 && shapeFlag & 1 && transition;
        if (needTransition2) {
            if (moveType === 0) {
                transition.beforeEnter(el);
                hostInsert(el, container, anchor);
                queuePostRenderEffect(function () { return transition.enter(el); }, parentSuspense);
            }
            else {
                var leave_1 = transition.leave, delayLeave = transition.delayLeave, afterLeave_1 = transition.afterLeave;
                var remove2_1 = function () { return hostInsert(el, container, anchor); };
                var performLeave = function () {
                    leave_1(el, function () {
                        remove2_1();
                        afterLeave_1 && afterLeave_1();
                    });
                };
                if (delayLeave) {
                    delayLeave(el, remove2_1, performLeave);
                }
                else {
                    performLeave();
                }
            }
        }
        else {
            hostInsert(el, container, anchor);
        }
    };
    var unmount = function (vnode, parentComponent, parentSuspense, doRemove, optimized) {
        if (doRemove === void 0) { doRemove = false; }
        if (optimized === void 0) { optimized = false; }
        var type = vnode.type, props = vnode.props, ref = vnode.ref, children = vnode.children, dynamicChildren = vnode.dynamicChildren, shapeFlag = vnode.shapeFlag, patchFlag = vnode.patchFlag, dirs = vnode.dirs;
        if (ref != null) {
            setRef(ref, null, parentSuspense, vnode, true);
        }
        if (shapeFlag & 256) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        var shouldInvokeDirs = shapeFlag & 1 && dirs;
        var shouldInvokeVnodeHook = !isAsyncWrapper(vnode);
        var vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) {
            invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
        if (shapeFlag & 6) {
            unmountComponent(vnode.component, parentSuspense, doRemove);
        }
        else {
            if (shapeFlag & 128) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) {
                invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            }
            if (shapeFlag & 64) {
                vnode.type.remove(vnode, parentComponent, parentSuspense, optimized, internals, doRemove);
            }
            else if (dynamicChildren && // #1153: fast path should not be taken for non-stable (v-for) fragments
                (type !== Fragment || patchFlag > 0 && patchFlag & 64)) {
                unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            }
            else if (type === Fragment && patchFlag & (128 | 256) || !optimized && shapeFlag & 16) {
                unmountChildren(children, parentComponent, parentSuspense);
            }
            if (doRemove) {
                remove(vnode);
            }
        }
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs) {
            queuePostRenderEffect(function () {
                vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, vnode);
                shouldInvokeDirs && invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
            }, parentSuspense);
        }
    };
    var remove = function (vnode) {
        var type = vnode.type, el = vnode.el, anchor = vnode.anchor, transition = vnode.transition;
        if (type === Fragment) {
            if (!!(process.env.NODE_ENV !== "production") && vnode.patchFlag > 0 && vnode.patchFlag & 2048 && transition && !transition.persisted) {
                vnode.children.forEach(function (child) {
                    if (child.type === Comment) {
                        hostRemove(child.el);
                    }
                    else {
                        remove(child);
                    }
                });
            }
            else {
                removeFragment(el, anchor);
            }
            return;
        }
        if (type === Static) {
            removeStaticNode(vnode);
            return;
        }
        var performRemove = function () {
            hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) {
                transition.afterLeave();
            }
        };
        if (vnode.shapeFlag & 1 && transition && !transition.persisted) {
            var leave_2 = transition.leave, delayLeave = transition.delayLeave;
            var performLeave = function () { return leave_2(el, performRemove); };
            if (delayLeave) {
                delayLeave(vnode.el, performRemove, performLeave);
            }
            else {
                performLeave();
            }
        }
        else {
            performRemove();
        }
    };
    var removeFragment = function (cur, end) {
        var next;
        while (cur !== end) {
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    var unmountComponent = function (instance, parentSuspense, doRemove) {
        if (!!(process.env.NODE_ENV !== "production") && instance.type.__hmrId) {
            unregisterHMR(instance);
        }
        var bum = instance.bum, scope = instance.scope, update = instance.update, subTree = instance.subTree, um = instance.um;
        if (bum) {
            invokeArrayFns(bum);
        }
        scope.stop();
        if (update) {
            update.active = false;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        if (um) {
            queuePostRenderEffect(um, parentSuspense);
        }
        queuePostRenderEffect(function () {
            instance.isUnmounted = true;
        }, parentSuspense);
        if (parentSuspense && parentSuspense.pendingBranch && !parentSuspense.isUnmounted && instance.asyncDep && !instance.asyncResolved && instance.suspenseId === parentSuspense.pendingId) {
            parentSuspense.deps--;
            if (parentSuspense.deps === 0) {
                parentSuspense.resolve();
            }
        }
        if (!!(process.env.NODE_ENV !== "production") || __VUE_PROD_DEVTOOLS__) {
            devtoolsComponentRemoved(instance);
        }
    };
    var unmountChildren = function (children, parentComponent, parentSuspense, doRemove, optimized, start) {
        if (doRemove === void 0) { doRemove = false; }
        if (optimized === void 0) { optimized = false; }
        if (start === void 0) { start = 0; }
        for (var i = start; i < children.length; i++) {
            unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
        }
    };
    var getNextHostNode = function (vnode) {
        if (vnode.shapeFlag & 6) {
            return getNextHostNode(vnode.component.subTree);
        }
        if (vnode.shapeFlag & 128) {
            return vnode.suspense.next();
        }
        return hostNextSibling(vnode.anchor || vnode.el);
    };
    var isFlushing = false;
    var render = function (vnode, container, namespace) {
        if (vnode == null) {
            if (container._vnode) {
                unmount(container._vnode, null, null, true);
            }
        }
        else {
            patch(container._vnode || null, vnode, container, null, null, null, namespace);
        }
        if (!isFlushing) {
            isFlushing = true;
            flushPreFlushCbs();
            flushPostFlushCbs();
            isFlushing = false;
        }
        container._vnode = vnode;
    };
    var internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    var hydrate;
    var hydrateNode;
    if (createHydrationFns) {
        _e = __read(createHydrationFns(internals), 2), hydrate = _e[0], hydrateNode = _e[1];
    }
    return {
        render: render,
        hydrate: hydrate,
        createApp: createAppAPI(render, hydrate)
    };
}
function resolveChildrenNamespace(_e, currentNamespace) {
    var type = _e.type, props = _e.props;
    return currentNamespace === "svg" && type === "foreignObject" || currentNamespace === "mathml" && type === "annotation-xml" && props && props.encoding && props.encoding.includes("html") ? void 0 : currentNamespace;
}
function toggleRecurse(_e, allowed) {
    var effect = _e.effect, update = _e.update;
    effect.allowRecurse = update.allowRecurse = allowed;
}
function needTransition(parentSuspense, transition) {
    return (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
}
function traverseStaticChildren(n1, n2, shallow) {
    if (shallow === void 0) { shallow = false; }
    var ch1 = n1.children;
    var ch2 = n2.children;
    if (isArray(ch1) && isArray(ch2)) {
        for (var i = 0; i < ch1.length; i++) {
            var c1 = ch1[i];
            var c2 = ch2[i];
            if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
                if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
                    c2 = ch2[i] = cloneIfMounted(ch2[i]);
                    c2.el = c1.el;
                }
                if (!shallow)
                    traverseStaticChildren(c1, c2);
            }
            if (c2.type === Text) {
                c2.el = c1.el;
            }
            if (!!(process.env.NODE_ENV !== "production") && c2.type === Comment && !c2.el) {
                c2.el = c1.el;
            }
        }
    }
}
function getSequence(arr) {
    var p = arr.slice();
    var result = [0];
    var i, j, u, v, c;
    var len = arr.length;
    for (i = 0; i < len; i++) {
        var arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v = result.length - 1;
            while (u < v) {
                c = u + v >> 1;
                if (arr[result[c]] < arrI) {
                    u = c + 1;
                }
                else {
                    v = c;
                }
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) {
                    p[i] = result[u - 1];
                }
                result[u] = i;
            }
        }
    }
    u = result.length;
    v = result[u - 1];
    while (u-- > 0) {
        result[u] = v;
        v = p[v];
    }
    return result;
}
function locateNonHydratedAsyncRoot(instance) {
    var subComponent = instance.subTree.component;
    if (subComponent) {
        if (subComponent.asyncDep && !subComponent.asyncResolved) {
            return subComponent;
        }
        else {
            return locateNonHydratedAsyncRoot(subComponent);
        }
    }
}
var isTeleport = function (type) { return type.__isTeleport; };
var isTeleportDisabled = function (props) { return props && (props.disabled || props.disabled === ""); };
var isTargetSVG = function (target) { return typeof SVGElement !== "undefined" && target instanceof SVGElement; };
var isTargetMathML = function (target) { return typeof MathMLElement === "function" && target instanceof MathMLElement; };
var resolveTarget = function (props, select) {
    var targetSelector = props && props.to;
    if (isString(targetSelector)) {
        if (!select) {
            !!(process.env.NODE_ENV !== "production") && warn$1("Current renderer does not support string target for Teleports. (missing querySelector renderer option)");
            return null;
        }
        else {
            var target = select(targetSelector);
            if (!target) {
                !!(process.env.NODE_ENV !== "production") && warn$1("Failed to locate Teleport target with selector \"".concat(targetSelector, "\". Note the target element must exist before the component is mounted - i.e. the target cannot be rendered by the component itself, and ideally should be outside of the entire Vue component tree."));
            }
            return target;
        }
    }
    else {
        if (!!(process.env.NODE_ENV !== "production") && !targetSelector && !isTeleportDisabled(props)) {
            warn$1("Invalid Teleport target: ".concat(targetSelector));
        }
        return targetSelector;
    }
};
var TeleportImpl = {
    name: "Teleport",
    __isTeleport: true,
    process: function (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals) {
        var mountChildren = internals.mc, patchChildren = internals.pc, patchBlockChildren = internals.pbc, _e = internals.o, insert = _e.insert, querySelector = _e.querySelector, createText = _e.createText, createComment = _e.createComment;
        var disabled = isTeleportDisabled(n2.props);
        var shapeFlag = n2.shapeFlag, children = n2.children, dynamicChildren = n2.dynamicChildren;
        if (!!(process.env.NODE_ENV !== "production") && isHmrUpdating) {
            optimized = false;
            dynamicChildren = null;
        }
        if (n1 == null) {
            var placeholder = n2.el = !!(process.env.NODE_ENV !== "production") ? createComment("teleport start") : createText("");
            var mainAnchor = n2.anchor = !!(process.env.NODE_ENV !== "production") ? createComment("teleport end") : createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            var target = n2.target = resolveTarget(n2.props, querySelector);
            var targetAnchor = n2.targetAnchor = createText("");
            if (target) {
                insert(targetAnchor, target);
                if (namespace === "svg" || isTargetSVG(target)) {
                    namespace = "svg";
                }
                else if (namespace === "mathml" || isTargetMathML(target)) {
                    namespace = "mathml";
                }
            }
            else if (!!(process.env.NODE_ENV !== "production") && !disabled) {
                warn$1("Invalid Teleport target on mount:", target, "(".concat(typeof target, ")"));
            }
            var mount = function (container2, anchor2) {
                if (shapeFlag & 16) {
                    mountChildren(children, container2, anchor2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                }
            };
            if (disabled) {
                mount(container, mainAnchor);
            }
            else if (target) {
                mount(target, targetAnchor);
            }
        }
        else {
            n2.el = n1.el;
            var mainAnchor = n2.anchor = n1.anchor;
            var target = n2.target = n1.target;
            var targetAnchor = n2.targetAnchor = n1.targetAnchor;
            var wasDisabled = isTeleportDisabled(n1.props);
            var currentContainer = wasDisabled ? container : target;
            var currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
            if (namespace === "svg" || isTargetSVG(target)) {
                namespace = "svg";
            }
            else if (namespace === "mathml" || isTargetMathML(target)) {
                namespace = "mathml";
            }
            if (dynamicChildren) {
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, namespace, slotScopeIds);
                traverseStaticChildren(n1, n2, true);
            }
            else if (!optimized) {
                patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, false);
            }
            if (disabled) {
                if (!wasDisabled) {
                    moveTeleport(n2, container, mainAnchor, internals, 1);
                }
                else {
                    if (n2.props && n1.props && n2.props.to !== n1.props.to) {
                        n2.props.to = n1.props.to;
                    }
                }
            }
            else {
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    var nextTarget = n2.target = resolveTarget(n2.props, querySelector);
                    if (nextTarget) {
                        moveTeleport(n2, nextTarget, null, internals, 0);
                    }
                    else if (!!(process.env.NODE_ENV !== "production")) {
                        warn$1("Invalid Teleport target on update:", target, "(".concat(typeof target, ")"));
                    }
                }
                else if (wasDisabled) {
                    moveTeleport(n2, target, targetAnchor, internals, 1);
                }
            }
        }
        updateCssVars(n2);
    },
    remove: function (vnode, parentComponent, parentSuspense, optimized, _e, doRemove) {
        var unmount = _e.um, hostRemove = _e.o.remove;
        var shapeFlag = vnode.shapeFlag, children = vnode.children, anchor = vnode.anchor, targetAnchor = vnode.targetAnchor, target = vnode.target, props = vnode.props;
        if (target) {
            hostRemove(targetAnchor);
        }
        doRemove && hostRemove(anchor);
        if (shapeFlag & 16) {
            var shouldRemove = doRemove || !isTeleportDisabled(props);
            for (var i = 0; i < children.length; i++) {
                var child = children[i];
                unmount(child, parentComponent, parentSuspense, shouldRemove, !!child.dynamicChildren);
            }
        }
    },
    move: moveTeleport,
    hydrate: hydrateTeleport
};
function moveTeleport(vnode, container, parentAnchor, _e, moveType) {
    var insert = _e.o.insert, move = _e.m;
    if (moveType === void 0) { moveType = 2; }
    if (moveType === 0) {
        insert(vnode.targetAnchor, container, parentAnchor);
    }
    var el = vnode.el, anchor = vnode.anchor, shapeFlag = vnode.shapeFlag, children = vnode.children, props = vnode.props;
    var isReorder = moveType === 2;
    if (isReorder) {
        insert(el, container, parentAnchor);
    }
    if (!isReorder || isTeleportDisabled(props)) {
        if (shapeFlag & 16) {
            for (var i = 0; i < children.length; i++) {
                move(children[i], container, parentAnchor, 2);
            }
        }
    }
    if (isReorder) {
        insert(anchor, container, parentAnchor);
    }
}
function hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, _e, hydrateChildren) {
    var _f = _e.o, nextSibling = _f.nextSibling, parentNode = _f.parentNode, querySelector = _f.querySelector;
    var target = vnode.target = resolveTarget(vnode.props, querySelector);
    if (target) {
        var targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16) {
            if (isTeleportDisabled(vnode.props)) {
                vnode.anchor = hydrateChildren(nextSibling(node), vnode, parentNode(node), parentComponent, parentSuspense, slotScopeIds, optimized);
                vnode.targetAnchor = targetNode;
            }
            else {
                vnode.anchor = nextSibling(node);
                var targetAnchor = targetNode;
                while (targetAnchor) {
                    targetAnchor = nextSibling(targetAnchor);
                    if (targetAnchor && targetAnchor.nodeType === 8 && targetAnchor.data === "teleport anchor") {
                        vnode.targetAnchor = targetAnchor;
                        target._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                        break;
                    }
                }
                hydrateChildren(targetNode, vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
        updateCssVars(vnode);
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
var Teleport = TeleportImpl;
function updateCssVars(vnode) {
    var ctx = vnode.ctx;
    if (ctx && ctx.ut) {
        var node = vnode.children[0].el;
        while (node && node !== vnode.targetAnchor) {
            if (node.nodeType === 1)
                node.setAttribute("data-v-owner", ctx.uid);
            node = node.nextSibling;
        }
        ctx.ut();
    }
}
var Fragment = Symbol.for("v-fgt");
var Text = Symbol.for("v-txt");
var Comment = Symbol.for("v-cmt");
var Static = Symbol.for("v-stc");
var blockStack = [];
var currentBlock = null;
function openBlock(disableTracking) {
    if (disableTracking === void 0) { disableTracking = false; }
    blockStack.push(currentBlock = disableTracking ? null : []);
}
function closeBlock() {
    blockStack.pop();
    currentBlock = blockStack[blockStack.length - 1] || null;
}
var isBlockTreeEnabled = 1;
function setBlockTracking(value) {
    isBlockTreeEnabled += value;
}
function setupBlock(vnode) {
    vnode.dynamicChildren = isBlockTreeEnabled > 0 ? currentBlock || EMPTY_ARR : null;
    closeBlock();
    if (isBlockTreeEnabled > 0 && currentBlock) {
        currentBlock.push(vnode);
    }
    return vnode;
}
function createElementBlock(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return setupBlock(createBaseVNode(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
function createBlock(type, props, children, patchFlag, dynamicProps) {
    return setupBlock(createVNode(type, props, children, patchFlag, dynamicProps, true));
}
function isVNode(value) {
    return value ? value.__v_isVNode === true : false;
}
function isSameVNodeType(n1, n2) {
    if (!!(process.env.NODE_ENV !== "production") && n2.shapeFlag & 6 && hmrDirtyComponents.has(n2.type)) {
        n1.shapeFlag &= ~256;
        n2.shapeFlag &= ~512;
        return false;
    }
    return n1.type === n2.type && n1.key === n2.key;
}
var vnodeArgsTransformer;
function transformVNodeArgs(transformer) {
    vnodeArgsTransformer = transformer;
}
var createVNodeWithArgsTransform = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return _createVNode.apply(void 0, __spreadArray([], __read(vnodeArgsTransformer ? vnodeArgsTransformer(args, currentRenderingInstance) : args), false));
};
var normalizeKey = function (_e) {
    var key = _e.key;
    return key != null ? key : null;
};
var normalizeRef = function (_e) {
    var ref = _e.ref, ref_key = _e.ref_key, ref_for = _e.ref_for;
    if (typeof ref === "number") {
        ref = "" + ref;
    }
    return ref != null ? isString(ref) || isRef(ref) || isFunction(ref) ? { i: currentRenderingInstance, r: ref, k: ref_key, f: !!ref_for } : ref : null;
};
function createBaseVNode(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, needFullChildrenNormalization) {
    if (props === void 0) { props = null; }
    if (children === void 0) { children = null; }
    if (patchFlag === void 0) { patchFlag = 0; }
    if (dynamicProps === void 0) { dynamicProps = null; }
    if (shapeFlag === void 0) { shapeFlag = type === Fragment ? 0 : 1; }
    if (isBlockNode === void 0) { isBlockNode = false; }
    if (needFullChildrenNormalization === void 0) { needFullChildrenNormalization = false; }
    var vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type: type,
        props: props,
        key: props && normalizeKey(props),
        ref: props && normalizeRef(props),
        scopeId: currentScopeId,
        slotScopeIds: null,
        children: children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: shapeFlag,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        dynamicChildren: null,
        appContext: null,
        ctx: currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
        normalizeChildren(vnode, children);
        if (shapeFlag & 128) {
            type.normalize(vnode);
        }
    }
    else if (children) {
        vnode.shapeFlag |= isString(children) ? 8 : 16;
    }
    if (!!(process.env.NODE_ENV !== "production") && vnode.key !== vnode.key) {
        warn$1("VNode created with invalid key (NaN). VNode type:", vnode.type);
    }
    if (isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
        !isBlockNode && // has current parent block
        currentBlock && // presence of a patch flag indicates this node needs patching on updates.
        // component nodes also should always be patched, because even if the
        // component doesn't need to update, it needs to persist the instance on to
        // the next vnode so that it can be properly unmounted later.
        (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
        // vnode should not be considered dynamic due to handler caching.
        vnode.patchFlag !== 32) {
        currentBlock.push(vnode);
    }
    return vnode;
}
var createVNode = !!(process.env.NODE_ENV !== "production") ? createVNodeWithArgsTransform : _createVNode;
function _createVNode(type, props, children, patchFlag, dynamicProps, isBlockNode) {
    if (props === void 0) { props = null; }
    if (children === void 0) { children = null; }
    if (patchFlag === void 0) { patchFlag = 0; }
    if (dynamicProps === void 0) { dynamicProps = null; }
    if (isBlockNode === void 0) { isBlockNode = false; }
    if (!type || type === NULL_DYNAMIC_COMPONENT) {
        if (!!(process.env.NODE_ENV !== "production") && !type) {
            warn$1("Invalid vnode type when creating vnode: ".concat(type, "."));
        }
        type = Comment;
    }
    if (isVNode(type)) {
        var cloned = cloneVNode(type, props, true
        /* mergeRef: true */
        );
        if (children) {
            normalizeChildren(cloned, children);
        }
        if (isBlockTreeEnabled > 0 && !isBlockNode && currentBlock) {
            if (cloned.shapeFlag & 6) {
                currentBlock[currentBlock.indexOf(type)] = cloned;
            }
            else {
                currentBlock.push(cloned);
            }
        }
        cloned.patchFlag |= -2;
        return cloned;
    }
    if (isClassComponent(type)) {
        type = type.__vccOpts;
    }
    if (props) {
        props = guardReactiveProps(props);
        var klass = props.class, style = props.style;
        if (klass && !isString(klass)) {
            props.class = normalizeClass(klass);
        }
        if (isObject(style)) {
            if (isProxy(style) && !isArray(style)) {
                style = extend({}, style);
            }
            props.style = normalizeStyle(style);
        }
    }
    var shapeFlag = isString(type) ? 1 : isSuspense(type) ? 128 : isTeleport(type) ? 64 : isObject(type) ? 4 : isFunction(type) ? 2 : 0;
    if (!!(process.env.NODE_ENV !== "production") && shapeFlag & 4 && isProxy(type)) {
        type = toRaw(type);
        warn$1("Vue received a Component that was made a reactive object. This can lead to unnecessary performance overhead and should be avoided by marking the component with `markRaw` or using `shallowRef` instead of `ref`.", "\nComponent that was made reactive: ", type);
    }
    return createBaseVNode(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function guardReactiveProps(props) {
    if (!props)
        return null;
    return isProxy(props) || isInternalObject(props) ? extend({}, props) : props;
}
function cloneVNode(vnode, extraProps, mergeRef, cloneTransition) {
    if (mergeRef === void 0) { mergeRef = false; }
    if (cloneTransition === void 0) { cloneTransition = false; }
    var props = vnode.props, ref = vnode.ref, patchFlag = vnode.patchFlag, children = vnode.children, transition = vnode.transition;
    var mergedProps = extraProps ? mergeProps(props || {}, extraProps) : props;
    var cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? (
        // #2078 in the case of <component :is="vnode" ref="extra"/>
        // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? isArray(ref) ? ref.concat(normalizeRef(extraProps)) : [ref, normalizeRef(extraProps)] : normalizeRef(extraProps)) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: !!(process.env.NODE_ENV !== "production") && patchFlag === -1 && isArray(children) ? children.map(deepCloneVNode) : children,
        target: vnode.target,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== Fragment ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition: transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && cloneVNode(vnode.ssContent),
        ssFallback: vnode.ssFallback && cloneVNode(vnode.ssFallback),
        el: vnode.el,
        anchor: vnode.anchor,
        ctx: vnode.ctx,
        ce: vnode.ce
    };
    if (transition && cloneTransition) {
        cloned.transition = transition.clone(cloned);
    }
    return cloned;
}
function deepCloneVNode(vnode) {
    var cloned = cloneVNode(vnode);
    if (isArray(vnode.children)) {
        cloned.children = vnode.children.map(deepCloneVNode);
    }
    return cloned;
}
function createTextVNode(text, flag) {
    if (text === void 0) { text = " "; }
    if (flag === void 0) { flag = 0; }
    return createVNode(Text, null, text, flag);
}
function createStaticVNode(content, numberOfNodes) {
    var vnode = createVNode(Static, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
function createCommentVNode(text, asBlock) {
    if (text === void 0) { text = ""; }
    if (asBlock === void 0) { asBlock = false; }
    return asBlock ? (openBlock(), createBlock(Comment, null, text)) : createVNode(Comment, null, text);
}
function normalizeVNode(child) {
    if (child == null || typeof child === "boolean") {
        return createVNode(Comment);
    }
    else if (isArray(child)) {
        return createVNode(Fragment, null, 
        // #3666, avoid reference pollution when reusing vnode
        child.slice());
    }
    else if (typeof child === "object") {
        return cloneIfMounted(child);
    }
    else {
        return createVNode(Text, null, String(child));
    }
}
function cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : cloneVNode(child);
}
function normalizeChildren(vnode, children) {
    var type = 0;
    var shapeFlag = vnode.shapeFlag;
    if (children == null) {
        children = null;
    }
    else if (isArray(children)) {
        type = 16;
    }
    else if (typeof children === "object") {
        if (shapeFlag & (1 | 64)) {
            var slot = children.default;
            if (slot) {
                slot._c && (slot._d = false);
                normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        }
        else {
            type = 32;
            var slotFlag = children._;
            if (!slotFlag && !isInternalObject(children)) {
                children._ctx = currentRenderingInstance;
            }
            else if (slotFlag === 3 && currentRenderingInstance) {
                if (currentRenderingInstance.slots._ === 1) {
                    children._ = 1;
                }
                else {
                    children._ = 2;
                    vnode.patchFlag |= 1024;
                }
            }
        }
    }
    else if (isFunction(children)) {
        children = { default: children, _ctx: currentRenderingInstance };
        type = 32;
    }
    else {
        children = String(children);
        if (shapeFlag & 64) {
            type = 16;
            children = [createTextVNode(children)];
        }
        else {
            type = 8;
        }
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function mergeProps() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var ret = {};
    for (var i = 0; i < args.length; i++) {
        var toMerge = args[i];
        for (var key in toMerge) {
            if (key === "class") {
                if (ret.class !== toMerge.class) {
                    ret.class = normalizeClass([ret.class, toMerge.class]);
                }
            }
            else if (key === "style") {
                ret.style = normalizeStyle([ret.style, toMerge.style]);
            }
            else if (isOn(key)) {
                var existing = ret[key];
                var incoming = toMerge[key];
                if (incoming && existing !== incoming && !(isArray(existing) && existing.includes(incoming))) {
                    ret[key] = existing ? [].concat(existing, incoming) : incoming;
                }
            }
            else if (key !== "") {
                ret[key] = toMerge[key];
            }
        }
    }
    return ret;
}
function invokeVNodeHook(hook, instance, vnode, prevVNode) {
    if (prevVNode === void 0) { prevVNode = null; }
    callWithAsyncErrorHandling(hook, instance, 7, [
        vnode,
        prevVNode
    ]);
}
var emptyAppContext = createAppContext();
var uid = 0;
function createComponentInstance(vnode, parent, suspense) {
    var type = vnode.type;
    var appContext = (parent ? parent.appContext : vnode.appContext) || emptyAppContext;
    var instance = {
        uid: uid++,
        vnode: vnode,
        type: type,
        parent: parent,
        appContext: appContext,
        root: null,
        // to be immediately set
        next: null,
        subTree: null,
        // will be set synchronously right after creation
        effect: null,
        update: null,
        // will be set synchronously right after creation
        scope: new EffectScope(true
        /* detached */
        ),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: normalizePropsOptions(type, appContext),
        emitsOptions: normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        // to be set immediately
        emitted: null,
        // props default value
        propsDefaults: EMPTY_OBJ,
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: EMPTY_OBJ,
        data: EMPTY_OBJ,
        props: EMPTY_OBJ,
        attrs: EMPTY_OBJ,
        slots: EMPTY_OBJ,
        refs: EMPTY_OBJ,
        setupState: EMPTY_OBJ,
        setupContext: null,
        attrsProxy: null,
        slotsProxy: null,
        // suspense related
        suspense: suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    if (!!(process.env.NODE_ENV !== "production")) {
        instance.ctx = createDevRenderContext(instance);
    }
    else {
        instance.ctx = { _: instance };
    }
    instance.root = parent ? parent.root : instance;
    instance.emit = emit.bind(null, instance);
    if (vnode.ce) {
        vnode.ce(instance);
    }
    return instance;
}
var currentInstance = null;
var getCurrentInstance = function () { return currentInstance || currentRenderingInstance; };
var internalSetCurrentInstance;
var setInSSRSetupState;
{
    var g_1 = getGlobalThis();
    var registerGlobalSetter = function (key, setter) {
        var setters;
        if (!(setters = g_1[key]))
            setters = g_1[key] = [];
        setters.push(setter);
        return function (v) {
            if (setters.length > 1)
                setters.forEach(function (set) { return set(v); });
            else
                setters[0](v);
        };
    };
    internalSetCurrentInstance = registerGlobalSetter("__VUE_INSTANCE_SETTERS__", function (v) { return currentInstance = v; });
    setInSSRSetupState = registerGlobalSetter("__VUE_SSR_SETTERS__", function (v) { return isInSSRComponentSetup = v; });
}
var setCurrentInstance = function (instance) {
    var prev = currentInstance;
    internalSetCurrentInstance(instance);
    instance.scope.on();
    return function () {
        instance.scope.off();
        internalSetCurrentInstance(prev);
    };
};
var unsetCurrentInstance = function () {
    currentInstance && currentInstance.scope.off();
    internalSetCurrentInstance(null);
};
var isBuiltInTag = /* @__PURE__ */ makeMap("slot,component");
function validateComponentName(name, _e) {
    var isNativeTag = _e.isNativeTag;
    if (isBuiltInTag(name) || isNativeTag(name)) {
        warn$1("Do not use built-in or reserved HTML elements as component id: " + name);
    }
}
function isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
}
var isInSSRComponentSetup = false;
function setupComponent(instance, isSSR) {
    if (isSSR === void 0) { isSSR = false; }
    isSSR && setInSSRSetupState(isSSR);
    var _e = instance.vnode, props = _e.props, children = _e.children;
    var isStateful = isStatefulComponent(instance);
    initProps(instance, props, isStateful, isSSR);
    initSlots(instance, children);
    var setupResult = isStateful ? setupStatefulComponent(instance, isSSR) : void 0;
    isSSR && setInSSRSetupState(false);
    return setupResult;
}
function setupStatefulComponent(instance, isSSR) {
    var _a;
    var Component = instance.type;
    if (!!(process.env.NODE_ENV !== "production")) {
        if (Component.name) {
            validateComponentName(Component.name, instance.appContext.config);
        }
        if (Component.components) {
            var names = Object.keys(Component.components);
            for (var i = 0; i < names.length; i++) {
                validateComponentName(names[i], instance.appContext.config);
            }
        }
        if (Component.directives) {
            var names = Object.keys(Component.directives);
            for (var i = 0; i < names.length; i++) {
                validateDirectiveName(names[i]);
            }
        }
        if (Component.compilerOptions && isRuntimeOnly()) {
            warn$1("\"compilerOptions\" is only supported when using a build of Vue that includes the runtime compiler. Since you are using a runtime-only build, the options should be passed via your build tool config instead.");
        }
    }
    instance.accessCache = /* @__PURE__ */ Object.create(null);
    instance.proxy = new Proxy(instance.ctx, PublicInstanceProxyHandlers);
    if (!!(process.env.NODE_ENV !== "production")) {
        exposePropsOnRenderContext(instance);
    }
    var setup = Component.setup;
    if (setup) {
        var setupContext = instance.setupContext = setup.length > 1 ? createSetupContext(instance) : null;
        var reset = setCurrentInstance(instance);
        pauseTracking();
        var setupResult = callWithErrorHandling(setup, instance, 0, [
            !!(process.env.NODE_ENV !== "production") ? shallowReadonly(instance.props) : instance.props,
            setupContext
        ]);
        resetTracking();
        reset();
        if (isPromise(setupResult)) {
            setupResult.then(unsetCurrentInstance, unsetCurrentInstance);
            if (isSSR) {
                return setupResult.then(function (resolvedResult) {
                    handleSetupResult(instance, resolvedResult, isSSR);
                }).catch(function (e) {
                    handleError(e, instance, 0);
                });
            }
            else {
                instance.asyncDep = setupResult;
                if (!!(process.env.NODE_ENV !== "production") && !instance.suspense) {
                    var name = (_a = Component.name) != null ? _a : "Anonymous";
                    warn$1("Component <".concat(name, ">: setup function returned a promise, but no <Suspense> boundary was found in the parent component tree. A component with async setup() must be nested in a <Suspense> in order to be rendered."));
                }
            }
        }
        else {
            handleSetupResult(instance, setupResult, isSSR);
        }
    }
    else {
        finishComponentSetup(instance, isSSR);
    }
}
function handleSetupResult(instance, setupResult, isSSR) {
    if (isFunction(setupResult)) {
        if (instance.type.__ssrInlineRender) {
            instance.ssrRender = setupResult;
        }
        else {
            instance.render = setupResult;
        }
    }
    else if (isObject(setupResult)) {
        if (!!(process.env.NODE_ENV !== "production") && isVNode(setupResult)) {
            warn$1("setup() should not return VNodes directly - return a render function instead.");
        }
        if (!!(process.env.NODE_ENV !== "production") || __VUE_PROD_DEVTOOLS__) {
            instance.devtoolsRawSetupState = setupResult;
        }
        instance.setupState = proxyRefs(setupResult);
        if (!!(process.env.NODE_ENV !== "production")) {
            exposeSetupStateOnRenderContext(instance);
        }
    }
    else if (!!(process.env.NODE_ENV !== "production") && setupResult !== void 0) {
        warn$1("setup() should return an object. Received: ".concat(setupResult === null ? "null" : typeof setupResult));
    }
    finishComponentSetup(instance, isSSR);
}
var compile;
var installWithProxy;
function registerRuntimeCompiler(_compile) {
    compile = _compile;
    installWithProxy = function (i) {
        if (i.render._rc) {
            i.withProxy = new Proxy(i.ctx, RuntimeCompiledPublicInstanceProxyHandlers);
        }
    };
}
var isRuntimeOnly = function () { return !compile; };
function finishComponentSetup(instance, isSSR, skipOptions) {
    var Component = instance.type;
    if (!instance.render) {
        if (!isSSR && compile && !Component.render) {
            var template = Component.template || resolveMergedOptions(instance).template;
            if (template) {
                if (!!(process.env.NODE_ENV !== "production")) {
                    startMeasure(instance, "compile");
                }
                var _e = instance.appContext.config, isCustomElement = _e.isCustomElement, compilerOptions = _e.compilerOptions;
                var delimiters = Component.delimiters, componentCompilerOptions = Component.compilerOptions;
                var finalCompilerOptions = extend(extend({
                    isCustomElement: isCustomElement,
                    delimiters: delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = compile(template, finalCompilerOptions);
                if (!!(process.env.NODE_ENV !== "production")) {
                    endMeasure(instance, "compile");
                }
            }
        }
        instance.render = Component.render || NOOP;
        if (installWithProxy) {
            installWithProxy(instance);
        }
    }
    if (__VUE_OPTIONS_API__ && true) {
        var reset = setCurrentInstance(instance);
        pauseTracking();
        try {
            applyOptions(instance);
        }
        finally {
            resetTracking();
            reset();
        }
    }
    if (!!(process.env.NODE_ENV !== "production") && !Component.render && instance.render === NOOP && !isSSR) {
        if (!compile && Component.template) {
            warn$1("Component provided template option but runtime compilation is not supported in this build of Vue." + (" Configure your bundler to alias \"vue\" to \"vue/dist/vue.esm-bundler.js\"."));
        }
        else {
            warn$1("Component is missing template or render function.");
        }
    }
}
var attrsProxyHandlers = !!(process.env.NODE_ENV !== "production") ? {
    get: function (target, key) {
        markAttrsAccessed();
        track(target, "get", "");
        return target[key];
    },
    set: function () {
        warn$1("setupContext.attrs is readonly.");
        return false;
    },
    deleteProperty: function () {
        warn$1("setupContext.attrs is readonly.");
        return false;
    }
} : {
    get: function (target, key) {
        track(target, "get", "");
        return target[key];
    }
};
function getSlotsProxy(instance) {
    return instance.slotsProxy || (instance.slotsProxy = new Proxy(instance.slots, {
        get: function (target, key) {
            track(instance, "get", "$slots");
            return target[key];
        }
    }));
}
function createSetupContext(instance) {
    var expose = function (exposed) {
        if (!!(process.env.NODE_ENV !== "production")) {
            if (instance.exposed) {
                warn$1("expose() should be called only once per setup().");
            }
            if (exposed != null) {
                var exposedType = typeof exposed;
                if (exposedType === "object") {
                    if (isArray(exposed)) {
                        exposedType = "array";
                    }
                    else if (isRef(exposed)) {
                        exposedType = "ref";
                    }
                }
                if (exposedType !== "object") {
                    warn$1("expose() should be passed a plain object, received ".concat(exposedType, "."));
                }
            }
        }
        instance.exposed = exposed || {};
    };
    if (!!(process.env.NODE_ENV !== "production")) {
        var attrsProxy_1;
        return Object.freeze({
            get attrs() {
                return attrsProxy_1 || (attrsProxy_1 = new Proxy(instance.attrs, attrsProxyHandlers));
            },
            get slots() {
                return getSlotsProxy(instance);
            },
            get emit() {
                return function (event) {
                    var args = [];
                    for (var _i = 1; _i < arguments.length; _i++) {
                        args[_i - 1] = arguments[_i];
                    }
                    return instance.emit.apply(instance, __spreadArray([event], __read(args), false));
                };
            },
            expose: expose
        });
    }
    else {
        return {
            attrs: new Proxy(instance.attrs, attrsProxyHandlers),
            slots: instance.slots,
            emit: instance.emit,
            expose: expose
        };
    }
}
function getExposeProxy(instance) {
    if (instance.exposed) {
        return instance.exposeProxy || (instance.exposeProxy = new Proxy(proxyRefs(markRaw(instance.exposed)), {
            get: function (target, key) {
                if (key in target) {
                    return target[key];
                }
                else if (key in publicPropertiesMap) {
                    return publicPropertiesMap[key](instance);
                }
            },
            has: function (target, key) {
                return key in target || key in publicPropertiesMap;
            }
        }));
    }
}
var classifyRE = /(?:^|[-_])(\w)/g;
var classify = function (str) { return str.replace(classifyRE, function (c) { return c.toUpperCase(); }).replace(/[-_]/g, ""); };
function getComponentName(Component, includeInferred) {
    if (includeInferred === void 0) { includeInferred = true; }
    return isFunction(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function formatComponentName(instance, Component, isRoot) {
    if (isRoot === void 0) { isRoot = false; }
    var name = getComponentName(Component);
    if (!name && Component.__file) {
        var match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) {
            name = match[1];
        }
    }
    if (!name && instance && instance.parent) {
        var inferFromRegistry = function (registry) {
            for (var key in registry) {
                if (registry[key] === Component) {
                    return key;
                }
            }
        };
        name = inferFromRegistry(instance.components || instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? classify(name) : isRoot ? "App" : "Anonymous";
}
function isClassComponent(value) {
    return isFunction(value) && "__vccOpts" in value;
}
var computed = function (getterOrOptions, debugOptions) {
    var c = computed$1(getterOrOptions, debugOptions, isInSSRComponentSetup);
    if (!!(process.env.NODE_ENV !== "production")) {
        var i = getCurrentInstance();
        if (i && i.appContext.config.warnRecursiveComputed) {
            c._warnRecursive = true;
        }
    }
    return c;
};
function useModel(props, name, options) {
    if (options === void 0) { options = EMPTY_OBJ; }
    var i = getCurrentInstance();
    if (!!(process.env.NODE_ENV !== "production") && !i) {
        warn$1("useModel() called without active instance.");
        return ref();
    }
    if (!!(process.env.NODE_ENV !== "production") && !i.propsOptions[0][name]) {
        warn$1("useModel() called with prop \"".concat(name, "\" which is not declared."));
        return ref();
    }
    var camelizedName = camelize(name);
    var hyphenatedName = hyphenate(name);
    var res = customRef(function (track, trigger) {
        var localValue;
        watchSyncEffect(function () {
            var propValue = props[name];
            if (hasChanged(localValue, propValue)) {
                localValue = propValue;
                trigger();
            }
        });
        return {
            get: function () {
                track();
                return options.get ? options.get(localValue) : localValue;
            },
            set: function (value) {
                var rawProps = i.vnode.props;
                if (!(rawProps && // check if parent has passed v-model
                    (name in rawProps || camelizedName in rawProps || hyphenatedName in rawProps) && ("onUpdate:".concat(name) in rawProps || "onUpdate:".concat(camelizedName) in rawProps || "onUpdate:".concat(hyphenatedName) in rawProps)) && hasChanged(value, localValue)) {
                    localValue = value;
                    trigger();
                }
                i.emit("update:".concat(name), options.set ? options.set(value) : value);
            }
        };
    });
    var modifierKey = name === "modelValue" ? "modelModifiers" : "".concat(name, "Modifiers");
    res[Symbol.iterator] = function () {
        var i2 = 0;
        return {
            next: function () {
                if (i2 < 2) {
                    return { value: i2++ ? props[modifierKey] || {} : res, done: false };
                }
                else {
                    return { done: true };
                }
            }
        };
    };
    return res;
}
function h(type, propsOrChildren, children) {
    var l = arguments.length;
    if (l === 2) {
        if (isObject(propsOrChildren) && !isArray(propsOrChildren)) {
            if (isVNode(propsOrChildren)) {
                return createVNode(type, null, [propsOrChildren]);
            }
            return createVNode(type, propsOrChildren);
        }
        else {
            return createVNode(type, null, propsOrChildren);
        }
    }
    else {
        if (l > 3) {
            children = Array.prototype.slice.call(arguments, 2);
        }
        else if (l === 3 && isVNode(children)) {
            children = [children];
        }
        return createVNode(type, propsOrChildren, children);
    }
}
function initCustomFormatter() {
    if (!!!(process.env.NODE_ENV !== "production") || typeof window === "undefined") {
        return;
    }
    var vueStyle = { style: "color:#3ba776" };
    var numberStyle = { style: "color:#1677ff" };
    var stringStyle = { style: "color:#f5222d" };
    var keywordStyle = { style: "color:#eb2f96" };
    var formatter = {
        header: function (obj) {
            if (!isObject(obj)) {
                return null;
            }
            if (obj.__isVue) {
                return ["div", vueStyle, "VueInstance"];
            }
            else if (isRef(obj)) {
                return [
                    "div",
                    {},
                    ["span", vueStyle, genRefFlag(obj)],
                    "<",
                    formatValue(obj.value),
                    ">"
                ];
            }
            else if (isReactive(obj)) {
                return [
                    "div",
                    {},
                    ["span", vueStyle, isShallow(obj) ? "ShallowReactive" : "Reactive"],
                    "<",
                    formatValue(obj),
                    ">".concat(isReadonly(obj) ? " (readonly)" : "")
                ];
            }
            else if (isReadonly(obj)) {
                return [
                    "div",
                    {},
                    ["span", vueStyle, isShallow(obj) ? "ShallowReadonly" : "Readonly"],
                    "<",
                    formatValue(obj),
                    ">"
                ];
            }
            return null;
        },
        hasBody: function (obj) {
            return obj && obj.__isVue;
        },
        body: function (obj) {
            if (obj && obj.__isVue) {
                return __spreadArray([
                    "div",
                    {}
                ], __read(formatInstance(obj.$)), false);
            }
        }
    };
    function formatInstance(instance) {
        var blocks = [];
        if (instance.type.props && instance.props) {
            blocks.push(createInstanceBlock("props", toRaw(instance.props)));
        }
        if (instance.setupState !== EMPTY_OBJ) {
            blocks.push(createInstanceBlock("setup", instance.setupState));
        }
        if (instance.data !== EMPTY_OBJ) {
            blocks.push(createInstanceBlock("data", toRaw(instance.data)));
        }
        var computed = extractKeys(instance, "computed");
        if (computed) {
            blocks.push(createInstanceBlock("computed", computed));
        }
        var injected = extractKeys(instance, "inject");
        if (injected) {
            blocks.push(createInstanceBlock("injected", injected));
        }
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            ["object", { object: instance }]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = extend({}, target);
        if (!Object.keys(target).length) {
            return ["span", {}];
        }
        return [
            "div",
            { style: "line-height:1.25em;margin-bottom:0.6em" },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            __spreadArray([
                "div",
                {
                    style: "padding-left:1.25em"
                }
            ], __read(Object.keys(target).map(function (key) {
                return [
                    "div",
                    {},
                    ["span", keywordStyle, key + ": "],
                    formatValue(target[key], false)
                ];
            })), false)
        ];
    }
    function formatValue(v, asRaw) {
        if (asRaw === void 0) { asRaw = true; }
        if (typeof v === "number") {
            return ["span", numberStyle, v];
        }
        else if (typeof v === "string") {
            return ["span", stringStyle, JSON.stringify(v)];
        }
        else if (typeof v === "boolean") {
            return ["span", keywordStyle, v];
        }
        else if (isObject(v)) {
            return ["object", { object: asRaw ? toRaw(v) : v }];
        }
        else {
            return ["span", stringStyle, String(v)];
        }
    }
    function extractKeys(instance, type) {
        var Comp = instance.type;
        if (isFunction(Comp)) {
            return;
        }
        var extracted = {};
        for (var key in instance.ctx) {
            if (isKeyOfType(Comp, key, type)) {
                extracted[key] = instance.ctx[key];
            }
        }
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        var opts = Comp[type];
        if (isArray(opts) && opts.includes(key) || isObject(opts) && key in opts) {
            return true;
        }
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) {
            return true;
        }
        if (Comp.mixins && Comp.mixins.some(function (m) { return isKeyOfType(m, key, type); })) {
            return true;
        }
    }
    function genRefFlag(v) {
        if (isShallow(v)) {
            return "ShallowRef";
        }
        if (v.effect) {
            return "ComputedRef";
        }
        return "Ref";
    }
    if (window.devtoolsFormatters) {
        window.devtoolsFormatters.push(formatter);
    }
    else {
        window.devtoolsFormatters = [formatter];
    }
}
function withMemo(memo, render, cache, index) {
    var cached = cache[index];
    if (cached && isMemoSame(cached, memo)) {
        return cached;
    }
    var ret = render();
    ret.memo = memo.slice();
    return cache[index] = ret;
}
function isMemoSame(cached, memo) {
    var prev = cached.memo;
    if (prev.length != memo.length) {
        return false;
    }
    for (var i = 0; i < prev.length; i++) {
        if (hasChanged(prev[i], memo[i])) {
            return false;
        }
    }
    if (isBlockTreeEnabled > 0 && currentBlock) {
        currentBlock.push(cached);
    }
    return true;
}
var version = "3.4.26";
var warn = !!(process.env.NODE_ENV !== "production") ? warn$1 : NOOP;
var ErrorTypeStrings = ErrorTypeStrings$1;
var devtools = !!(process.env.NODE_ENV !== "production") || true ? devtools$1 : void 0;
var setDevtoolsHook = !!(process.env.NODE_ENV !== "production") || true ? setDevtoolsHook$1 : NOOP;
var _ssrUtils = {
    createComponentInstance: createComponentInstance,
    setupComponent: setupComponent,
    renderComponentRoot: renderComponentRoot,
    setCurrentRenderingInstance: setCurrentRenderingInstance,
    isVNode: isVNode,
    normalizeVNode: normalizeVNode
};
var ssrUtils = _ssrUtils;
var resolveFilter = null;
var compatUtils = null;
var DeprecationTypes = null;
export { BaseTransition, BaseTransitionPropsValidators, Comment, DeprecationTypes, ErrorCodes, ErrorTypeStrings, Fragment, KeepAlive, Static, Suspense, Teleport, Text, assertNumber, callWithAsyncErrorHandling, callWithErrorHandling, cloneVNode, compatUtils, computed, createBlock, createCommentVNode, createElementBlock, createBaseVNode as createElementVNode, createHydrationRenderer, createPropsRestProxy, createRenderer, createSlots, createStaticVNode, createTextVNode, createVNode, defineAsyncComponent, defineComponent, defineEmits, defineExpose, defineModel, defineOptions, defineProps, defineSlots, devtools, getCurrentInstance, getTransitionRawChildren, guardReactiveProps, h, handleError, hasInjectionContext, initCustomFormatter, inject, isMemoSame, isRuntimeOnly, isVNode, mergeDefaults, mergeModels, mergeProps, nextTick, onActivated, onBeforeMount, onBeforeUnmount, onBeforeUpdate, onDeactivated, onErrorCaptured, onMounted, onRenderTracked, onRenderTriggered, onServerPrefetch, onUnmounted, onUpdated, openBlock, popScopeId, provide, pushScopeId, queuePostFlushCb, registerRuntimeCompiler, renderList, renderSlot, resolveComponent, resolveDirective, resolveDynamicComponent, resolveFilter, resolveTransitionHooks, setBlockTracking, setDevtoolsHook, setTransitionHooks, ssrContextKey, ssrUtils, toHandlers, transformVNodeArgs, useAttrs, useModel, useSSRContext, useSlots, useTransitionState, version, warn, watch, watchEffect, watchPostEffect, watchSyncEffect, withAsyncContext, withCtx, withDefaults, withDirectives, withMemo, withScopeId };
